import { $ as TooManyEmbeddingValuesForCallError, A as normalizeHeaders, C as getRuntimeEnvironmentUserAgent, E as jsonSchema, F as safeParseJSON, G as InvalidArgumentError$1, H as AISDKError, I as safeValidateTypes, J as JSONParseError, K as InvalidPromptError, L as tool, N as readResponseWithSizeLimit, O as lazyValidator, P as resolve, Q as NoSuchModelError, R as validateTypes, T as isUrlSupported, U as APICallError, V as zodSchema, W as EmptyResponseBodyError, X as LoadSettingError, Y as LoadAPIKeyError, Z as NoContentGeneratedError, _ as dynamicTool, a as asSchema, b as generateId, et as TypeValidationError, f as createIdGenerator, g as delay, i as EMBEDDING_MODEL_MAX_INPUT_BYTES_PER_CALL, it as isJSONObject, j as parseJsonEventStream, l as convertBase64ToUint8Array, n as DelayedPromise, nt as getErrorMessage, o as cancelResponseBody, q as InvalidResponseDataError, r as DownloadError$1, rt as isJSONArray, t as DEFAULT_MAX_DOWNLOAD_SIZE, tt as UnsupportedFunctionalityError, u as convertUint8ArrayToBase64, v as executeTool, w as isAbortError, x as getErrorMessage$1, y as fetchWithValidatedRedirects, z as withUserAgentSuffix } from "./dist-OCi48HWi.js";
import { i as gateway, n as GatewayError, r as createGatewayProvider, t as GatewayAuthenticationError } from "./dist-Bcz48aZq.js";
import { z } from "zod/v4";
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/platform/node/globalThis.js
/** only globals that common to node and browsers are allowed */
var _globalThis = typeof globalThis === "object" ? globalThis : global;
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/version.js
var VERSION$1 = "1.9.0";
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/internal/semver.js
var re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
/**
* Create a function to test an API version to see if it is compatible with the provided ownVersion.
*
* The returned function has the following semantics:
* - Exact match is always compatible
* - Major versions must match exactly
*    - 1.x package cannot use global 2.x package
*    - 2.x package cannot use global 1.x package
* - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
*    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
*    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
* - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
* - Patch and build tag differences are not considered at this time
*
* @param ownVersion version which should be checked against
*/
function _makeCompatibilityCheck(ownVersion) {
	var acceptedVersions = /* @__PURE__ */ new Set([ownVersion]);
	var rejectedVersions = /* @__PURE__ */ new Set();
	var myVersionMatch = ownVersion.match(re);
	if (!myVersionMatch) return function() {
		return false;
	};
	var ownVersionParsed = {
		major: +myVersionMatch[1],
		minor: +myVersionMatch[2],
		patch: +myVersionMatch[3],
		prerelease: myVersionMatch[4]
	};
	if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
		return globalVersion === ownVersion;
	};
	function _reject(v) {
		rejectedVersions.add(v);
		return false;
	}
	function _accept(v) {
		acceptedVersions.add(v);
		return true;
	}
	return function isCompatible(globalVersion) {
		if (acceptedVersions.has(globalVersion)) return true;
		if (rejectedVersions.has(globalVersion)) return false;
		var globalVersionMatch = globalVersion.match(re);
		if (!globalVersionMatch) return _reject(globalVersion);
		var globalVersionParsed = {
			major: +globalVersionMatch[1],
			minor: +globalVersionMatch[2],
			patch: +globalVersionMatch[3],
			prerelease: globalVersionMatch[4]
		};
		if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
		if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
		if (ownVersionParsed.major === 0) {
			if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
			return _reject(globalVersion);
		}
		if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
		return _reject(globalVersion);
	};
}
/**
* Test an API version to see if it is compatible with this API.
*
* - Exact match is always compatible
* - Major versions must match exactly
*    - 1.x package cannot use global 2.x package
*    - 2.x package cannot use global 1.x package
* - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
*    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
*    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
* - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
* - Patch and build tag differences are not considered at this time
*
* @param version version of the API requesting an instance of the global API
*/
var isCompatible = _makeCompatibilityCheck(VERSION$1);
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/internal/global-utils.js
var major = VERSION$1.split(".")[0];
var GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + major);
var _global = _globalThis;
function registerGlobal(type, instance, diag, allowOverride) {
	var _a;
	if (allowOverride === void 0) allowOverride = false;
	var api = _global[GLOBAL_OPENTELEMETRY_API_KEY] = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : { version: VERSION$1 };
	if (!allowOverride && api[type]) {
		var err = /* @__PURE__ */ new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
		diag.error(err.stack || err.message);
		return false;
	}
	if (api.version !== "1.9.0") {
		var err = /* @__PURE__ */ new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + VERSION$1);
		diag.error(err.stack || err.message);
		return false;
	}
	api[type] = instance;
	diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + VERSION$1 + ".");
	return true;
}
function getGlobal(type) {
	var _a, _b;
	var globalVersion = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
	if (!globalVersion || !isCompatible(globalVersion)) return;
	return (_b = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function unregisterGlobal(type, diag) {
	diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + VERSION$1 + ".");
	var api = _global[GLOBAL_OPENTELEMETRY_API_KEY];
	if (api) delete api[type];
}
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/diag/ComponentLogger.js
var __read$3 = function(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
};
var __spreadArray$3 = function(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
};
/**
* Component Logger which is meant to be used as part of any component which
* will add automatically additional namespace in front of the log message.
* It will then forward all message to global diag logger
* @example
* const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
* cLogger.debug('test');
* // @opentelemetry/instrumentation-http test
*/
var DiagComponentLogger = function() {
	function DiagComponentLogger(props) {
		this._namespace = props.namespace || "DiagComponentLogger";
	}
	DiagComponentLogger.prototype.debug = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy("debug", this._namespace, args);
	};
	DiagComponentLogger.prototype.error = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy("error", this._namespace, args);
	};
	DiagComponentLogger.prototype.info = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy("info", this._namespace, args);
	};
	DiagComponentLogger.prototype.warn = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy("warn", this._namespace, args);
	};
	DiagComponentLogger.prototype.verbose = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy("verbose", this._namespace, args);
	};
	return DiagComponentLogger;
}();
function logProxy(funcName, namespace, args) {
	var logger = getGlobal("diag");
	if (!logger) return;
	args.unshift(namespace);
	return logger[funcName].apply(logger, __spreadArray$3([], __read$3(args), false));
}
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/diag/types.js
/**
* Defines the available internal logging levels for the diagnostic logger, the numeric values
* of the levels are defined to match the original values from the initial LogLevel to avoid
* compatibility/migration issues for any implementation that assume the numeric ordering.
*/
var DiagLogLevel;
(function(DiagLogLevel) {
	/** Diagnostic Logging level setting to disable all logging (except and forced logs) */
	DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
	/** Identifies an error scenario */
	DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
	/** Identifies a warning scenario */
	DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
	/** General informational log message */
	DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
	/** General debug log message */
	DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
	/**
	* Detailed trace level logging should only be used for development, should only be set
	* in a development environment.
	*/
	DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
	/** Used to set the logging level to include all logging */
	DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})(DiagLogLevel || (DiagLogLevel = {}));
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/diag/internal/logLevelLogger.js
function createLogLevelDiagLogger(maxLevel, logger) {
	if (maxLevel < DiagLogLevel.NONE) maxLevel = DiagLogLevel.NONE;
	else if (maxLevel > DiagLogLevel.ALL) maxLevel = DiagLogLevel.ALL;
	logger = logger || {};
	function _filterFunc(funcName, theLevel) {
		var theFunc = logger[funcName];
		if (typeof theFunc === "function" && maxLevel >= theLevel) return theFunc.bind(logger);
		return function() {};
	}
	return {
		error: _filterFunc("error", DiagLogLevel.ERROR),
		warn: _filterFunc("warn", DiagLogLevel.WARN),
		info: _filterFunc("info", DiagLogLevel.INFO),
		debug: _filterFunc("debug", DiagLogLevel.DEBUG),
		verbose: _filterFunc("verbose", DiagLogLevel.VERBOSE)
	};
}
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/api/diag.js
var __read$2 = function(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
};
var __spreadArray$2 = function(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
};
var API_NAME$2 = "diag";
/**
* Singleton object which represents the entry point to the OpenTelemetry internal
* diagnostic API
*/
var DiagAPI = function() {
	/**
	* Private internal constructor
	* @private
	*/
	function DiagAPI() {
		function _logProxy(funcName) {
			return function() {
				var args = [];
				for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
				var logger = getGlobal("diag");
				if (!logger) return;
				return logger[funcName].apply(logger, __spreadArray$2([], __read$2(args), false));
			};
		}
		var self = this;
		var setLogger = function(logger, optionsOrLogLevel) {
			var _a, _b, _c;
			if (optionsOrLogLevel === void 0) optionsOrLogLevel = { logLevel: DiagLogLevel.INFO };
			if (logger === self) {
				var err = /* @__PURE__ */ new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
				self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
				return false;
			}
			if (typeof optionsOrLogLevel === "number") optionsOrLogLevel = { logLevel: optionsOrLogLevel };
			var oldLogger = getGlobal("diag");
			var newLogger = createLogLevelDiagLogger((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : DiagLogLevel.INFO, logger);
			if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
				var stack = (_c = (/* @__PURE__ */ new Error()).stack) !== null && _c !== void 0 ? _c : "<failed to generate stacktrace>";
				oldLogger.warn("Current logger will be overwritten from " + stack);
				newLogger.warn("Current logger will overwrite one already registered from " + stack);
			}
			return registerGlobal("diag", newLogger, self, true);
		};
		self.setLogger = setLogger;
		self.disable = function() {
			unregisterGlobal(API_NAME$2, self);
		};
		self.createComponentLogger = function(options) {
			return new DiagComponentLogger(options);
		};
		self.verbose = _logProxy("verbose");
		self.debug = _logProxy("debug");
		self.info = _logProxy("info");
		self.warn = _logProxy("warn");
		self.error = _logProxy("error");
	}
	/** Get the singleton instance of the DiagAPI API */
	DiagAPI.instance = function() {
		if (!this._instance) this._instance = new DiagAPI();
		return this._instance;
	};
	return DiagAPI;
}();
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/context/context.js
/** Get a key to uniquely identify a context value */
function createContextKey(description) {
	return Symbol.for(description);
}
/** The root context is used as the default parent context when there is no active context */
var ROOT_CONTEXT = new (function() {
	/**
	* Construct a new context which inherits values from an optional parent context.
	*
	* @param parentContext a context from which to inherit values
	*/
	function BaseContext(parentContext) {
		var self = this;
		self._currentContext = parentContext ? new Map(parentContext) : /* @__PURE__ */ new Map();
		self.getValue = function(key) {
			return self._currentContext.get(key);
		};
		self.setValue = function(key, value) {
			var context = new BaseContext(self._currentContext);
			context._currentContext.set(key, value);
			return context;
		};
		self.deleteValue = function(key) {
			var context = new BaseContext(self._currentContext);
			context._currentContext.delete(key);
			return context;
		};
	}
	return BaseContext;
}())();
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/context/NoopContextManager.js
var __read$1 = function(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
};
var __spreadArray$1 = function(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
};
var NoopContextManager = function() {
	function NoopContextManager() {}
	NoopContextManager.prototype.active = function() {
		return ROOT_CONTEXT;
	};
	NoopContextManager.prototype.with = function(_context, fn, thisArg) {
		var args = [];
		for (var _i = 3; _i < arguments.length; _i++) args[_i - 3] = arguments[_i];
		return fn.call.apply(fn, __spreadArray$1([thisArg], __read$1(args), false));
	};
	NoopContextManager.prototype.bind = function(_context, target) {
		return target;
	};
	NoopContextManager.prototype.enable = function() {
		return this;
	};
	NoopContextManager.prototype.disable = function() {
		return this;
	};
	return NoopContextManager;
}();
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/api/context.js
var __read = function(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
};
var __spreadArray = function(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
};
var API_NAME$1 = "context";
var NOOP_CONTEXT_MANAGER = new NoopContextManager();
/**
* Singleton object which represents the entry point to the OpenTelemetry Context API
*/
var ContextAPI = function() {
	/** Empty private constructor prevents end users from constructing a new instance of the API */
	function ContextAPI() {}
	/** Get the singleton instance of the Context API */
	ContextAPI.getInstance = function() {
		if (!this._instance) this._instance = new ContextAPI();
		return this._instance;
	};
	/**
	* Set the current context manager.
	*
	* @returns true if the context manager was successfully registered, else false
	*/
	ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
		return registerGlobal(API_NAME$1, contextManager, DiagAPI.instance());
	};
	/**
	* Get the currently active context
	*/
	ContextAPI.prototype.active = function() {
		return this._getContextManager().active();
	};
	/**
	* Execute a function with an active context
	*
	* @param context context to be active during function execution
	* @param fn function to execute in a context
	* @param thisArg optional receiver to be used for calling fn
	* @param args optional arguments forwarded to fn
	*/
	ContextAPI.prototype.with = function(context, fn, thisArg) {
		var _a;
		var args = [];
		for (var _i = 3; _i < arguments.length; _i++) args[_i - 3] = arguments[_i];
		return (_a = this._getContextManager()).with.apply(_a, __spreadArray([
			context,
			fn,
			thisArg
		], __read(args), false));
	};
	/**
	* Bind a context to a target function or event emitter
	*
	* @param context context to bind to the event emitter or function. Defaults to the currently active context
	* @param target function or event emitter to bind
	*/
	ContextAPI.prototype.bind = function(context, target) {
		return this._getContextManager().bind(context, target);
	};
	ContextAPI.prototype._getContextManager = function() {
		return getGlobal(API_NAME$1) || NOOP_CONTEXT_MANAGER;
	};
	/** Disable and remove the global context manager */
	ContextAPI.prototype.disable = function() {
		this._getContextManager().disable();
		unregisterGlobal(API_NAME$1, DiagAPI.instance());
	};
	return ContextAPI;
}();
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/trace/trace_flags.js
var TraceFlags;
(function(TraceFlags) {
	/** Represents no flag set. */
	TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
	/** Bit to represent whether trace is sampled in trace flags. */
	TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})(TraceFlags || (TraceFlags = {}));
var INVALID_SPAN_CONTEXT = {
	traceId: "00000000000000000000000000000000",
	spanId: "0000000000000000",
	traceFlags: TraceFlags.NONE
};
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/trace/NonRecordingSpan.js
/**
* The NonRecordingSpan is the default {@link Span} that is used when no Span
* implementation is available. All operations are no-op including context
* propagation.
*/
var NonRecordingSpan = function() {
	function NonRecordingSpan(_spanContext) {
		if (_spanContext === void 0) _spanContext = INVALID_SPAN_CONTEXT;
		this._spanContext = _spanContext;
	}
	NonRecordingSpan.prototype.spanContext = function() {
		return this._spanContext;
	};
	NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
		return this;
	};
	NonRecordingSpan.prototype.setAttributes = function(_attributes) {
		return this;
	};
	NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
		return this;
	};
	NonRecordingSpan.prototype.addLink = function(_link) {
		return this;
	};
	NonRecordingSpan.prototype.addLinks = function(_links) {
		return this;
	};
	NonRecordingSpan.prototype.setStatus = function(_status) {
		return this;
	};
	NonRecordingSpan.prototype.updateName = function(_name) {
		return this;
	};
	NonRecordingSpan.prototype.end = function(_endTime) {};
	NonRecordingSpan.prototype.isRecording = function() {
		return false;
	};
	NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
	return NonRecordingSpan;
}();
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/trace/context-utils.js
/**
* span key
*/
var SPAN_KEY = createContextKey("OpenTelemetry Context Key SPAN");
/**
* Return the span if one exists
*
* @param context context to get span from
*/
function getSpan(context) {
	return context.getValue(SPAN_KEY) || void 0;
}
/**
* Gets the span from the current context, if one exists.
*/
function getActiveSpan() {
	return getSpan(ContextAPI.getInstance().active());
}
/**
* Set the span on a context
*
* @param context context to use as parent
* @param span span to set active
*/
function setSpan(context, span) {
	return context.setValue(SPAN_KEY, span);
}
/**
* Remove current span stored in the context
*
* @param context context to delete span from
*/
function deleteSpan(context) {
	return context.deleteValue(SPAN_KEY);
}
/**
* Wrap span context in a NoopSpan and set as span in a new
* context
*
* @param context context to set active span on
* @param spanContext span context to be wrapped
*/
function setSpanContext(context, spanContext) {
	return setSpan(context, new NonRecordingSpan(spanContext));
}
/**
* Get the span context of the span if it exists.
*
* @param context context to get values from
*/
function getSpanContext(context) {
	var _a;
	return (_a = getSpan(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/trace/spancontext-utils.js
var VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function isValidTraceId(traceId) {
	return VALID_TRACEID_REGEX.test(traceId) && traceId !== "00000000000000000000000000000000";
}
function isValidSpanId(spanId) {
	return VALID_SPANID_REGEX.test(spanId) && spanId !== "0000000000000000";
}
/**
* Returns true if this {@link SpanContext} is valid.
* @return true if this {@link SpanContext} is valid.
*/
function isSpanContextValid(spanContext) {
	return isValidTraceId(spanContext.traceId) && isValidSpanId(spanContext.spanId);
}
/**
* Wrap the given {@link SpanContext} in a new non-recording {@link Span}
*
* @param spanContext span context to be wrapped
* @returns a new non-recording {@link Span} with the provided context
*/
function wrapSpanContext(spanContext) {
	return new NonRecordingSpan(spanContext);
}
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/trace/NoopTracer.js
var contextApi = ContextAPI.getInstance();
/**
* No-op implementations of {@link Tracer}.
*/
var NoopTracer = function() {
	function NoopTracer() {}
	NoopTracer.prototype.startSpan = function(name, options, context) {
		if (context === void 0) context = contextApi.active();
		if (Boolean(options === null || options === void 0 ? void 0 : options.root)) return new NonRecordingSpan();
		var parentFromContext = context && getSpanContext(context);
		if (isSpanContext(parentFromContext) && isSpanContextValid(parentFromContext)) return new NonRecordingSpan(parentFromContext);
		else return new NonRecordingSpan();
	};
	NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
		var opts;
		var ctx;
		var fn;
		if (arguments.length < 2) return;
		else if (arguments.length === 2) fn = arg2;
		else if (arguments.length === 3) {
			opts = arg2;
			fn = arg3;
		} else {
			opts = arg2;
			ctx = arg3;
			fn = arg4;
		}
		var parentContext = ctx !== null && ctx !== void 0 ? ctx : contextApi.active();
		var span = this.startSpan(name, opts, parentContext);
		var contextWithSpanSet = setSpan(parentContext, span);
		return contextApi.with(contextWithSpanSet, fn, void 0, span);
	};
	return NoopTracer;
}();
function isSpanContext(spanContext) {
	return typeof spanContext === "object" && typeof spanContext["spanId"] === "string" && typeof spanContext["traceId"] === "string" && typeof spanContext["traceFlags"] === "number";
}
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/trace/ProxyTracer.js
var NOOP_TRACER = new NoopTracer();
/**
* Proxy tracer provided by the proxy tracer provider
*/
var ProxyTracer = function() {
	function ProxyTracer(_provider, name, version, options) {
		this._provider = _provider;
		this.name = name;
		this.version = version;
		this.options = options;
	}
	ProxyTracer.prototype.startSpan = function(name, options, context) {
		return this._getTracer().startSpan(name, options, context);
	};
	ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
		var tracer = this._getTracer();
		return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
	};
	/**
	* Try to get a tracer from the proxy tracer provider.
	* If the proxy tracer provider has no delegate, return a noop tracer.
	*/
	ProxyTracer.prototype._getTracer = function() {
		if (this._delegate) return this._delegate;
		var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
		if (!tracer) return NOOP_TRACER;
		this._delegate = tracer;
		return this._delegate;
	};
	return ProxyTracer;
}();
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/trace/ProxyTracerProvider.js
var NOOP_TRACER_PROVIDER = new (function() {
	function NoopTracerProvider() {}
	NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
		return new NoopTracer();
	};
	return NoopTracerProvider;
}())();
/**
* Tracer provider which provides {@link ProxyTracer}s.
*
* Before a delegate is set, tracers provided are NoOp.
*   When a delegate is set, traces are provided from the delegate.
*   When a delegate is set after tracers have already been provided,
*   all tracers already provided will use the provided delegate implementation.
*/
var ProxyTracerProvider = function() {
	function ProxyTracerProvider() {}
	/**
	* Get a {@link ProxyTracer}
	*/
	ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
		var _a;
		return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new ProxyTracer(this, name, version, options);
	};
	ProxyTracerProvider.prototype.getDelegate = function() {
		var _a;
		return (_a = this._delegate) !== null && _a !== void 0 ? _a : NOOP_TRACER_PROVIDER;
	};
	/**
	* Set the delegate tracer provider
	*/
	ProxyTracerProvider.prototype.setDelegate = function(delegate) {
		this._delegate = delegate;
	};
	ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
		var _a;
		return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
	};
	return ProxyTracerProvider;
}();
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/trace/status.js
/**
* An enumeration of status codes.
*/
var SpanStatusCode;
(function(SpanStatusCode) {
	/**
	* The default status.
	*/
	SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
	/**
	* The operation has been validated by an Application developer or
	* Operator to have completed successfully.
	*/
	SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
	/**
	* The operation contains an error.
	*/
	SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
})(SpanStatusCode || (SpanStatusCode = {}));
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/api/trace.js
var API_NAME = "trace";
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@opentelemetry/api/1.9.0/ee469078ed078052a7533b2805abc7686d72155c80f67e8929d9d1ae6c630f05/node_modules/@opentelemetry/api/build/esm/trace-api.js
/** Entrypoint for trace API */
var trace = function() {
	/** Empty private constructor prevents end users from constructing a new instance of the API */
	function TraceAPI() {
		this._proxyTracerProvider = new ProxyTracerProvider();
		this.wrapSpanContext = wrapSpanContext;
		this.isSpanContextValid = isSpanContextValid;
		this.deleteSpan = deleteSpan;
		this.getSpan = getSpan;
		this.getActiveSpan = getActiveSpan;
		this.getSpanContext = getSpanContext;
		this.setSpan = setSpan;
		this.setSpanContext = setSpanContext;
	}
	/** Get the singleton instance of the Trace API */
	TraceAPI.getInstance = function() {
		if (!this._instance) this._instance = new TraceAPI();
		return this._instance;
	};
	/**
	* Set the current global tracer.
	*
	* @returns true if the tracer provider was successfully registered, else false
	*/
	TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
		var success = registerGlobal(API_NAME, this._proxyTracerProvider, DiagAPI.instance());
		if (success) this._proxyTracerProvider.setDelegate(provider);
		return success;
	};
	/**
	* Returns the global tracer provider.
	*/
	TraceAPI.prototype.getTracerProvider = function() {
		return getGlobal(API_NAME) || this._proxyTracerProvider;
	};
	/**
	* Returns a tracer from the global tracer provider.
	*/
	TraceAPI.prototype.getTracer = function(name, version) {
		return this.getTracerProvider().getTracer(name, version);
	};
	/** Remove the global tracer provider */
	TraceAPI.prototype.disable = function() {
		unregisterGlobal(API_NAME, DiagAPI.instance());
		this._proxyTracerProvider = new ProxyTracerProvider();
	};
	return TraceAPI;
}().getInstance();
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@/ai/5.0.277/29baf09a3fb3418d0bb2392d80c4174b2208d7cd6fec72bb6b4b3d27f449deda/node_modules/ai/dist/index.mjs
var __defProp = Object.defineProperty;
var __export = (target, all) => {
	for (var name16 in all) __defProp(target, name16, {
		get: all[name16],
		enumerable: true
	});
};
var name = "AI_NoOutputSpecifiedError";
var marker = `vercel.ai.error.${name}`;
var symbol = Symbol.for(marker);
var _a;
var NoOutputSpecifiedError = class extends AISDKError {
	constructor({ message = "No output specified." } = {}) {
		super({
			name,
			message
		});
		this[_a] = true;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker);
	}
};
_a = symbol;
function formatWarning(warning) {
	const prefix = "AI SDK Warning:";
	switch (warning.type) {
		case "unsupported-setting": {
			let message = `${prefix} The "${warning.setting}" setting is not supported by this model`;
			if (warning.details) message += ` - ${warning.details}`;
			return message;
		}
		case "unsupported-tool": {
			let message = `${prefix} The tool "${"name" in warning.tool ? warning.tool.name : "unknown tool"}" is not supported by this model`;
			if (warning.details) message += ` - ${warning.details}`;
			return message;
		}
		case "other": return `${prefix} ${warning.message}`;
		default: return `${prefix} ${JSON.stringify(warning, null, 2)}`;
	}
}
var FIRST_WARNING_INFO_MESSAGE = "AI SDK Warning System: To turn off warning logging, set the AI_SDK_LOG_WARNINGS global to false.";
var hasLoggedBefore = false;
function emitWarning({ message, type }) {
	if (typeof process !== "undefined" && typeof process.emitWarning === "function") process.emitWarning(message, { type });
	else console.warn(message);
}
var logWarnings = (warnings) => {
	if (warnings.length === 0) return;
	const logger = globalThis.AI_SDK_LOG_WARNINGS;
	if (logger === false) return;
	if (typeof logger === "function") {
		logger(warnings);
		return;
	}
	if (!hasLoggedBefore) {
		hasLoggedBefore = true;
		emitWarning({
			message: FIRST_WARNING_INFO_MESSAGE,
			type: "Warning"
		});
	}
	for (const warning of warnings) emitWarning({
		message: formatWarning(warning),
		type: "Warning"
	});
};
var name2 = "AI_InvalidArgumentError";
var marker2 = `vercel.ai.error.${name2}`;
var symbol2 = Symbol.for(marker2);
var _a2;
var InvalidArgumentError = class extends AISDKError {
	constructor({ parameter, value, message }) {
		super({
			name: name2,
			message: `Invalid argument for parameter ${parameter}: ${message}`
		});
		this[_a2] = true;
		this.parameter = parameter;
		this.value = value;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker2);
	}
};
_a2 = symbol2;
var name3 = "AI_InvalidStreamPartError";
var marker3 = `vercel.ai.error.${name3}`;
var symbol3 = Symbol.for(marker3);
var _a3;
var InvalidStreamPartError = class extends AISDKError {
	constructor({ chunk, message }) {
		super({
			name: name3,
			message
		});
		this[_a3] = true;
		this.chunk = chunk;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker3);
	}
};
_a3 = symbol3;
var name4 = "AI_InvalidToolInputError";
var marker4 = `vercel.ai.error.${name4}`;
var symbol4 = Symbol.for(marker4);
var _a4;
var InvalidToolInputError = class extends AISDKError {
	constructor({ toolInput, toolName, cause, message = `Invalid input for tool ${toolName}: ${getErrorMessage(cause)}` }) {
		super({
			name: name4,
			message,
			cause
		});
		this[_a4] = true;
		this.toolInput = toolInput;
		this.toolName = toolName;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker4);
	}
};
_a4 = symbol4;
var name5 = "AI_NoImageGeneratedError";
var marker5 = `vercel.ai.error.${name5}`;
var symbol5 = Symbol.for(marker5);
var _a5;
var NoImageGeneratedError = class extends AISDKError {
	constructor({ message = "No image generated.", cause, responses }) {
		super({
			name: name5,
			message,
			cause
		});
		this[_a5] = true;
		this.responses = responses;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker5);
	}
};
_a5 = symbol5;
var name6 = "AI_NoObjectGeneratedError";
var marker6 = `vercel.ai.error.${name6}`;
var symbol6 = Symbol.for(marker6);
var _a6;
var NoObjectGeneratedError = class extends AISDKError {
	constructor({ message = "No object generated.", cause, text: text2, response, usage, finishReason }) {
		super({
			name: name6,
			message,
			cause
		});
		this[_a6] = true;
		this.text = text2;
		this.response = response;
		this.usage = usage;
		this.finishReason = finishReason;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker6);
	}
};
_a6 = symbol6;
var name7 = "AI_NoOutputGeneratedError";
var marker7 = `vercel.ai.error.${name7}`;
var symbol7 = Symbol.for(marker7);
var _a7;
var NoOutputGeneratedError = class extends AISDKError {
	constructor({ message = "No output generated.", cause } = {}) {
		super({
			name: name7,
			message,
			cause
		});
		this[_a7] = true;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker7);
	}
};
_a7 = symbol7;
var NoSpeechGeneratedError = class extends AISDKError {
	constructor(options) {
		super({
			name: "AI_NoSpeechGeneratedError",
			message: "No speech audio generated."
		});
		this.responses = options.responses;
	}
};
var name8 = "AI_NoSuchToolError";
var marker8 = `vercel.ai.error.${name8}`;
var symbol8 = Symbol.for(marker8);
var _a8;
var NoSuchToolError = class extends AISDKError {
	constructor({ toolName, availableTools = void 0, message = `Model tried to call unavailable tool '${toolName}'. ${availableTools === void 0 ? "No tools are available." : `Available tools: ${availableTools.join(", ")}.`}` }) {
		super({
			name: name8,
			message
		});
		this[_a8] = true;
		this.toolName = toolName;
		this.availableTools = availableTools;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker8);
	}
};
_a8 = symbol8;
var name9 = "AI_ToolCallRepairError";
var marker9 = `vercel.ai.error.${name9}`;
var symbol9 = Symbol.for(marker9);
var _a9;
var ToolCallRepairError = class extends AISDKError {
	constructor({ cause, originalError, message = `Error repairing tool call: ${getErrorMessage(cause)}` }) {
		super({
			name: name9,
			message,
			cause
		});
		this[_a9] = true;
		this.originalError = originalError;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker9);
	}
};
_a9 = symbol9;
var UnsupportedModelVersionError = class extends AISDKError {
	constructor(options) {
		super({
			name: "AI_UnsupportedModelVersionError",
			message: `Unsupported model version ${options.version} for provider "${options.provider}" and model "${options.modelId}". AI SDK 5 only supports models that implement specification version "v2".`
		});
		this.version = options.version;
		this.provider = options.provider;
		this.modelId = options.modelId;
	}
};
var name10 = "AI_InvalidDataContentError";
var marker10 = `vercel.ai.error.${name10}`;
var symbol10 = Symbol.for(marker10);
var _a10;
var InvalidDataContentError = class extends AISDKError {
	constructor({ content, cause, message = `Invalid data content. Expected a base64 string, Uint8Array, ArrayBuffer, or Buffer, but got ${typeof content}.` }) {
		super({
			name: name10,
			message,
			cause
		});
		this[_a10] = true;
		this.content = content;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker10);
	}
};
_a10 = symbol10;
var name11 = "AI_InvalidMessageRoleError";
var marker11 = `vercel.ai.error.${name11}`;
var symbol11 = Symbol.for(marker11);
var _a11;
var InvalidMessageRoleError = class extends AISDKError {
	constructor({ role, message = `Invalid message role: '${role}'. Must be one of: "system", "user", "assistant", "tool".` }) {
		super({
			name: name11,
			message
		});
		this[_a11] = true;
		this.role = role;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker11);
	}
};
_a11 = symbol11;
var name12 = "AI_MessageConversionError";
var marker12 = `vercel.ai.error.${name12}`;
var symbol12 = Symbol.for(marker12);
var _a12;
var MessageConversionError = class extends AISDKError {
	constructor({ originalMessage, message }) {
		super({
			name: name12,
			message
		});
		this[_a12] = true;
		this.originalMessage = originalMessage;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker12);
	}
};
_a12 = symbol12;
var name13 = "AI_DownloadError";
var marker13 = `vercel.ai.error.${name13}`;
var symbol13 = Symbol.for(marker13);
var _a13;
var DownloadError = class extends AISDKError {
	constructor({ url, statusCode, statusText, cause, message = cause == null ? `Failed to download ${url}: ${statusCode} ${statusText}` : `Failed to download ${url}: ${cause}` }) {
		super({
			name: name13,
			message,
			cause
		});
		this[_a13] = true;
		this.url = url;
		this.statusCode = statusCode;
		this.statusText = statusText;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker13);
	}
};
_a13 = symbol13;
var name14 = "AI_RetryError";
var marker14 = `vercel.ai.error.${name14}`;
var symbol14 = Symbol.for(marker14);
var _a14;
var RetryError = class extends AISDKError {
	constructor({ message, reason, errors }) {
		super({
			name: name14,
			message
		});
		this[_a14] = true;
		this.reason = reason;
		this.errors = errors;
		this.lastError = errors[errors.length - 1];
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker14);
	}
};
_a14 = symbol14;
function resolveLanguageModel(model) {
	if (typeof model !== "string") {
		if (model.specificationVersion !== "v2") throw new UnsupportedModelVersionError({
			version: model.specificationVersion,
			provider: model.provider,
			modelId: model.modelId
		});
		return model;
	}
	return getGlobalProvider().languageModel(model);
}
function resolveEmbeddingModel(model) {
	if (typeof model !== "string") {
		if (model.specificationVersion !== "v2") throw new UnsupportedModelVersionError({
			version: model.specificationVersion,
			provider: model.provider,
			modelId: model.modelId
		});
		return model;
	}
	return getGlobalProvider().textEmbeddingModel(model);
}
function resolveImageModel(model) {
	if (typeof model !== "string") {
		if (model.specificationVersion !== "v2") throw new UnsupportedModelVersionError({
			version: model.specificationVersion,
			provider: model.provider,
			modelId: model.modelId
		});
		return model;
	}
	return getGlobalProvider().imageModel(model);
}
function getGlobalProvider() {
	var _a16;
	return (_a16 = globalThis.AI_SDK_DEFAULT_PROVIDER) != null ? _a16 : gateway;
}
var imageMediaTypeSignatures = [
	{
		mediaType: "image/gif",
		bytesPrefix: [
			71,
			73,
			70
		]
	},
	{
		mediaType: "image/png",
		bytesPrefix: [
			137,
			80,
			78,
			71
		]
	},
	{
		mediaType: "image/jpeg",
		bytesPrefix: [255, 216]
	},
	{
		mediaType: "image/webp",
		bytesPrefix: [
			82,
			73,
			70,
			70,
			null,
			null,
			null,
			null,
			87,
			69,
			66,
			80
		]
	},
	{
		mediaType: "image/bmp",
		bytesPrefix: [66, 77]
	},
	{
		mediaType: "image/tiff",
		bytesPrefix: [
			73,
			73,
			42,
			0
		]
	},
	{
		mediaType: "image/tiff",
		bytesPrefix: [
			77,
			77,
			0,
			42
		]
	},
	{
		mediaType: "image/avif",
		bytesPrefix: [
			0,
			0,
			0,
			32,
			102,
			116,
			121,
			112,
			97,
			118,
			105,
			102
		]
	},
	{
		mediaType: "image/heic",
		bytesPrefix: [
			0,
			0,
			0,
			32,
			102,
			116,
			121,
			112,
			104,
			101,
			105,
			99
		]
	}
];
var audioMediaTypeSignatures = [
	{
		mediaType: "audio/mpeg",
		bytesPrefix: [255, 251]
	},
	{
		mediaType: "audio/mpeg",
		bytesPrefix: [255, 250]
	},
	{
		mediaType: "audio/mpeg",
		bytesPrefix: [255, 243]
	},
	{
		mediaType: "audio/mpeg",
		bytesPrefix: [255, 242]
	},
	{
		mediaType: "audio/mpeg",
		bytesPrefix: [255, 227]
	},
	{
		mediaType: "audio/mpeg",
		bytesPrefix: [255, 226]
	},
	{
		mediaType: "audio/wav",
		bytesPrefix: [
			82,
			73,
			70,
			70,
			null,
			null,
			null,
			null,
			87,
			65,
			86,
			69
		]
	},
	{
		mediaType: "audio/ogg",
		bytesPrefix: [
			79,
			103,
			103,
			83
		]
	},
	{
		mediaType: "audio/flac",
		bytesPrefix: [
			102,
			76,
			97,
			67
		]
	},
	{
		mediaType: "audio/aac",
		bytesPrefix: [
			64,
			21,
			0,
			0
		]
	},
	{
		mediaType: "audio/mp4",
		bytesPrefix: [
			0,
			0,
			0,
			null,
			102,
			116,
			121,
			112
		]
	},
	{
		mediaType: "audio/webm",
		bytesPrefix: [
			26,
			69,
			223,
			163
		]
	}
];
var DEFAULT_SNIFF_BYTES = 18;
var ID3_SCAN_BYTES = 131084;
function decodePrefix(data, maxBytes) {
	if (typeof data !== "string") return data.length > maxBytes ? data.subarray(0, maxBytes) : data;
	const maxChars = Math.ceil(maxBytes / 3) * 4;
	const bytes = convertBase64ToUint8Array(data.substring(0, Math.min(data.length, maxChars)));
	return bytes.length > maxBytes ? bytes.subarray(0, maxBytes) : bytes;
}
function hasID3(bytes) {
	return bytes.length > 10 && bytes[0] === 73 && bytes[1] === 68 && bytes[2] === 51;
}
var stripID3 = (bytes) => {
	const id3Size = (bytes[6] & 127) << 21 | (bytes[7] & 127) << 14 | (bytes[8] & 127) << 7 | bytes[9] & 127;
	return bytes.subarray(id3Size + 10);
};
function detectMediaType({ data, signatures }) {
	let bytes = decodePrefix(data, DEFAULT_SNIFF_BYTES);
	if (hasID3(bytes)) bytes = stripID3(decodePrefix(data, ID3_SCAN_BYTES));
	for (const signature of signatures) if (bytes.length >= signature.bytesPrefix.length && signature.bytesPrefix.every((byte, index) => byte === null || bytes[index] === byte)) return signature.mediaType;
}
var VERSION = "5.0.277";
var download = async ({ url, maxBytes, abortSignal }) => {
	var _a16;
	const urlText = url.toString();
	try {
		const headers = withUserAgentSuffix({}, `ai-sdk/${VERSION}`, getRuntimeEnvironmentUserAgent());
		const response = await fetchWithValidatedRedirects({
			url: urlText,
			headers,
			abortSignal
		});
		if (!response.ok) {
			await cancelResponseBody(response);
			throw new DownloadError$1({
				url: urlText,
				statusCode: response.status,
				statusText: response.statusText
			});
		}
		return {
			data: await readResponseWithSizeLimit({
				response,
				url: urlText,
				maxBytes: maxBytes != null ? maxBytes : DEFAULT_MAX_DOWNLOAD_SIZE
			}),
			mediaType: (_a16 = response.headers.get("content-type")) != null ? _a16 : void 0
		};
	} catch (error) {
		if (DownloadError$1.isInstance(error)) throw error;
		throw new DownloadError$1({
			url: urlText,
			cause: error
		});
	}
};
var createDefaultDownloadFunction = (download2 = download) => (requestedDownloads) => Promise.all(requestedDownloads.map(async (requestedDownload) => requestedDownload.isUrlSupportedByModel ? null : download2(requestedDownload)));
function splitDataUrl(dataUrl) {
	try {
		const [header, base64Content] = dataUrl.split(",");
		return {
			mediaType: header.split(";")[0].split(":")[1],
			base64Content
		};
	} catch (error) {
		return {
			mediaType: void 0,
			base64Content: void 0
		};
	}
}
var dataContentSchema = z.union([
	z.string(),
	z.instanceof(Uint8Array),
	z.instanceof(ArrayBuffer),
	z.custom((value) => {
		var _a16, _b;
		return (_b = (_a16 = globalThis.Buffer) == null ? void 0 : _a16.isBuffer(value)) != null ? _b : false;
	}, { message: "Must be a Buffer" })
]);
function convertToLanguageModelV2DataContent(content) {
	if (content instanceof Uint8Array) return {
		data: content,
		mediaType: void 0
	};
	if (content instanceof ArrayBuffer) return {
		data: new Uint8Array(content),
		mediaType: void 0
	};
	if (typeof content === "string") try {
		content = new URL(content);
	} catch (error) {}
	if (content instanceof URL && content.protocol === "data:") {
		const { mediaType: dataUrlMediaType, base64Content } = splitDataUrl(content.toString());
		if (dataUrlMediaType == null || base64Content == null) throw new AISDKError({
			name: "InvalidDataContentError",
			message: `Invalid data URL format in content ${content.toString()}`
		});
		return {
			data: base64Content,
			mediaType: dataUrlMediaType
		};
	}
	return {
		data: content,
		mediaType: void 0
	};
}
function convertDataContentToBase64String(content) {
	if (typeof content === "string") return content;
	if (content instanceof ArrayBuffer) return convertUint8ArrayToBase64(new Uint8Array(content));
	return convertUint8ArrayToBase64(content);
}
function convertDataContentToUint8Array(content) {
	if (content instanceof Uint8Array) return content;
	if (typeof content === "string") try {
		return convertBase64ToUint8Array(content);
	} catch (error) {
		throw new InvalidDataContentError({
			message: "Invalid data content. Content string is not a base64-encoded media.",
			content,
			cause: error
		});
	}
	if (content instanceof ArrayBuffer) return new Uint8Array(content);
	throw new InvalidDataContentError({ content });
}
async function convertToLanguageModelPrompt({ prompt, supportedUrls, download: download2 = createDefaultDownloadFunction() }) {
	const downloadedAssets = await downloadAssets(prompt.messages, download2, supportedUrls);
	return [...prompt.system != null ? [{
		role: "system",
		content: prompt.system
	}] : [], ...prompt.messages.map((message) => convertToLanguageModelMessage({
		message,
		downloadedAssets
	}))];
}
function convertToLanguageModelMessage({ message, downloadedAssets }) {
	const role = message.role;
	switch (role) {
		case "system": return {
			role: "system",
			content: message.content,
			providerOptions: message.providerOptions
		};
		case "user":
			if (typeof message.content === "string") return {
				role: "user",
				content: [{
					type: "text",
					text: message.content
				}],
				providerOptions: message.providerOptions
			};
			return {
				role: "user",
				content: message.content.map((part) => convertPartToLanguageModelPart(part, downloadedAssets)).filter((part) => part.type !== "text" || part.text !== ""),
				providerOptions: message.providerOptions
			};
		case "assistant":
			if (typeof message.content === "string") return {
				role: "assistant",
				content: [{
					type: "text",
					text: message.content
				}],
				providerOptions: message.providerOptions
			};
			return {
				role: "assistant",
				content: message.content.filter((part) => part.type !== "text" || part.text !== "" || part.providerOptions != null).map((part) => {
					const providerOptions = part.providerOptions;
					switch (part.type) {
						case "file": {
							const { data, mediaType } = convertToLanguageModelV2DataContent(part.data);
							const originalUrl = getOriginalUrl(part.data, data);
							return {
								type: "file",
								data,
								filename: part.filename,
								mediaType: mediaType != null ? mediaType : part.mediaType,
								providerOptions,
								...originalUrl != null ? { originalUrl } : {}
							};
						}
						case "reasoning": return {
							type: "reasoning",
							text: part.text,
							providerOptions
						};
						case "text": return {
							type: "text",
							text: part.text,
							providerOptions
						};
						case "tool-call": return {
							type: "tool-call",
							toolCallId: part.toolCallId,
							toolName: part.toolName,
							input: part.input,
							providerExecuted: part.providerExecuted,
							providerOptions
						};
						case "tool-result": return {
							type: "tool-result",
							toolCallId: part.toolCallId,
							toolName: part.toolName,
							output: part.output,
							providerOptions
						};
					}
				}),
				providerOptions: message.providerOptions
			};
		case "tool": return {
			role: "tool",
			content: message.content.map((part) => ({
				type: "tool-result",
				toolCallId: part.toolCallId,
				toolName: part.toolName,
				output: part.output,
				providerOptions: part.providerOptions
			})),
			providerOptions: message.providerOptions
		};
		default: throw new InvalidMessageRoleError({ role });
	}
}
async function downloadAssets(messages, download2, supportedUrls) {
	const plannedDownloads = messages.filter((message) => message.role === "user").map((message) => message.content).filter((content) => Array.isArray(content)).flat().filter((part) => part.type === "image" || part.type === "file").map((part) => {
		var _a16;
		const mediaType = (_a16 = part.mediaType) != null ? _a16 : part.type === "image" ? "image/*" : void 0;
		let data = part.type === "image" ? part.image : part.data;
		if (typeof data === "string") try {
			data = new URL(data);
		} catch (ignored) {}
		return {
			mediaType,
			data
		};
	}).filter((part) => part.data instanceof URL).map((part) => ({
		url: part.data,
		isUrlSupportedByModel: part.mediaType != null && isUrlSupported({
			url: part.data.toString(),
			mediaType: part.mediaType,
			supportedUrls
		})
	}));
	const downloadedFiles = await download2(plannedDownloads);
	return Object.fromEntries(downloadedFiles.map((file, index) => file == null ? null : [plannedDownloads[index].url.toString(), {
		data: file.data,
		mediaType: file.mediaType
	}]).filter((file) => file != null));
}
function getOriginalUrl(originalData, convertedData) {
	return typeof originalData === "string" && convertedData instanceof URL && convertedData.toString() !== originalData ? originalData : void 0;
}
function convertPartToLanguageModelPart(part, downloadedAssets) {
	var _a16;
	if (part.type === "text") return {
		type: "text",
		text: part.text,
		providerOptions: part.providerOptions
	};
	let originalData;
	const type = part.type;
	switch (type) {
		case "image":
			originalData = part.image;
			break;
		case "file":
			originalData = part.data;
			break;
		default: throw new Error(`Unsupported part type: ${type}`);
	}
	const { data: convertedData, mediaType: convertedMediaType } = convertToLanguageModelV2DataContent(originalData);
	let mediaType = convertedMediaType != null ? convertedMediaType : part.mediaType;
	let data = convertedData;
	let originalUrl = getOriginalUrl(originalData, convertedData);
	if (data instanceof URL) {
		const downloadedFile = downloadedAssets[data.toString()];
		if (downloadedFile) {
			data = downloadedFile.data;
			mediaType ??= downloadedFile.mediaType;
			originalUrl = void 0;
		}
	}
	switch (type) {
		case "image":
			if (data instanceof Uint8Array || typeof data === "string") mediaType = (_a16 = detectMediaType({
				data,
				signatures: imageMediaTypeSignatures
			})) != null ? _a16 : mediaType;
			return {
				type: "file",
				mediaType: mediaType != null ? mediaType : "image/*",
				filename: void 0,
				data,
				providerOptions: part.providerOptions,
				...originalUrl != null ? { originalUrl } : {}
			};
		case "file":
			if (mediaType == null) throw new Error(`Media type is missing for file part`);
			return {
				type: "file",
				mediaType,
				filename: part.filename,
				data,
				providerOptions: part.providerOptions,
				...originalUrl != null ? { originalUrl } : {}
			};
	}
}
function prepareCallSettings({ maxOutputTokens, temperature, topP, topK, presencePenalty, frequencyPenalty, seed, stopSequences }) {
	if (maxOutputTokens != null) {
		if (!Number.isInteger(maxOutputTokens)) throw new InvalidArgumentError({
			parameter: "maxOutputTokens",
			value: maxOutputTokens,
			message: "maxOutputTokens must be an integer"
		});
		if (maxOutputTokens < 1) throw new InvalidArgumentError({
			parameter: "maxOutputTokens",
			value: maxOutputTokens,
			message: "maxOutputTokens must be >= 1"
		});
	}
	if (temperature != null) {
		if (typeof temperature !== "number") throw new InvalidArgumentError({
			parameter: "temperature",
			value: temperature,
			message: "temperature must be a number"
		});
	}
	if (topP != null) {
		if (typeof topP !== "number") throw new InvalidArgumentError({
			parameter: "topP",
			value: topP,
			message: "topP must be a number"
		});
	}
	if (topK != null) {
		if (typeof topK !== "number") throw new InvalidArgumentError({
			parameter: "topK",
			value: topK,
			message: "topK must be a number"
		});
	}
	if (presencePenalty != null) {
		if (typeof presencePenalty !== "number") throw new InvalidArgumentError({
			parameter: "presencePenalty",
			value: presencePenalty,
			message: "presencePenalty must be a number"
		});
	}
	if (frequencyPenalty != null) {
		if (typeof frequencyPenalty !== "number") throw new InvalidArgumentError({
			parameter: "frequencyPenalty",
			value: frequencyPenalty,
			message: "frequencyPenalty must be a number"
		});
	}
	if (seed != null) {
		if (!Number.isInteger(seed)) throw new InvalidArgumentError({
			parameter: "seed",
			value: seed,
			message: "seed must be an integer"
		});
	}
	return {
		maxOutputTokens,
		temperature,
		topP,
		topK,
		presencePenalty,
		frequencyPenalty,
		stopSequences,
		seed
	};
}
function isNonEmptyObject(object2) {
	return object2 != null && Object.keys(object2).length > 0;
}
function prepareToolsAndToolChoice({ tools, toolChoice, activeTools }) {
	if (!isNonEmptyObject(tools)) return {
		tools: void 0,
		toolChoice: void 0
	};
	return {
		tools: (activeTools != null ? Object.entries(tools).filter(([name16]) => activeTools.includes(name16)) : Object.entries(tools)).map(([name16, tool2]) => {
			const toolType = tool2.type;
			switch (toolType) {
				case void 0:
				case "dynamic":
				case "function": return {
					type: "function",
					name: name16,
					description: tool2.description,
					inputSchema: asSchema(tool2.inputSchema).jsonSchema,
					providerOptions: tool2.providerOptions
				};
				case "provider-defined": return {
					type: "provider-defined",
					name: name16,
					id: tool2.id,
					args: tool2.args
				};
				default: throw new Error(`Unsupported tool type: ${toolType}`);
			}
		}),
		toolChoice: toolChoice == null ? { type: "auto" } : typeof toolChoice === "string" ? { type: toolChoice } : {
			type: "tool",
			toolName: toolChoice.toolName
		}
	};
}
var jsonValueSchema = z.lazy(() => z.union([
	z.null(),
	z.string(),
	z.number(),
	z.boolean(),
	z.record(z.string(), jsonValueSchema.optional()),
	z.array(jsonValueSchema)
]));
var providerMetadataSchema = z.record(z.string(), z.record(z.string(), jsonValueSchema));
var textPartSchema = z.object({
	type: z.literal("text"),
	text: z.string(),
	providerOptions: providerMetadataSchema.optional()
});
var imagePartSchema = z.object({
	type: z.literal("image"),
	image: z.union([dataContentSchema, z.instanceof(URL)]),
	mediaType: z.string().optional(),
	providerOptions: providerMetadataSchema.optional()
});
var filePartSchema = z.object({
	type: z.literal("file"),
	data: z.union([dataContentSchema, z.instanceof(URL)]),
	filename: z.string().optional(),
	mediaType: z.string(),
	providerOptions: providerMetadataSchema.optional()
});
var reasoningPartSchema = z.object({
	type: z.literal("reasoning"),
	text: z.string(),
	providerOptions: providerMetadataSchema.optional()
});
var toolCallPartSchema = z.object({
	type: z.literal("tool-call"),
	toolCallId: z.string(),
	toolName: z.string(),
	input: z.unknown(),
	providerOptions: providerMetadataSchema.optional(),
	providerExecuted: z.boolean().optional()
});
var outputSchema = z.discriminatedUnion("type", [
	z.object({
		type: z.literal("text"),
		value: z.string()
	}),
	z.object({
		type: z.literal("json"),
		value: jsonValueSchema
	}),
	z.object({
		type: z.literal("error-text"),
		value: z.string()
	}),
	z.object({
		type: z.literal("error-json"),
		value: jsonValueSchema
	}),
	z.object({
		type: z.literal("content"),
		value: z.array(z.union([z.object({
			type: z.literal("text"),
			text: z.string()
		}), z.object({
			type: z.literal("media"),
			data: z.string(),
			mediaType: z.string()
		})]))
	})
]);
var toolResultPartSchema = z.object({
	type: z.literal("tool-result"),
	toolCallId: z.string(),
	toolName: z.string(),
	output: outputSchema,
	providerOptions: providerMetadataSchema.optional()
});
var systemModelMessageSchema = z.object({
	role: z.literal("system"),
	content: z.string(),
	providerOptions: providerMetadataSchema.optional()
});
var coreSystemMessageSchema = systemModelMessageSchema;
var userModelMessageSchema = z.object({
	role: z.literal("user"),
	content: z.union([z.string(), z.array(z.union([
		textPartSchema,
		imagePartSchema,
		filePartSchema
	]))]),
	providerOptions: providerMetadataSchema.optional()
});
var coreUserMessageSchema = userModelMessageSchema;
var assistantModelMessageSchema = z.object({
	role: z.literal("assistant"),
	content: z.union([z.string(), z.array(z.union([
		textPartSchema,
		filePartSchema,
		reasoningPartSchema,
		toolCallPartSchema,
		toolResultPartSchema
	]))]),
	providerOptions: providerMetadataSchema.optional()
});
var coreAssistantMessageSchema = assistantModelMessageSchema;
var toolModelMessageSchema = z.object({
	role: z.literal("tool"),
	content: z.array(toolResultPartSchema),
	providerOptions: providerMetadataSchema.optional()
});
var coreToolMessageSchema = toolModelMessageSchema;
var modelMessageSchema = z.union([
	systemModelMessageSchema,
	userModelMessageSchema,
	assistantModelMessageSchema,
	toolModelMessageSchema
]);
var coreMessageSchema = modelMessageSchema;
async function standardizePrompt({ allowSystemInMessages, system, prompt, messages }) {
	if (prompt == null && messages == null) throw new InvalidPromptError({
		prompt,
		message: "prompt or messages must be defined"
	});
	if (prompt != null && messages != null) throw new InvalidPromptError({
		prompt,
		message: "prompt and messages cannot be defined at the same time"
	});
	if (system != null && typeof system !== "string") throw new InvalidPromptError({
		prompt,
		message: "system must be a string"
	});
	if (prompt != null && typeof prompt === "string") messages = [{
		role: "user",
		content: prompt
	}];
	else if (prompt != null && Array.isArray(prompt)) messages = prompt;
	else if (messages == null) throw new InvalidPromptError({
		prompt,
		message: "prompt or messages must be defined"
	});
	if (messages.length === 0) throw new InvalidPromptError({
		prompt,
		message: "messages must not be empty"
	});
	if (messages.some((message) => message.role === "system")) {
		if (allowSystemInMessages === false) throw new InvalidPromptError({
			prompt,
			message: "System messages are not allowed in the prompt or messages fields. Use the system option instead."
		});
		if (allowSystemInMessages === void 0) console.warn("AI SDK Warning: System messages in the prompt or messages fields can be a security risk because they may enable prompt injection attacks. Use the system option instead when possible. Set allowSystemInMessages to true to suppress this warning, or false to throw an error.");
	}
	const validationResult = await safeValidateTypes({
		value: messages,
		schema: z.array(modelMessageSchema)
	});
	if (!validationResult.success) throw new InvalidPromptError({
		prompt,
		message: "The messages must be a ModelMessage[]. If you have passed a UIMessage[], you can use convertToModelMessages to convert them.",
		cause: validationResult.error
	});
	return {
		messages,
		system
	};
}
function wrapGatewayError(error) {
	if (!GatewayAuthenticationError.isInstance(error)) return error;
	const isProductionEnv = (process == null ? void 0 : "production") === "production";
	const moreInfoURL = "https://v5.ai-sdk.dev/unauthenticated-ai-gateway";
	if (isProductionEnv) return new AISDKError({
		name: "GatewayError",
		message: `Unauthenticated. Configure AI_GATEWAY_API_KEY or use a provider module. Learn more: ${moreInfoURL}`
	});
	return Object.assign(/* @__PURE__ */ new Error(`\x1B[1m\x1B[31mUnauthenticated request to AI Gateway.\x1B[0m

To authenticate, set the \x1B[33mAI_GATEWAY_API_KEY\x1B[0m environment variable with your API key.

Alternatively, you can use a provider module instead of the AI Gateway.

Learn more: \x1B[34m${moreInfoURL}\x1B[0m

`), { name: "GatewayAuthenticationError" });
}
function assembleOperationName({ operationId, telemetry }) {
	return {
		"operation.name": `${operationId}${(telemetry == null ? void 0 : telemetry.functionId) != null ? ` ${telemetry.functionId}` : ""}`,
		"resource.name": telemetry == null ? void 0 : telemetry.functionId,
		"ai.operationId": operationId,
		"ai.telemetry.functionId": telemetry == null ? void 0 : telemetry.functionId
	};
}
function getTelemetryMetadataAttributes(telemetry) {
	var _a16;
	return Object.entries((_a16 = telemetry == null ? void 0 : telemetry.metadata) != null ? _a16 : {}).reduce((attributes, [key, value]) => {
		attributes[`ai.telemetry.metadata.${key}`] = value;
		return attributes;
	}, {});
}
function getBaseTelemetryAttributes({ model, settings, telemetry, headers }) {
	return {
		"ai.model.provider": model.provider,
		"ai.model.id": model.modelId,
		...Object.entries(settings).reduce((attributes, [key, value]) => {
			attributes[`ai.settings.${key}`] = value;
			return attributes;
		}, {}),
		...getTelemetryMetadataAttributes(telemetry),
		...Object.entries(headers != null ? headers : {}).reduce((attributes, [key, value]) => {
			if (value !== void 0) attributes[`ai.request.headers.${key}`] = value;
			return attributes;
		}, {})
	};
}
var noopTracer = {
	startSpan() {
		return noopSpan;
	},
	startActiveSpan(name16, arg1, arg2, arg3) {
		if (typeof arg1 === "function") return arg1(noopSpan);
		if (typeof arg2 === "function") return arg2(noopSpan);
		if (typeof arg3 === "function") return arg3(noopSpan);
	}
};
var noopSpan = {
	spanContext() {
		return noopSpanContext;
	},
	setAttribute() {
		return this;
	},
	setAttributes() {
		return this;
	},
	addEvent() {
		return this;
	},
	addLink() {
		return this;
	},
	addLinks() {
		return this;
	},
	setStatus() {
		return this;
	},
	updateName() {
		return this;
	},
	end() {
		return this;
	},
	isRecording() {
		return false;
	},
	recordException() {
		return this;
	}
};
var noopSpanContext = {
	traceId: "",
	spanId: "",
	traceFlags: 0
};
function getTracer({ isEnabled = false, tracer } = {}) {
	if (!isEnabled) return noopTracer;
	if (tracer) return tracer;
	return trace.getTracer("ai");
}
function recordSpan({ name: name16, tracer, attributes, fn, endWhenDone = true, endOnError = endWhenDone }) {
	return tracer.startActiveSpan(name16, { attributes }, async (span) => {
		try {
			const result = await fn(span);
			if (endWhenDone) span.end();
			return result;
		} catch (error) {
			try {
				recordErrorOnSpan(span, error);
			} finally {
				if (endOnError) span.end();
			}
			throw error;
		}
	});
}
function recordErrorOnSpan(span, error) {
	if (error instanceof Error) {
		span.recordException({
			name: error.name,
			message: error.message,
			stack: error.stack
		});
		span.setStatus({
			code: SpanStatusCode.ERROR,
			message: error.message
		});
	} else span.setStatus({ code: SpanStatusCode.ERROR });
}
function selectTelemetryAttributes({ telemetry, attributes }) {
	if ((telemetry == null ? void 0 : telemetry.isEnabled) !== true) return {};
	return Object.entries(attributes).reduce((attributes2, [key, value]) => {
		if (value == null) return attributes2;
		if (typeof value === "object" && "input" in value && typeof value.input === "function") {
			if ((telemetry == null ? void 0 : telemetry.recordInputs) === false) return attributes2;
			const result = value.input();
			return result == null ? attributes2 : {
				...attributes2,
				[key]: result
			};
		}
		if (typeof value === "object" && "output" in value && typeof value.output === "function") {
			if ((telemetry == null ? void 0 : telemetry.recordOutputs) === false) return attributes2;
			const result = value.output();
			return result == null ? attributes2 : {
				...attributes2,
				[key]: result
			};
		}
		return {
			...attributes2,
			[key]: value
		};
	}, {});
}
function stringifyForTelemetry(prompt) {
	return JSON.stringify(prompt.map((message) => ({
		...message,
		content: typeof message.content === "string" ? message.content : message.content.map((part) => part.type === "file" ? {
			...part,
			data: part.data instanceof Uint8Array ? convertDataContentToBase64String(part.data) : part.data
		} : part)
	})));
}
function addLanguageModelUsage(usage1, usage2) {
	return {
		inputTokens: addTokenCounts(usage1.inputTokens, usage2.inputTokens),
		outputTokens: addTokenCounts(usage1.outputTokens, usage2.outputTokens),
		totalTokens: addTokenCounts(usage1.totalTokens, usage2.totalTokens),
		reasoningTokens: addTokenCounts(usage1.reasoningTokens, usage2.reasoningTokens),
		cachedInputTokens: addTokenCounts(usage1.cachedInputTokens, usage2.cachedInputTokens)
	};
}
function addTokenCounts(tokenCount1, tokenCount2) {
	return tokenCount1 == null && tokenCount2 == null ? void 0 : (tokenCount1 != null ? tokenCount1 : 0) + (tokenCount2 != null ? tokenCount2 : 0);
}
function asArray(value) {
	return value === void 0 ? [] : Array.isArray(value) ? value : [value];
}
function getRetryDelayInMs({ error, exponentialBackoffDelay }) {
	const headers = APICallError.isInstance(error) ? error.responseHeaders : APICallError.isInstance(error.cause) ? error.cause.responseHeaders : void 0;
	if (!headers) return exponentialBackoffDelay;
	let ms;
	const retryAfterMs = headers["retry-after-ms"];
	if (retryAfterMs) {
		const timeoutMs = parseFloat(retryAfterMs);
		if (!Number.isNaN(timeoutMs)) ms = timeoutMs;
	}
	const retryAfter = headers["retry-after"];
	if (retryAfter && ms === void 0) {
		const timeoutSeconds = parseFloat(retryAfter);
		if (!Number.isNaN(timeoutSeconds)) ms = timeoutSeconds * 1e3;
		else ms = Date.parse(retryAfter) - Date.now();
	}
	if (ms != null && !Number.isNaN(ms) && 0 <= ms && (ms < 6e4 || ms < exponentialBackoffDelay)) return ms;
	return exponentialBackoffDelay;
}
var retryWithExponentialBackoffRespectingRetryHeaders = ({ maxRetries = 2, initialDelayInMs = 2e3, backoffFactor = 2, abortSignal, additionalRetryableError } = {}) => async (f) => _retryWithExponentialBackoff(f, {
	maxRetries,
	delayInMs: initialDelayInMs,
	backoffFactor,
	abortSignal,
	additionalRetryableError
});
async function _retryWithExponentialBackoff(f, { maxRetries, delayInMs, backoffFactor, abortSignal, additionalRetryableError }, errors = []) {
	try {
		return await f();
	} catch (error) {
		if (isAbortError(error)) throw error;
		if (maxRetries === 0) throw error;
		const errorMessage = getErrorMessage$1(error);
		const newErrors = [...errors, error];
		const tryNumber = newErrors.length;
		if (tryNumber > maxRetries) throw new RetryError({
			message: `Failed after ${tryNumber} attempts. Last error: ${errorMessage}`,
			reason: "maxRetriesExceeded",
			errors: newErrors
		});
		if ((error instanceof Error && (APICallError.isInstance(error) && error.isRetryable === true || GatewayError.isInstance(error) && error.isRetryable === true) || (additionalRetryableError == null ? void 0 : additionalRetryableError(error)) === true) && tryNumber <= maxRetries) {
			await delay(getRetryDelayInMs({
				error,
				exponentialBackoffDelay: delayInMs
			}), { abortSignal });
			return _retryWithExponentialBackoff(f, {
				maxRetries,
				delayInMs: backoffFactor * delayInMs,
				backoffFactor,
				abortSignal,
				additionalRetryableError
			}, newErrors);
		}
		if (tryNumber === 1) throw error;
		throw new RetryError({
			message: `Failed after ${tryNumber} attempts with non-retryable error: '${errorMessage}'`,
			reason: "errorNotRetryable",
			errors: newErrors
		});
	}
}
function prepareRetries({ maxRetries, abortSignal, additionalRetryableError }) {
	if (maxRetries != null) {
		if (!Number.isInteger(maxRetries)) throw new InvalidArgumentError({
			parameter: "maxRetries",
			value: maxRetries,
			message: "maxRetries must be an integer"
		});
		if (maxRetries < 0) throw new InvalidArgumentError({
			parameter: "maxRetries",
			value: maxRetries,
			message: "maxRetries must be >= 0"
		});
	}
	const maxRetriesResult = maxRetries != null ? maxRetries : 2;
	return {
		maxRetries: maxRetriesResult,
		retry: retryWithExponentialBackoffRespectingRetryHeaders({
			maxRetries: maxRetriesResult,
			abortSignal,
			additionalRetryableError
		})
	};
}
function extractTextContent(content) {
	const parts = content.filter((content2) => content2.type === "text");
	if (parts.length === 0) return;
	return parts.map((content2) => content2.text).join("");
}
function filterActiveTools({ tools, activeTools }) {
	if (tools == null || activeTools == null) return tools;
	return Object.fromEntries(Object.entries(tools).filter(([name16]) => activeTools.includes(name16)));
}
var DefaultGeneratedFile = class {
	constructor({ data, mediaType }) {
		const isUint8Array = data instanceof Uint8Array;
		this.base64Data = isUint8Array ? void 0 : data;
		this.uint8ArrayData = isUint8Array ? data : void 0;
		this.mediaType = mediaType;
	}
	get base64() {
		if (this.base64Data == null) this.base64Data = convertUint8ArrayToBase64(this.uint8ArrayData);
		return this.base64Data;
	}
	get uint8Array() {
		if (this.uint8ArrayData == null) this.uint8ArrayData = convertBase64ToUint8Array(this.base64Data);
		return this.uint8ArrayData;
	}
};
var DefaultGeneratedFileWithType = class extends DefaultGeneratedFile {
	constructor() {
		super(...arguments);
		this.type = "file";
	}
};
function isToolExecutionAllowedFinishReason(finishReason) {
	return finishReason === "stop" || finishReason === "tool-calls";
}
async function parseToolCall({ toolCall, tools, repairToolCall, system, messages }) {
	try {
		if (tools == null) {
			if (toolCall.providerExecuted) return await parseProviderExecutedDynamicToolCall(toolCall);
			throw new NoSuchToolError({ toolName: toolCall.toolName });
		}
		try {
			return await doParseToolCall({
				toolCall,
				tools
			});
		} catch (error) {
			if (repairToolCall == null || !(NoSuchToolError.isInstance(error) || InvalidToolInputError.isInstance(error))) throw error;
			let repairedToolCall = null;
			try {
				repairedToolCall = await repairToolCall({
					toolCall,
					tools,
					inputSchema: ({ toolName }) => {
						const { inputSchema } = tools[toolName];
						return asSchema(inputSchema).jsonSchema;
					},
					system,
					messages,
					error
				});
			} catch (repairError) {
				throw new ToolCallRepairError({
					cause: repairError,
					originalError: error
				});
			}
			if (repairedToolCall == null) throw error;
			return await doParseToolCall({
				toolCall: repairedToolCall,
				tools
			});
		}
	} catch (error) {
		const parsedInput = await safeParseJSON({ text: toolCall.input });
		const input = parsedInput.success ? parsedInput.value : toolCall.input;
		return {
			type: "tool-call",
			toolCallId: toolCall.toolCallId,
			toolName: toolCall.toolName,
			input,
			dynamic: true,
			invalid: true,
			error,
			providerMetadata: toolCall.providerMetadata
		};
	}
}
async function parseProviderExecutedDynamicToolCall(toolCall) {
	const parseResult = toolCall.input.trim() === "" ? {
		success: true,
		value: {}
	} : await safeParseJSON({ text: toolCall.input });
	if (parseResult.success === false) throw new InvalidToolInputError({
		toolName: toolCall.toolName,
		toolInput: toolCall.input,
		cause: parseResult.error
	});
	return {
		type: "tool-call",
		toolCallId: toolCall.toolCallId,
		toolName: toolCall.toolName,
		input: parseResult.value,
		providerExecuted: true,
		dynamic: true,
		providerMetadata: toolCall.providerMetadata
	};
}
async function doParseToolCall({ toolCall, tools }) {
	const toolName = toolCall.toolName;
	const tool2 = tools[toolName];
	if (tool2 == null) {
		if (toolCall.providerExecuted) return await parseProviderExecutedDynamicToolCall(toolCall);
		throw new NoSuchToolError({
			toolName: toolCall.toolName,
			availableTools: Object.keys(tools)
		});
	}
	const schema = asSchema(tool2.inputSchema);
	const parseResult = toolCall.input.trim() === "" ? await safeValidateTypes({
		value: {},
		schema
	}) : await safeParseJSON({
		text: toolCall.input,
		schema
	});
	if (parseResult.success === false) throw new InvalidToolInputError({
		toolName,
		toolInput: toolCall.input,
		cause: parseResult.error
	});
	return tool2.type === "dynamic" ? {
		type: "tool-call",
		toolCallId: toolCall.toolCallId,
		toolName: toolCall.toolName,
		input: parseResult.value,
		providerExecuted: toolCall.providerExecuted,
		providerMetadata: toolCall.providerMetadata,
		dynamic: true
	} : {
		type: "tool-call",
		toolCallId: toolCall.toolCallId,
		toolName,
		input: parseResult.value,
		providerExecuted: toolCall.providerExecuted,
		providerMetadata: toolCall.providerMetadata
	};
}
var DefaultStepResult = class {
	constructor({ content, finishReason, usage, warnings, request, response, providerMetadata }) {
		this.content = content;
		this.finishReason = finishReason;
		this.usage = usage;
		this.warnings = warnings;
		this.request = request;
		this.response = response;
		this.providerMetadata = providerMetadata;
	}
	get text() {
		return this.content.filter((part) => part.type === "text").map((part) => part.text).join("");
	}
	get reasoning() {
		return this.content.filter((part) => part.type === "reasoning");
	}
	get reasoningText() {
		return this.reasoning.length === 0 ? void 0 : this.reasoning.map((part) => part.text).join("");
	}
	get files() {
		return this.content.filter((part) => part.type === "file").map((part) => part.file);
	}
	get sources() {
		return this.content.filter((part) => part.type === "source");
	}
	get toolCalls() {
		return this.content.filter((part) => part.type === "tool-call");
	}
	get staticToolCalls() {
		return this.toolCalls.filter((toolCall) => toolCall.dynamic !== true);
	}
	get dynamicToolCalls() {
		return this.toolCalls.filter((toolCall) => toolCall.dynamic === true);
	}
	get toolResults() {
		return this.content.filter((part) => part.type === "tool-result");
	}
	get staticToolResults() {
		return this.toolResults.filter((toolResult) => toolResult.dynamic !== true);
	}
	get dynamicToolResults() {
		return this.toolResults.filter((toolResult) => toolResult.dynamic === true);
	}
};
function stepCountIs(stepCount) {
	return ({ steps }) => steps.length === stepCount;
}
function hasToolCall(toolName) {
	return ({ steps }) => {
		var _a16, _b, _c;
		return (_c = (_b = (_a16 = steps[steps.length - 1]) == null ? void 0 : _a16.toolCalls) == null ? void 0 : _b.some((toolCall) => toolCall.toolName === toolName)) != null ? _c : false;
	};
}
async function isStopConditionMet({ stopConditions, steps }) {
	return (await Promise.all(stopConditions.map((condition) => condition({ steps })))).some((result) => result);
}
function createToolModelOutput({ output, tool: tool2, errorMode }) {
	if (errorMode === "text") return {
		type: "error-text",
		value: getErrorMessage(output)
	};
	else if (errorMode === "json") return {
		type: "error-json",
		value: toJSONValue(output)
	};
	if (tool2 == null ? void 0 : tool2.toModelOutput) return tool2.toModelOutput(output);
	return typeof output === "string" ? {
		type: "text",
		value: output
	} : {
		type: "json",
		value: toJSONValue(output)
	};
}
function toJSONValue(value) {
	return value === void 0 ? null : value;
}
function toResponseMessages({ content: inputContent, tools }) {
	const responseMessages = [];
	const content = inputContent.filter((part) => part.type !== "source").filter((part) => (part.type !== "tool-result" || part.providerExecuted) && (part.type !== "tool-error" || part.providerExecuted)).filter((part) => part.type !== "text" || part.text.length > 0).map((part) => {
		switch (part.type) {
			case "text": return {
				type: "text",
				text: part.text,
				providerOptions: part.providerMetadata
			};
			case "reasoning": return {
				type: "reasoning",
				text: part.text,
				providerOptions: part.providerMetadata
			};
			case "file": return {
				type: "file",
				data: part.file.base64,
				mediaType: part.file.mediaType,
				providerOptions: part.providerMetadata
			};
			case "tool-call": return {
				type: "tool-call",
				toolCallId: part.toolCallId,
				toolName: part.toolName,
				input: part.input,
				providerExecuted: part.providerExecuted,
				providerOptions: part.providerMetadata
			};
			case "tool-result": return {
				type: "tool-result",
				toolCallId: part.toolCallId,
				toolName: part.toolName,
				output: createToolModelOutput({
					tool: tools == null ? void 0 : tools[part.toolName],
					output: part.output,
					errorMode: "none"
				}),
				providerExecuted: true,
				providerOptions: part.providerMetadata
			};
			case "tool-error": return {
				type: "tool-result",
				toolCallId: part.toolCallId,
				toolName: part.toolName,
				output: createToolModelOutput({
					tool: tools == null ? void 0 : tools[part.toolName],
					output: part.error,
					errorMode: "json"
				}),
				providerOptions: part.providerMetadata
			};
		}
	});
	if (content.length > 0) responseMessages.push({
		role: "assistant",
		content
	});
	const toolResultContent = inputContent.filter((part) => part.type === "tool-result" || part.type === "tool-error").filter((part) => !part.providerExecuted).map((toolResult) => ({
		type: "tool-result",
		toolCallId: toolResult.toolCallId,
		toolName: toolResult.toolName,
		output: createToolModelOutput({
			tool: tools == null ? void 0 : tools[toolResult.toolName],
			output: toolResult.type === "tool-result" ? toolResult.output : toolResult.error,
			errorMode: toolResult.type === "tool-error" ? "text" : "none"
		}),
		...toolResult.providerMetadata != null ? { providerOptions: toolResult.providerMetadata } : {}
	}));
	if (toolResultContent.length > 0) responseMessages.push({
		role: "tool",
		content: toolResultContent
	});
	return responseMessages;
}
var originalGenerateId = createIdGenerator({
	prefix: "aitxt",
	size: 24
});
async function generateText$1({ model: modelArg, tools, toolChoice, system, prompt, messages, allowSystemInMessages, maxRetries: maxRetriesArg, abortSignal, headers, stopWhen = stepCountIs(1), experimental_output: output, experimental_telemetry: telemetry, providerOptions, experimental_activeTools, activeTools = experimental_activeTools, experimental_prepareStep, prepareStep = experimental_prepareStep, experimental_repairToolCall: repairToolCall, experimental_download: download2, experimental_context, _internal: { generateId: generateId3 = originalGenerateId, currentDate = () => /* @__PURE__ */ new Date() } = {}, onStepFinish, ...settings }) {
	const model = resolveLanguageModel(modelArg);
	const stopConditions = asArray(stopWhen);
	const { maxRetries, retry } = prepareRetries({
		maxRetries: maxRetriesArg,
		abortSignal
	});
	const callSettings = prepareCallSettings(settings);
	const headersWithUserAgent = withUserAgentSuffix(headers != null ? headers : {}, `ai/${VERSION}`);
	const baseTelemetryAttributes = getBaseTelemetryAttributes({
		model,
		telemetry,
		headers: headersWithUserAgent,
		settings: {
			...callSettings,
			maxRetries
		}
	});
	const initialPrompt = await standardizePrompt({
		system,
		prompt,
		messages,
		allowSystemInMessages
	});
	const tracer = getTracer(telemetry);
	try {
		return await recordSpan({
			name: "ai.generateText",
			attributes: selectTelemetryAttributes({
				telemetry,
				attributes: {
					...assembleOperationName({
						operationId: "ai.generateText",
						telemetry
					}),
					...baseTelemetryAttributes,
					"ai.model.provider": model.provider,
					"ai.model.id": model.modelId,
					"ai.prompt": { input: () => JSON.stringify({
						system,
						prompt,
						messages
					}) }
				}
			}),
			tracer,
			fn: async (span) => {
				var _a16, _b, _c, _d, _e, _f, _g;
				const callSettings2 = prepareCallSettings(settings);
				let currentModelResponse;
				let clientToolCalls = [];
				let clientToolOutputs = [];
				const responseMessages = [];
				const steps = [];
				do {
					if (steps.length > 0) abortSignal?.throwIfAborted();
					const stepInputMessages = [...initialPrompt.messages, ...responseMessages];
					const prepareStepResult = await (prepareStep == null ? void 0 : prepareStep({
						model,
						steps,
						stepNumber: steps.length,
						messages: stepInputMessages
					}));
					const stepModel = resolveLanguageModel((_a16 = prepareStepResult == null ? void 0 : prepareStepResult.model) != null ? _a16 : model);
					const promptMessages = await convertToLanguageModelPrompt({
						prompt: {
							system: (_b = prepareStepResult == null ? void 0 : prepareStepResult.system) != null ? _b : initialPrompt.system,
							messages: (_c = prepareStepResult == null ? void 0 : prepareStepResult.messages) != null ? _c : stepInputMessages
						},
						supportedUrls: await stepModel.supportedUrls,
						download: download2
					});
					const stepActiveTools = (_d = prepareStepResult == null ? void 0 : prepareStepResult.activeTools) != null ? _d : activeTools;
					const stepToolSet = filterActiveTools({
						tools,
						activeTools: stepActiveTools
					});
					const { toolChoice: stepToolChoice, tools: stepTools } = prepareToolsAndToolChoice({
						tools,
						toolChoice: (_e = prepareStepResult == null ? void 0 : prepareStepResult.toolChoice) != null ? _e : toolChoice,
						activeTools: stepActiveTools
					});
					currentModelResponse = await retry(() => {
						var _a17;
						return recordSpan({
							name: "ai.generateText.doGenerate",
							attributes: selectTelemetryAttributes({
								telemetry,
								attributes: {
									...assembleOperationName({
										operationId: "ai.generateText.doGenerate",
										telemetry
									}),
									...baseTelemetryAttributes,
									"ai.model.provider": stepModel.provider,
									"ai.model.id": stepModel.modelId,
									"ai.prompt.messages": { input: () => stringifyForTelemetry(promptMessages) },
									"ai.prompt.tools": { input: () => stepTools == null ? void 0 : stepTools.map((tool2) => JSON.stringify(tool2)) },
									"ai.prompt.toolChoice": { input: () => stepToolChoice != null ? JSON.stringify(stepToolChoice) : void 0 },
									"gen_ai.system": stepModel.provider,
									"gen_ai.request.model": stepModel.modelId,
									"gen_ai.request.frequency_penalty": settings.frequencyPenalty,
									"gen_ai.request.max_tokens": settings.maxOutputTokens,
									"gen_ai.request.presence_penalty": settings.presencePenalty,
									"gen_ai.request.stop_sequences": settings.stopSequences,
									"gen_ai.request.temperature": (_a17 = settings.temperature) != null ? _a17 : void 0,
									"gen_ai.request.top_k": settings.topK,
									"gen_ai.request.top_p": settings.topP
								}
							}),
							tracer,
							fn: async (span2) => {
								var _a18, _b2, _c2, _d2, _e2, _f2, _g2, _h;
								const result = await stepModel.doGenerate({
									...callSettings2,
									tools: stepTools,
									toolChoice: stepToolChoice,
									responseFormat: output == null ? void 0 : output.responseFormat,
									prompt: promptMessages,
									providerOptions,
									abortSignal,
									headers: headersWithUserAgent
								});
								const responseData = {
									id: (_b2 = (_a18 = result.response) == null ? void 0 : _a18.id) != null ? _b2 : generateId3(),
									timestamp: (_d2 = (_c2 = result.response) == null ? void 0 : _c2.timestamp) != null ? _d2 : currentDate(),
									modelId: (_f2 = (_e2 = result.response) == null ? void 0 : _e2.modelId) != null ? _f2 : stepModel.modelId,
									headers: (_g2 = result.response) == null ? void 0 : _g2.headers,
									body: (_h = result.response) == null ? void 0 : _h.body
								};
								span2.setAttributes(selectTelemetryAttributes({
									telemetry,
									attributes: {
										"ai.response.finishReason": result.finishReason,
										"ai.response.text": { output: () => extractTextContent(result.content) },
										"ai.response.toolCalls": { output: () => {
											const toolCalls = asToolCalls(result.content);
											return toolCalls == null ? void 0 : JSON.stringify(toolCalls);
										} },
										"ai.response.id": responseData.id,
										"ai.response.model": responseData.modelId,
										"ai.response.timestamp": responseData.timestamp.toISOString(),
										"ai.response.providerMetadata": JSON.stringify(result.providerMetadata),
										"ai.usage.promptTokens": result.usage.inputTokens,
										"ai.usage.completionTokens": result.usage.outputTokens,
										"gen_ai.response.finish_reasons": [result.finishReason],
										"gen_ai.response.id": responseData.id,
										"gen_ai.response.model": responseData.modelId,
										"gen_ai.usage.input_tokens": result.usage.inputTokens,
										"gen_ai.usage.output_tokens": result.usage.outputTokens
									}
								}));
								return {
									...result,
									response: responseData
								};
							}
						});
					});
					const stepToolCalls = await Promise.all(currentModelResponse.content.filter((part) => part.type === "tool-call").map((toolCall) => parseToolCall({
						toolCall,
						tools: stepToolSet,
						repairToolCall,
						system,
						messages: stepInputMessages
					})));
					for (const toolCall of stepToolCalls) {
						if (toolCall.invalid) continue;
						const tool2 = stepToolSet[toolCall.toolName];
						if (tool2.onInputStart != null) await tool2.onInputStart({
							toolCallId: toolCall.toolCallId,
							messages: stepInputMessages,
							abortSignal,
							experimental_context
						});
						if ((tool2 == null ? void 0 : tool2.onInputAvailable) != null) await tool2.onInputAvailable({
							input: toolCall.input,
							toolCallId: toolCall.toolCallId,
							messages: stepInputMessages,
							abortSignal,
							experimental_context
						});
					}
					const invalidToolCalls = stepToolCalls.filter((toolCall) => toolCall.invalid && toolCall.dynamic);
					clientToolOutputs = [];
					for (const toolCall of invalidToolCalls) clientToolOutputs.push({
						type: "tool-error",
						toolCallId: toolCall.toolCallId,
						toolName: toolCall.toolName,
						input: toolCall.input,
						error: getErrorMessage$1(toolCall.error),
						dynamic: true
					});
					clientToolCalls = stepToolCalls.filter((toolCall) => !toolCall.providerExecuted);
					if (stepToolSet != null && isToolExecutionAllowedFinishReason(currentModelResponse.finishReason)) clientToolOutputs.push(...await executeTools({
						toolCalls: clientToolCalls.filter((toolCall) => !toolCall.invalid),
						tools: stepToolSet,
						tracer,
						telemetry,
						messages: stepInputMessages,
						abortSignal,
						experimental_context
					}));
					const stepContent = asContent({
						content: currentModelResponse.content,
						toolCalls: stepToolCalls,
						toolOutputs: clientToolOutputs
					});
					responseMessages.push(...toResponseMessages({
						content: stepContent,
						tools: stepToolSet
					}));
					const currentStepResult = new DefaultStepResult({
						content: stepContent,
						finishReason: currentModelResponse.finishReason,
						usage: currentModelResponse.usage,
						warnings: currentModelResponse.warnings,
						providerMetadata: currentModelResponse.providerMetadata,
						request: (_f = currentModelResponse.request) != null ? _f : {},
						response: {
							...currentModelResponse.response,
							messages: structuredClone(responseMessages)
						}
					});
					logWarnings((_g = currentModelResponse.warnings) != null ? _g : []);
					steps.push(currentStepResult);
					await (onStepFinish == null ? void 0 : onStepFinish(currentStepResult));
				} while (clientToolCalls.length > 0 && clientToolOutputs.length === clientToolCalls.length && !await isStopConditionMet({
					stopConditions,
					steps
				}));
				span.setAttributes(selectTelemetryAttributes({
					telemetry,
					attributes: {
						"ai.response.finishReason": currentModelResponse.finishReason,
						"ai.response.text": { output: () => extractTextContent(currentModelResponse.content) },
						"ai.response.toolCalls": { output: () => {
							const toolCalls = asToolCalls(currentModelResponse.content);
							return toolCalls == null ? void 0 : JSON.stringify(toolCalls);
						} },
						"ai.response.providerMetadata": JSON.stringify(currentModelResponse.providerMetadata),
						"ai.usage.promptTokens": currentModelResponse.usage.inputTokens,
						"ai.usage.completionTokens": currentModelResponse.usage.outputTokens
					}
				}));
				const lastStep = steps[steps.length - 1];
				let resolvedOutput;
				if (lastStep.finishReason === "stop") resolvedOutput = await (output == null ? void 0 : output.parseOutput({ text: lastStep.text }, {
					response: lastStep.response,
					usage: lastStep.usage,
					finishReason: lastStep.finishReason
				}));
				return new DefaultGenerateTextResult({
					steps,
					resolvedOutput
				});
			}
		});
	} catch (error) {
		throw wrapGatewayError(error);
	}
}
async function executeTools({ toolCalls, tools, tracer, telemetry, messages, abortSignal, experimental_context }) {
	return (await Promise.all(toolCalls.map(async ({ toolCallId, toolName, input }) => {
		const tool2 = tools[toolName];
		if ((tool2 == null ? void 0 : tool2.execute) == null) return;
		return recordSpan({
			name: "ai.toolCall",
			attributes: selectTelemetryAttributes({
				telemetry,
				attributes: {
					...assembleOperationName({
						operationId: "ai.toolCall",
						telemetry
					}),
					...getTelemetryMetadataAttributes(telemetry),
					"ai.toolCall.name": toolName,
					"ai.toolCall.id": toolCallId,
					"ai.toolCall.args": { output: () => JSON.stringify(input) }
				}
			}),
			tracer,
			fn: async (span) => {
				try {
					const stream = executeTool({
						execute: tool2.execute.bind(tool2),
						input,
						options: {
							toolCallId,
							messages,
							abortSignal,
							experimental_context
						}
					});
					let output;
					for await (const part of stream) if (part.type === "final") output = part.output;
					try {
						span.setAttributes(selectTelemetryAttributes({
							telemetry,
							attributes: { "ai.toolCall.result": { output: () => JSON.stringify(output) } }
						}));
					} catch (ignored) {}
					return {
						type: "tool-result",
						toolCallId,
						toolName,
						input,
						output,
						dynamic: tool2.type === "dynamic"
					};
				} catch (error) {
					recordErrorOnSpan(span, error);
					return {
						type: "tool-error",
						toolCallId,
						toolName,
						input,
						error,
						dynamic: tool2.type === "dynamic"
					};
				}
			}
		});
	}))).filter((output) => output != null);
}
var DefaultGenerateTextResult = class {
	constructor(options) {
		this.steps = options.steps;
		this.resolvedOutput = options.resolvedOutput;
	}
	get finalStep() {
		return this.steps[this.steps.length - 1];
	}
	get content() {
		return this.finalStep.content;
	}
	get text() {
		return this.finalStep.text;
	}
	get files() {
		return this.finalStep.files;
	}
	get reasoningText() {
		return this.finalStep.reasoningText;
	}
	get reasoning() {
		return this.finalStep.reasoning;
	}
	get toolCalls() {
		return this.finalStep.toolCalls;
	}
	get staticToolCalls() {
		return this.finalStep.staticToolCalls;
	}
	get dynamicToolCalls() {
		return this.finalStep.dynamicToolCalls;
	}
	get toolResults() {
		return this.finalStep.toolResults;
	}
	get staticToolResults() {
		return this.finalStep.staticToolResults;
	}
	get dynamicToolResults() {
		return this.finalStep.dynamicToolResults;
	}
	get sources() {
		return this.finalStep.sources;
	}
	get finishReason() {
		return this.finalStep.finishReason;
	}
	get warnings() {
		return this.finalStep.warnings;
	}
	get providerMetadata() {
		return this.finalStep.providerMetadata;
	}
	get response() {
		return this.finalStep.response;
	}
	get request() {
		return this.finalStep.request;
	}
	get usage() {
		return this.finalStep.usage;
	}
	get totalUsage() {
		return this.steps.reduce((totalUsage, step) => {
			return addLanguageModelUsage(totalUsage, step.usage);
		}, {
			inputTokens: void 0,
			outputTokens: void 0,
			totalTokens: void 0,
			reasoningTokens: void 0,
			cachedInputTokens: void 0
		});
	}
	get experimental_output() {
		if (this.resolvedOutput == null) throw new NoOutputSpecifiedError();
		return this.resolvedOutput;
	}
};
function asToolCalls(content) {
	const parts = content.filter((part) => part.type === "tool-call");
	if (parts.length === 0) return;
	return parts.map((toolCall) => ({
		toolCallId: toolCall.toolCallId,
		toolName: toolCall.toolName,
		input: toolCall.input
	}));
}
function asContent({ content, toolCalls, toolOutputs }) {
	return [...content.map((part) => {
		switch (part.type) {
			case "text":
			case "reasoning":
			case "source": return part;
			case "file": return {
				type: "file",
				file: new DefaultGeneratedFile(part)
			};
			case "tool-call": return toolCalls.find((toolCall) => toolCall.toolCallId === part.toolCallId);
			case "tool-result": {
				const toolCall = toolCalls.find((toolCall2) => toolCall2.toolCallId === part.toolCallId);
				if (toolCall == null) throw new Error(`Tool call ${part.toolCallId} not found.`);
				if (part.isError) return {
					type: "tool-error",
					toolCallId: part.toolCallId,
					toolName: part.toolName,
					input: toolCall.input,
					error: part.result,
					providerExecuted: true,
					dynamic: toolCall.dynamic
				};
				return {
					type: "tool-result",
					toolCallId: part.toolCallId,
					toolName: part.toolName,
					input: toolCall.input,
					output: part.result,
					providerExecuted: true,
					dynamic: toolCall.dynamic
				};
			}
		}
	}), ...toolOutputs];
}
function prepareHeaders(headers, defaultHeaders) {
	const responseHeaders = new Headers(headers != null ? headers : {});
	for (const [key, value] of Object.entries(defaultHeaders)) if (!responseHeaders.has(key)) responseHeaders.set(key, value);
	return responseHeaders;
}
function createTextStreamResponse({ status, statusText, headers, textStream }) {
	return new Response(textStream.pipeThrough(new TextEncoderStream()), {
		status: status != null ? status : 200,
		statusText,
		headers: prepareHeaders(headers, { "content-type": "text/plain; charset=utf-8" })
	});
}
function writeToServerResponse({ response, status, statusText, headers, stream }) {
	const statusCode = status != null ? status : 200;
	if (statusText !== void 0) response.writeHead(statusCode, statusText, headers);
	else response.writeHead(statusCode, headers);
	const reader = stream.getReader();
	let clientDisconnected = false;
	let onDisconnect;
	const handleClose = () => {
		if (response.writableFinished) return;
		clientDisconnected = true;
		onDisconnect?.();
		reader.cancel(/* @__PURE__ */ new Error("Client disconnected.")).catch(() => {});
	};
	response.once("close", handleClose);
	if (response.destroyed) handleClose();
	const read = async () => {
		try {
			while (true) {
				const { done, value } = await reader.read();
				if (done || clientDisconnected || response.destroyed) break;
				if (!response.write(value)) {
					await new Promise((resolve2) => {
						onDisconnect = resolve2;
						response.once("drain", resolve2);
					});
					onDisconnect = void 0;
				}
			}
		} finally {
			response.off("close", handleClose);
			if (clientDisconnected || response.destroyed) reader.cancel().catch(() => {});
			else response.end();
		}
	};
	return read();
}
function pipeTextStreamToResponse({ response, status, statusText, headers, textStream }) {
	return writeToServerResponse({
		response,
		status,
		statusText,
		headers: Object.fromEntries(prepareHeaders(headers, { "content-type": "text/plain; charset=utf-8" }).entries()),
		stream: textStream.pipeThrough(new TextEncoderStream())
	});
}
var STREAM_OPEN_COMMENT = ": stream-open\n\n";
var KEEP_ALIVE_COMMENT = ": keep-alive\n\n";
function createSseStreamWithKeepAlive({ stream, keepAliveMs }) {
	if (keepAliveMs == null) return stream;
	if (!Number.isFinite(keepAliveMs) || keepAliveMs <= 0 || keepAliveMs > 2147483647) throw new Error("keepAliveMs must be a positive finite timer duration no greater than 2147483647");
	const reader = stream.getReader();
	let keepAliveTimeout;
	let isCancelled = false;
	const clearKeepAliveTimeout = () => {
		clearTimeout(keepAliveTimeout);
		keepAliveTimeout = void 0;
	};
	const scheduleKeepAlive = (controller) => {
		clearKeepAliveTimeout();
		keepAliveTimeout = setTimeout(() => {
			if (isCancelled) return;
			if (controller.desiredSize != null && controller.desiredSize > 0) controller.enqueue(KEEP_ALIVE_COMMENT);
			scheduleKeepAlive(controller);
		}, keepAliveMs);
	};
	return new ReadableStream({
		start(controller) {
			controller.enqueue(STREAM_OPEN_COMMENT);
			scheduleKeepAlive(controller);
		},
		pull(controller) {
			return reader.read().then((result) => {
				clearKeepAliveTimeout();
				if (isCancelled) return;
				if (result.done) controller.close();
				else {
					controller.enqueue(result.value);
					scheduleKeepAlive(controller);
				}
			}, (error) => {
				clearKeepAliveTimeout();
				if (!isCancelled) throw error;
			});
		},
		async cancel(reason) {
			isCancelled = true;
			clearKeepAliveTimeout();
			await reader.cancel(reason);
		}
	});
}
var JsonToSseTransformStream = class extends TransformStream {
	constructor() {
		super({
			transform(part, controller) {
				controller.enqueue(`data: ${JSON.stringify(part)}

`);
			},
			flush(controller) {
				controller.enqueue("data: [DONE]\n\n");
			}
		});
	}
};
var UI_MESSAGE_STREAM_HEADERS = {
	"content-type": "text/event-stream",
	"cache-control": "no-cache",
	connection: "keep-alive",
	"x-vercel-ai-ui-message-stream": "v1",
	"x-accel-buffering": "no"
};
function createUIMessageStreamResponse({ status, statusText, headers, stream, keepAliveMs, consumeSseStream }) {
	let sseStream = createSseStreamWithKeepAlive({
		stream: stream.pipeThrough(new JsonToSseTransformStream()),
		keepAliveMs
	});
	if (consumeSseStream) {
		const [stream1, stream2] = sseStream.tee();
		sseStream = stream1;
		consumeSseStream({ stream: stream2 });
	}
	return new Response(sseStream.pipeThrough(new TextEncoderStream()), {
		status,
		statusText,
		headers: prepareHeaders(headers, UI_MESSAGE_STREAM_HEADERS)
	});
}
function getResponseUIMessageId({ originalMessages, responseMessageId }) {
	if (originalMessages == null) return;
	const lastMessage = originalMessages[originalMessages.length - 1];
	return (lastMessage == null ? void 0 : lastMessage.role) === "assistant" ? lastMessage.id : typeof responseMessageId === "function" ? responseMessageId() : responseMessageId;
}
var uiMessageChunkSchema = lazyValidator(() => zodSchema(z.union([
	z.looseObject({
		type: z.literal("text-start"),
		id: z.string(),
		providerMetadata: providerMetadataSchema.optional()
	}),
	z.looseObject({
		type: z.literal("text-delta"),
		id: z.string(),
		delta: z.string(),
		providerMetadata: providerMetadataSchema.optional()
	}),
	z.looseObject({
		type: z.literal("text-end"),
		id: z.string(),
		providerMetadata: providerMetadataSchema.optional()
	}),
	z.looseObject({
		type: z.literal("error"),
		errorText: z.string()
	}),
	z.looseObject({
		type: z.literal("tool-input-start"),
		toolCallId: z.string(),
		toolName: z.string(),
		providerExecuted: z.boolean().optional(),
		dynamic: z.boolean().optional()
	}),
	z.looseObject({
		type: z.literal("tool-input-delta"),
		toolCallId: z.string(),
		inputTextDelta: z.string()
	}),
	z.looseObject({
		type: z.literal("tool-input-available"),
		toolCallId: z.string(),
		toolName: z.string(),
		input: z.unknown(),
		providerExecuted: z.boolean().optional(),
		providerMetadata: providerMetadataSchema.optional(),
		dynamic: z.boolean().optional()
	}),
	z.looseObject({
		type: z.literal("tool-input-error"),
		toolCallId: z.string(),
		toolName: z.string(),
		input: z.unknown(),
		providerExecuted: z.boolean().optional(),
		providerMetadata: providerMetadataSchema.optional(),
		dynamic: z.boolean().optional(),
		errorText: z.string()
	}),
	z.looseObject({
		type: z.literal("tool-output-available"),
		toolCallId: z.string(),
		output: z.unknown(),
		providerExecuted: z.boolean().optional(),
		dynamic: z.boolean().optional(),
		preliminary: z.boolean().optional()
	}),
	z.looseObject({
		type: z.literal("tool-output-error"),
		toolCallId: z.string(),
		errorText: z.string(),
		providerExecuted: z.boolean().optional(),
		dynamic: z.boolean().optional()
	}),
	z.looseObject({
		type: z.literal("reasoning-start"),
		id: z.string(),
		providerMetadata: providerMetadataSchema.optional()
	}),
	z.looseObject({
		type: z.literal("reasoning-delta"),
		id: z.string(),
		delta: z.string(),
		providerMetadata: providerMetadataSchema.optional()
	}),
	z.looseObject({
		type: z.literal("reasoning-end"),
		id: z.string(),
		providerMetadata: providerMetadataSchema.optional()
	}),
	z.looseObject({
		type: z.literal("source-url"),
		sourceId: z.string(),
		url: z.string(),
		title: z.string().optional(),
		providerMetadata: providerMetadataSchema.optional()
	}),
	z.looseObject({
		type: z.literal("source-document"),
		sourceId: z.string(),
		mediaType: z.string(),
		title: z.string(),
		filename: z.string().optional(),
		providerMetadata: providerMetadataSchema.optional()
	}),
	z.looseObject({
		type: z.literal("file"),
		url: z.string(),
		mediaType: z.string(),
		providerMetadata: providerMetadataSchema.optional()
	}),
	z.looseObject({
		type: z.custom((value) => typeof value === "string" && value.startsWith("data-"), { message: "Type must start with \"data-\"" }),
		id: z.string().optional(),
		data: z.unknown(),
		transient: z.boolean().optional()
	}),
	z.looseObject({ type: z.literal("start-step") }),
	z.looseObject({ type: z.literal("finish-step") }),
	z.looseObject({
		type: z.literal("start"),
		messageId: z.string().optional(),
		messageMetadata: z.unknown().optional()
	}),
	z.looseObject({
		type: z.literal("finish"),
		finishReason: z.enum([
			"stop",
			"length",
			"content-filter",
			"tool-calls",
			"error",
			"other",
			"unknown"
		]).optional(),
		messageMetadata: z.unknown().optional()
	}),
	z.looseObject({ type: z.literal("abort") }),
	z.looseObject({
		type: z.literal("message-metadata"),
		messageMetadata: z.unknown()
	})
])));
function isDataUIMessageChunk(chunk) {
	return chunk.type.startsWith("data-");
}
function createIdMap() {
	return /* @__PURE__ */ Object.create(null);
}
function mergeObjects(base, overrides) {
	if (base === void 0 && overrides === void 0) return;
	if (base === void 0) return overrides;
	if (overrides === void 0) return base;
	const result = { ...base };
	for (const key in overrides) {
		if (key === "__proto__" || key === "constructor" || key === "prototype") continue;
		if (Object.prototype.hasOwnProperty.call(overrides, key)) {
			const overridesValue = overrides[key];
			if (overridesValue === void 0) continue;
			const baseValue = key in base ? base[key] : void 0;
			const isSourceObject = overridesValue !== null && typeof overridesValue === "object" && !Array.isArray(overridesValue) && !(overridesValue instanceof Date) && !(overridesValue instanceof RegExp);
			const isTargetObject = baseValue !== null && baseValue !== void 0 && typeof baseValue === "object" && !Array.isArray(baseValue) && !(baseValue instanceof Date) && !(baseValue instanceof RegExp);
			if (isSourceObject && isTargetObject) result[key] = mergeObjects(baseValue, overridesValue);
			else result[key] = overridesValue;
		}
	}
	return result;
}
function fixJson(input) {
	const stack = ["ROOT"];
	let lastValidIndex = -1;
	let literalStart = null;
	function processValueStart(char, i, swapState) {
		switch (char) {
			case "\"":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_STRING");
				break;
			case "f":
			case "t":
			case "n":
				lastValidIndex = i;
				literalStart = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_LITERAL");
				break;
			case "-":
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_NUMBER");
				break;
			case "0":
			case "1":
			case "2":
			case "3":
			case "4":
			case "5":
			case "6":
			case "7":
			case "8":
			case "9":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_NUMBER");
				break;
			case "{":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_OBJECT_START");
				break;
			case "[":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_ARRAY_START");
		}
	}
	function processAfterObjectValue(char, i) {
		switch (char) {
			case ",":
				stack.pop();
				stack.push("INSIDE_OBJECT_AFTER_COMMA");
				break;
			case "}":
				lastValidIndex = i;
				stack.pop();
		}
	}
	function processAfterArrayValue(char, i) {
		switch (char) {
			case ",":
				stack.pop();
				stack.push("INSIDE_ARRAY_AFTER_COMMA");
				break;
			case "]":
				lastValidIndex = i;
				stack.pop();
		}
	}
	for (let i = 0; i < input.length; i++) {
		const char = input[i];
		switch (stack[stack.length - 1]) {
			case "ROOT":
				processValueStart(char, i, "FINISH");
				break;
			case "INSIDE_OBJECT_START":
				switch (char) {
					case "\"":
						stack.pop();
						stack.push("INSIDE_OBJECT_KEY");
						break;
					case "}":
						lastValidIndex = i;
						stack.pop();
				}
				break;
			case "INSIDE_OBJECT_AFTER_COMMA":
				switch (char) {
					case "\"":
						stack.pop();
						stack.push("INSIDE_OBJECT_KEY");
				}
				break;
			case "INSIDE_OBJECT_KEY":
				switch (char) {
					case "\"":
						stack.pop();
						stack.push("INSIDE_OBJECT_AFTER_KEY");
				}
				break;
			case "INSIDE_OBJECT_AFTER_KEY":
				switch (char) {
					case ":":
						stack.pop();
						stack.push("INSIDE_OBJECT_BEFORE_VALUE");
				}
				break;
			case "INSIDE_OBJECT_BEFORE_VALUE":
				processValueStart(char, i, "INSIDE_OBJECT_AFTER_VALUE");
				break;
			case "INSIDE_OBJECT_AFTER_VALUE":
				processAfterObjectValue(char, i);
				break;
			case "INSIDE_STRING":
				switch (char) {
					case "\"":
						stack.pop();
						lastValidIndex = i;
						break;
					case "\\":
						stack.push("INSIDE_STRING_ESCAPE");
						break;
					default: lastValidIndex = i;
				}
				break;
			case "INSIDE_ARRAY_START":
				switch (char) {
					case "]":
						lastValidIndex = i;
						stack.pop();
						break;
					default:
						lastValidIndex = i;
						processValueStart(char, i, "INSIDE_ARRAY_AFTER_VALUE");
				}
				break;
			case "INSIDE_ARRAY_AFTER_VALUE":
				switch (char) {
					case ",":
						stack.pop();
						stack.push("INSIDE_ARRAY_AFTER_COMMA");
						break;
					case "]":
						lastValidIndex = i;
						stack.pop();
						break;
					default: lastValidIndex = i;
				}
				break;
			case "INSIDE_ARRAY_AFTER_COMMA":
				processValueStart(char, i, "INSIDE_ARRAY_AFTER_VALUE");
				break;
			case "INSIDE_STRING_ESCAPE":
				stack.pop();
				lastValidIndex = i;
				break;
			case "INSIDE_NUMBER":
				switch (char) {
					case "0":
					case "1":
					case "2":
					case "3":
					case "4":
					case "5":
					case "6":
					case "7":
					case "8":
					case "9":
						lastValidIndex = i;
						break;
					case "e":
					case "E":
					case "-":
					case ".": break;
					case ",":
						stack.pop();
						if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") processAfterArrayValue(char, i);
						if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") processAfterObjectValue(char, i);
						break;
					case "}":
						stack.pop();
						if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") processAfterObjectValue(char, i);
						break;
					case "]":
						stack.pop();
						if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") processAfterArrayValue(char, i);
						break;
					default: stack.pop();
				}
				break;
			case "INSIDE_LITERAL": {
				const partialLiteral = input.substring(literalStart, i + 1);
				if (!"false".startsWith(partialLiteral) && !"true".startsWith(partialLiteral) && !"null".startsWith(partialLiteral)) {
					stack.pop();
					if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") processAfterObjectValue(char, i);
					else if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") processAfterArrayValue(char, i);
				} else lastValidIndex = i;
				break;
			}
		}
	}
	let result = input.slice(0, lastValidIndex + 1);
	for (let i = stack.length - 1; i >= 0; i--) switch (stack[i]) {
		case "INSIDE_STRING":
			result += "\"";
			break;
		case "INSIDE_OBJECT_KEY":
		case "INSIDE_OBJECT_AFTER_KEY":
		case "INSIDE_OBJECT_AFTER_COMMA":
		case "INSIDE_OBJECT_START":
		case "INSIDE_OBJECT_BEFORE_VALUE":
		case "INSIDE_OBJECT_AFTER_VALUE":
			result += "}";
			break;
		case "INSIDE_ARRAY_START":
		case "INSIDE_ARRAY_AFTER_COMMA":
		case "INSIDE_ARRAY_AFTER_VALUE":
			result += "]";
			break;
		case "INSIDE_LITERAL": {
			const partialLiteral = input.substring(literalStart, input.length);
			if ("true".startsWith(partialLiteral)) result += "true".slice(partialLiteral.length);
			else if ("false".startsWith(partialLiteral)) result += "false".slice(partialLiteral.length);
			else if ("null".startsWith(partialLiteral)) result += "null".slice(partialLiteral.length);
		}
	}
	return result;
}
async function parsePartialJson(jsonText) {
	if (jsonText === void 0) return {
		value: void 0,
		state: "undefined-input"
	};
	let result = await safeParseJSON({ text: jsonText });
	if (result.success) return {
		value: result.value,
		state: "successful-parse"
	};
	result = await safeParseJSON({ text: fixJson(jsonText) });
	if (result.success) return {
		value: result.value,
		state: "repaired-parse"
	};
	return {
		value: void 0,
		state: "failed-parse"
	};
}
function isDataUIPart(part) {
	return part.type.startsWith("data-");
}
function isTextUIPart(part) {
	return part.type === "text";
}
function isFileUIPart(part) {
	return part.type === "file";
}
function isReasoningUIPart(part) {
	return part.type === "reasoning";
}
function isToolUIPart(part) {
	return part.type.startsWith("tool-");
}
function isDynamicToolUIPart(part) {
	return part.type === "dynamic-tool";
}
function isToolOrDynamicToolUIPart(part) {
	return isToolUIPart(part) || isDynamicToolUIPart(part);
}
function getToolName(part) {
	return part.type.split("-").slice(1).join("-");
}
function getToolOrDynamicToolName(part) {
	return isDynamicToolUIPart(part) ? part.toolName : getToolName(part);
}
function createStreamingUIMessageState({ lastMessage, messageId }) {
	var _a16;
	const message = (lastMessage == null ? void 0 : lastMessage.role) === "assistant" ? lastMessage : {
		id: messageId,
		metadata: void 0,
		role: "assistant",
		parts: []
	};
	const partialToolCalls = createIdMap();
	const lastStepStartIndex = message.parts.findLastIndex((part) => part.type === "step-start");
	let staticToolIndex = 0;
	for (const part of message.parts.slice(lastStepStartIndex + 1)) {
		if (!isToolOrDynamicToolUIPart(part)) continue;
		const index = staticToolIndex;
		if (isToolUIPart(part)) staticToolIndex++;
		if (part.state !== "input-streaming") continue;
		partialToolCalls[part.toolCallId] = {
			text: (_a16 = part.rawInput) != null ? _a16 : "",
			index,
			toolName: isDynamicToolUIPart(part) ? part.toolName : getToolName(part),
			dynamic: isDynamicToolUIPart(part)
		};
	}
	return {
		message,
		activeTextParts: createIdMap(),
		activeReasoningParts: createIdMap(),
		partialToolCalls
	};
}
function processUIMessageStream({ stream, messageMetadataSchema, dataPartSchemas, runUpdateMessageJob, onError, onToolCall, onData, resetStateOnMessageIdChange = false }) {
	return stream.pipeThrough(new TransformStream({ async transform(chunk, controller) {
		await runUpdateMessageJob(async ({ state, write }) => {
			var _a16, _b, _c, _d;
			function getCurrentStepParts() {
				const parts = state.message.parts;
				let currentStepStartIndex = parts.length - 1;
				while (currentStepStartIndex >= 0 && parts[currentStepStartIndex].type !== "step-start") currentStepStartIndex--;
				return parts.slice(currentStepStartIndex + 1);
			}
			function getCurrentStepToolInvocations() {
				return getCurrentStepParts().filter(isToolUIPart);
			}
			function getToolInvocation(toolCallId) {
				let toolInvocation = getCurrentStepToolInvocations().find((invocation) => invocation.toolCallId === toolCallId);
				if (toolInvocation == null) {
					const parts = state.message.parts;
					for (let i = parts.length - 1; i >= 0; i--) {
						const part = parts[i];
						if (isToolUIPart(part) && part.toolCallId === toolCallId) {
							toolInvocation = part;
							break;
						}
					}
				}
				if (toolInvocation == null) throw new Error("tool-output-error must be preceded by a tool-input-available");
				return toolInvocation;
			}
			function getDynamicToolInvocation(toolCallId) {
				let toolInvocation = getCurrentStepParts().filter((part) => part.type === "dynamic-tool").find((invocation) => invocation.toolCallId === toolCallId);
				if (toolInvocation == null) {
					const parts = state.message.parts;
					for (let i = parts.length - 1; i >= 0; i--) {
						const part = parts[i];
						if (part.type === "dynamic-tool" && part.toolCallId === toolCallId) {
							toolInvocation = part;
							break;
						}
					}
				}
				if (toolInvocation == null) throw new Error("tool-output-error must be preceded by a tool-input-available");
				return toolInvocation;
			}
			function updateToolPart(options, existingPart) {
				var _a17;
				const part = existingPart != null ? existingPart : getCurrentStepParts().find((part2) => isToolUIPart(part2) && part2.toolCallId === options.toolCallId);
				const anyOptions = options;
				const anyPart = part;
				if (part != null) {
					part.state = options.state;
					anyPart.input = anyOptions.input;
					anyPart.output = anyOptions.output;
					anyPart.errorText = anyOptions.errorText;
					anyPart.rawInput = anyOptions.rawInput;
					anyPart.preliminary = anyOptions.preliminary;
					anyPart.providerExecuted = (_a17 = anyOptions.providerExecuted) != null ? _a17 : part.providerExecuted;
					if (anyOptions.providerMetadata != null && part.state === "input-available") part.callProviderMetadata = anyOptions.providerMetadata;
				} else state.message.parts.push({
					type: `tool-${options.toolName}`,
					toolCallId: options.toolCallId,
					state: options.state,
					input: anyOptions.input,
					output: anyOptions.output,
					rawInput: anyOptions.rawInput,
					errorText: anyOptions.errorText,
					providerExecuted: anyOptions.providerExecuted,
					preliminary: anyOptions.preliminary,
					...anyOptions.providerMetadata != null ? { callProviderMetadata: anyOptions.providerMetadata } : {}
				});
			}
			function updateDynamicToolPart(options, existingPart) {
				var _a17;
				const part = existingPart != null ? existingPart : getCurrentStepParts().find((part2) => part2.type === "dynamic-tool" && part2.toolCallId === options.toolCallId);
				const anyOptions = options;
				const anyPart = part;
				if (part != null) {
					part.state = options.state;
					anyPart.toolName = options.toolName;
					anyPart.input = anyOptions.input;
					anyPart.output = anyOptions.output;
					anyPart.errorText = anyOptions.errorText;
					anyPart.rawInput = anyOptions.rawInput;
					anyPart.preliminary = anyOptions.preliminary;
					anyPart.providerExecuted = (_a17 = anyOptions.providerExecuted) != null ? _a17 : part.providerExecuted;
					if (anyOptions.providerMetadata != null && part.state === "input-available") part.callProviderMetadata = anyOptions.providerMetadata;
				} else state.message.parts.push({
					type: "dynamic-tool",
					toolName: options.toolName,
					toolCallId: options.toolCallId,
					state: options.state,
					input: anyOptions.input,
					output: anyOptions.output,
					errorText: anyOptions.errorText,
					preliminary: anyOptions.preliminary,
					providerExecuted: anyOptions.providerExecuted,
					...anyOptions.providerMetadata != null ? { callProviderMetadata: anyOptions.providerMetadata } : {}
				});
			}
			async function updateMessageMetadata(metadata) {
				if (metadata != null) {
					const mergedMetadata = state.message.metadata != null ? mergeObjects(state.message.metadata, metadata) : metadata;
					if (messageMetadataSchema != null) await validateTypes({
						value: mergedMetadata,
						schema: messageMetadataSchema
					});
					state.message.metadata = mergedMetadata;
				}
			}
			switch (chunk.type) {
				case "text-start": {
					const textPart = {
						type: "text",
						text: "",
						providerMetadata: chunk.providerMetadata,
						state: "streaming"
					};
					state.activeTextParts[chunk.id] = textPart;
					state.message.parts.push(textPart);
					write();
					break;
				}
				case "text-delta": {
					const textPart = state.activeTextParts[chunk.id];
					textPart.text += chunk.delta;
					textPart.providerMetadata = (_a16 = chunk.providerMetadata) != null ? _a16 : textPart.providerMetadata;
					write();
					break;
				}
				case "text-end": {
					const textPart = state.activeTextParts[chunk.id];
					textPart.state = "done";
					textPart.providerMetadata = (_b = chunk.providerMetadata) != null ? _b : textPart.providerMetadata;
					delete state.activeTextParts[chunk.id];
					write();
					break;
				}
				case "reasoning-start": {
					const reasoningPart = {
						type: "reasoning",
						id: chunk.id,
						text: "",
						providerMetadata: chunk.providerMetadata,
						state: "streaming"
					};
					state.activeReasoningParts[chunk.id] = reasoningPart;
					state.message.parts.push(reasoningPart);
					write();
					break;
				}
				case "reasoning-delta": {
					const reasoningPart = state.activeReasoningParts[chunk.id];
					reasoningPart.text += chunk.delta;
					reasoningPart.providerMetadata = (_c = chunk.providerMetadata) != null ? _c : reasoningPart.providerMetadata;
					write();
					break;
				}
				case "reasoning-end": {
					const reasoningPart = state.activeReasoningParts[chunk.id];
					reasoningPart.providerMetadata = (_d = chunk.providerMetadata) != null ? _d : reasoningPart.providerMetadata;
					reasoningPart.state = "done";
					delete state.activeReasoningParts[chunk.id];
					write();
					break;
				}
				case "file":
					state.message.parts.push({
						type: "file",
						mediaType: chunk.mediaType,
						url: chunk.url
					});
					write();
					break;
				case "source-url":
					state.message.parts.push({
						type: "source-url",
						sourceId: chunk.sourceId,
						url: chunk.url,
						title: chunk.title,
						providerMetadata: chunk.providerMetadata
					});
					write();
					break;
				case "source-document":
					state.message.parts.push({
						type: "source-document",
						sourceId: chunk.sourceId,
						mediaType: chunk.mediaType,
						title: chunk.title,
						filename: chunk.filename,
						providerMetadata: chunk.providerMetadata
					});
					write();
					break;
				case "tool-input-start": {
					const toolInvocations = getCurrentStepParts().filter(isToolUIPart);
					state.partialToolCalls[chunk.toolCallId] = {
						text: "",
						toolName: chunk.toolName,
						index: toolInvocations.length,
						dynamic: chunk.dynamic
					};
					if (chunk.dynamic) updateDynamicToolPart({
						toolCallId: chunk.toolCallId,
						toolName: chunk.toolName,
						state: "input-streaming",
						input: void 0,
						providerExecuted: chunk.providerExecuted
					});
					else updateToolPart({
						toolCallId: chunk.toolCallId,
						toolName: chunk.toolName,
						state: "input-streaming",
						input: void 0,
						providerExecuted: chunk.providerExecuted
					});
					write();
					break;
				}
				case "tool-input-delta": {
					const partialToolCall = state.partialToolCalls[chunk.toolCallId];
					partialToolCall.text += chunk.inputTextDelta;
					const { value: partialArgs } = await parsePartialJson(partialToolCall.text);
					if (partialToolCall.dynamic) updateDynamicToolPart({
						toolCallId: chunk.toolCallId,
						toolName: partialToolCall.toolName,
						state: "input-streaming",
						input: partialArgs,
						rawInput: partialToolCall.text
					});
					else updateToolPart({
						toolCallId: chunk.toolCallId,
						toolName: partialToolCall.toolName,
						state: "input-streaming",
						input: partialArgs,
						rawInput: partialToolCall.text
					});
					write();
					break;
				}
				case "tool-input-available":
					if (chunk.dynamic) updateDynamicToolPart({
						toolCallId: chunk.toolCallId,
						toolName: chunk.toolName,
						state: "input-available",
						input: chunk.input,
						providerExecuted: chunk.providerExecuted,
						providerMetadata: chunk.providerMetadata
					});
					else updateToolPart({
						toolCallId: chunk.toolCallId,
						toolName: chunk.toolName,
						state: "input-available",
						input: chunk.input,
						providerExecuted: chunk.providerExecuted,
						providerMetadata: chunk.providerMetadata
					});
					write();
					if (onToolCall && !chunk.providerExecuted) await onToolCall({ toolCall: chunk });
					break;
				case "tool-input-error":
					if (chunk.dynamic) updateDynamicToolPart({
						toolCallId: chunk.toolCallId,
						toolName: chunk.toolName,
						state: "output-error",
						input: chunk.input,
						errorText: chunk.errorText,
						providerExecuted: chunk.providerExecuted,
						providerMetadata: chunk.providerMetadata
					});
					else updateToolPart({
						toolCallId: chunk.toolCallId,
						toolName: chunk.toolName,
						state: "output-error",
						input: void 0,
						rawInput: chunk.input,
						errorText: chunk.errorText,
						providerExecuted: chunk.providerExecuted,
						providerMetadata: chunk.providerMetadata
					});
					write();
					break;
				case "tool-output-available":
					if (chunk.dynamic) {
						const toolInvocation = getDynamicToolInvocation(chunk.toolCallId);
						updateDynamicToolPart({
							toolCallId: chunk.toolCallId,
							toolName: toolInvocation.toolName,
							state: "output-available",
							input: toolInvocation.input,
							output: chunk.output,
							preliminary: chunk.preliminary
						}, toolInvocation);
					} else {
						const toolInvocation = getToolInvocation(chunk.toolCallId);
						updateToolPart({
							toolCallId: chunk.toolCallId,
							toolName: getToolName(toolInvocation),
							state: "output-available",
							input: toolInvocation.input,
							output: chunk.output,
							providerExecuted: chunk.providerExecuted,
							preliminary: chunk.preliminary
						}, toolInvocation);
					}
					write();
					break;
				case "tool-output-error":
					if (chunk.dynamic) {
						const toolInvocation = getDynamicToolInvocation(chunk.toolCallId);
						updateDynamicToolPart({
							toolCallId: chunk.toolCallId,
							toolName: toolInvocation.toolName,
							state: "output-error",
							input: toolInvocation.input,
							errorText: chunk.errorText,
							providerExecuted: chunk.providerExecuted
						}, toolInvocation);
					} else {
						const toolInvocation = getToolInvocation(chunk.toolCallId);
						updateToolPart({
							toolCallId: chunk.toolCallId,
							toolName: getToolName(toolInvocation),
							state: "output-error",
							input: toolInvocation.input,
							rawInput: toolInvocation.rawInput,
							errorText: chunk.errorText,
							providerExecuted: chunk.providerExecuted
						}, toolInvocation);
					}
					write();
					break;
				case "start-step":
					state.message.parts.push({ type: "step-start" });
					break;
				case "finish-step":
					state.activeTextParts = createIdMap();
					state.activeReasoningParts = createIdMap();
					break;
				case "start":
					if (resetStateOnMessageIdChange && chunk.messageId != null && chunk.messageId !== state.message.id) Object.assign(state, createStreamingUIMessageState({
						lastMessage: void 0,
						messageId: chunk.messageId
					}), { finishReason: void 0 });
					if (chunk.messageId != null) state.message.id = chunk.messageId;
					await updateMessageMetadata(chunk.messageMetadata);
					if (chunk.messageId != null || chunk.messageMetadata != null) write({ updateStatus: false });
					break;
				case "finish":
					if (chunk.finishReason != null) state.finishReason = chunk.finishReason;
					await updateMessageMetadata(chunk.messageMetadata);
					if (chunk.messageMetadata != null) write();
					break;
				case "message-metadata":
					await updateMessageMetadata(chunk.messageMetadata);
					if (chunk.messageMetadata != null) write();
					break;
				case "error":
					onError?.(new Error(chunk.errorText));
					break;
				default: if (isDataUIMessageChunk(chunk)) {
					if ((dataPartSchemas == null ? void 0 : dataPartSchemas[chunk.type]) != null) await validateTypes({
						value: chunk.data,
						schema: dataPartSchemas[chunk.type]
					});
					const dataChunk = chunk;
					if (dataChunk.transient) {
						onData?.(dataChunk);
						break;
					}
					const existingUIPart = dataChunk.id != null ? state.message.parts.find((chunkArg) => dataChunk.type === chunkArg.type && dataChunk.id === chunkArg.id) : void 0;
					if (existingUIPart != null) existingUIPart.data = dataChunk.data;
					else state.message.parts.push(dataChunk);
					onData?.(dataChunk);
					write();
				}
			}
			controller.enqueue(chunk);
		});
	} }));
}
function handleUIMessageStreamFinish({ messageId, originalMessages = [], onFinish, onError, stream, getOutcome }) {
	let lastMessage = originalMessages == null ? void 0 : originalMessages[originalMessages.length - 1];
	if ((lastMessage == null ? void 0 : lastMessage.role) !== "assistant") lastMessage = void 0;
	else messageId = lastMessage.id;
	let isAborted = false;
	let hasProcessingFailure = false;
	let processingError;
	const recordProcessingFailure = (error) => {
		hasProcessingFailure = true;
		processingError = error;
	};
	const idInjectedStream = stream.pipeThrough(new TransformStream({ transform(chunk, controller) {
		try {
			let outputChunk = chunk;
			if (chunk.type === "start") {
				const startChunk = chunk;
				if (startChunk.messageId == null && messageId != null) outputChunk = {
					...startChunk,
					messageId
				};
			}
			if (chunk.type === "abort") isAborted = true;
			controller.enqueue(outputChunk);
		} catch (error) {
			recordProcessingFailure(error);
			throw error;
		}
	} }));
	if (onFinish == null) return idInjectedStream;
	const state = createStreamingUIMessageState({
		lastMessage: lastMessage ? structuredClone(lastMessage) : void 0,
		messageId: messageId != null ? messageId : ""
	});
	const runUpdateMessageJob = async (job) => {
		try {
			await job({
				state,
				write: () => {}
			});
		} catch (error) {
			recordProcessingFailure(error);
			throw error;
		}
	};
	let finishCalled = false;
	const callOnFinish = async () => {
		var _a16;
		if (finishCalled || !onFinish) return;
		finishCalled = true;
		const isContinuation = state.message.id === (lastMessage == null ? void 0 : lastMessage.id);
		const declaredOutcome = (_a16 = getOutcome == null ? void 0 : getOutcome()) != null ? _a16 : { status: "unknown" };
		const outcome = hasProcessingFailure ? {
			status: "failed",
			error: processingError
		} : declaredOutcome.status === "unknown" && isAborted ? { status: "aborted" } : declaredOutcome;
		await onFinish({
			isAborted: isAborted || outcome.status === "aborted",
			isContinuation,
			outcome,
			responseMessage: state.message,
			messages: [...isContinuation ? originalMessages.slice(0, -1) : originalMessages, state.message],
			finishReason: state.finishReason
		});
	};
	return processUIMessageStream({
		stream: idInjectedStream,
		runUpdateMessageJob,
		onError
	}).pipeThrough(new TransformStream({
		transform(chunk, controller) {
			controller.enqueue(chunk);
		},
		async cancel() {
			await callOnFinish();
		},
		async flush() {
			await callOnFinish();
		}
	}));
}
function pipeUIMessageStreamToResponse({ response, status, statusText, headers, stream, keepAliveMs, consumeSseStream }) {
	let sseStream = createSseStreamWithKeepAlive({
		stream: stream.pipeThrough(new JsonToSseTransformStream()),
		keepAliveMs
	});
	if (consumeSseStream) {
		const [stream1, stream2] = sseStream.tee();
		sseStream = stream1;
		consumeSseStream({ stream: stream2 });
	}
	return writeToServerResponse({
		response,
		status,
		statusText,
		headers: Object.fromEntries(prepareHeaders(headers, UI_MESSAGE_STREAM_HEADERS).entries()),
		stream: sseStream.pipeThrough(new TextEncoderStream())
	});
}
function createAsyncIterableStream(source) {
	const stream = source.pipeThrough(new TransformStream());
	stream[Symbol.asyncIterator] = function() {
		const reader = this.getReader();
		let finished = false;
		async function cleanup(cancelStream) {
			var _a16;
			finished = true;
			try {
				if (cancelStream) await ((_a16 = reader.cancel) == null ? void 0 : _a16.call(reader));
			} finally {
				try {
					reader.releaseLock();
				} catch (e) {}
			}
		}
		return {
			/**
			* Reads the next chunk from the stream.
			* @returns A promise resolving to the next IteratorResult.
			*/
			async next() {
				if (finished) return {
					done: true,
					value: void 0
				};
				const { done, value } = await reader.read();
				if (done) {
					await cleanup(true);
					return {
						done: true,
						value: void 0
					};
				}
				return {
					done: false,
					value
				};
			},
			/**
			* Called on early exit (e.g., break from for-await).
			* Ensures the stream is cancelled and resources are released.
			* @returns A promise resolving to a completed IteratorResult.
			*/
			async return() {
				await cleanup(true);
				return {
					done: true,
					value: void 0
				};
			},
			/**
			* Called on early exit with error.
			* Ensures the stream is cancelled and resources are released, then rethrows the error.
			* @param err The error to throw.
			* @returns A promise that rejects with the provided error.
			*/
			async throw(err) {
				await cleanup(true);
				throw err;
			}
		};
	};
	return stream;
}
async function consumeStream({ stream, onError, abortSignal }) {
	const reader = stream.getReader();
	let cancelPromise;
	const cancelOnAbort = () => {
		cancelPromise ??= reader.cancel().catch(() => {});
	};
	if (abortSignal == null ? void 0 : abortSignal.aborted) cancelOnAbort();
	else abortSignal?.addEventListener("abort", cancelOnAbort, { once: true });
	try {
		while (true) {
			const { done } = await reader.read();
			if (done) break;
		}
	} catch (error) {
		onError?.(error);
	} finally {
		await cancelPromise;
		abortSignal?.removeEventListener("abort", cancelOnAbort);
		reader.releaseLock();
	}
}
function createResolvablePromise() {
	let resolve2;
	let reject;
	return {
		promise: new Promise((res, rej) => {
			resolve2 = res;
			reject = rej;
		}),
		resolve: resolve2,
		reject
	};
}
function createStitchableStream() {
	let innerStreams = [];
	let controller = null;
	let isClosed = false;
	let waitForNewStream = createResolvablePromise();
	const terminate = () => {
		isClosed = true;
		waitForNewStream.resolve();
		innerStreams.forEach(({ reader }) => reader.cancel());
		innerStreams = [];
		controller?.close();
	};
	const processPull = async () => {
		var _a16, _b;
		if (isClosed && innerStreams.length === 0) {
			controller?.close();
			return;
		}
		if (innerStreams.length === 0) {
			waitForNewStream = createResolvablePromise();
			await waitForNewStream.promise;
			return processPull();
		}
		try {
			const { value, done } = await innerStreams[0].reader.read();
			if (done) {
				innerStreams.shift();
				if (innerStreams.length > 0) await processPull();
				else if (isClosed) controller?.close();
			} else controller?.enqueue(value);
		} catch (error) {
			(_b = (_a16 = innerStreams[0]).onError) == null || _b.call(_a16, error);
			controller?.error(error);
			innerStreams.shift();
			terminate();
		}
	};
	return {
		stream: new ReadableStream({
			start(controllerParam) {
				controller = controllerParam;
			},
			pull: processPull,
			async cancel() {
				for (const { reader } of innerStreams) await reader.cancel();
				innerStreams = [];
				isClosed = true;
			}
		}),
		addStream: (innerStream, callbacks) => {
			if (isClosed) throw new Error("Cannot add inner stream: outer stream is closed");
			innerStreams.push({
				reader: innerStream.getReader(),
				...callbacks
			});
			waitForNewStream.resolve();
		},
		/**
		* Gracefully close the outer stream. This will let the inner streams
		* finish processing and then close the outer stream.
		*/
		close: () => {
			isClosed = true;
			waitForNewStream.resolve();
			if (innerStreams.length === 0) controller?.close();
		},
		/**
		* Immediately close the outer stream. This will cancel all inner streams
		* and close the outer stream.
		*/
		terminate
	};
}
async function notify(options) {
	for (const callback of asArray(options.callbacks)) try {
		await callback(options.event);
	} catch (_ignored) {}
}
function now() {
	var _a16, _b;
	return (_b = (_a16 = globalThis == null ? void 0 : globalThis.performance) == null ? void 0 : _a16.now()) != null ? _b : Date.now();
}
function runToolsTransformation({ tools, generatorStream, tracer, telemetry, system, messages, abortSignal, repairToolCall, experimental_context }) {
	let toolResultsStreamController = null;
	let toolResultsStreamClosed = false;
	const toolResultsStream = new ReadableStream({
		start(controller) {
			toolResultsStreamController = controller;
		},
		cancel() {
			toolResultsStreamClosed = true;
		}
	});
	function enqueueToolResult(chunk) {
		if (toolResultsStreamClosed) return;
		try {
			toolResultsStreamController.enqueue(chunk);
		} catch (e) {
			toolResultsStreamClosed = true;
		}
	}
	function closeToolResultsStream() {
		if (toolResultsStreamClosed) return;
		toolResultsStreamClosed = true;
		try {
			toolResultsStreamController.close();
		} catch (e) {}
	}
	const outstandingToolResults = /* @__PURE__ */ new Set();
	const pendingToolCalls = [];
	const toolInputs = /* @__PURE__ */ new Map();
	let canClose = false;
	let finishChunk = void 0;
	function attemptClose() {
		if (canClose && outstandingToolResults.size === 0) {
			if (finishChunk != null) enqueueToolResult(finishChunk);
			closeToolResultsStream();
		}
	}
	function executePendingToolCall(toolCall) {
		const tool2 = tools[toolCall.toolName];
		const toolExecutionId = generateId();
		outstandingToolResults.add(toolExecutionId);
		recordSpan({
			name: "ai.toolCall",
			attributes: selectTelemetryAttributes({
				telemetry,
				attributes: {
					...assembleOperationName({
						operationId: "ai.toolCall",
						telemetry
					}),
					...getTelemetryMetadataAttributes(telemetry),
					"ai.toolCall.name": toolCall.toolName,
					"ai.toolCall.id": toolCall.toolCallId,
					"ai.toolCall.args": { output: () => JSON.stringify(toolCall.input) }
				}
			}),
			tracer,
			fn: async (span) => {
				let output;
				try {
					const stream = executeTool({
						execute: tool2.execute.bind(tool2),
						input: toolCall.input,
						options: {
							toolCallId: toolCall.toolCallId,
							messages,
							abortSignal,
							experimental_context
						}
					});
					for await (const part of stream) {
						enqueueToolResult({
							...toolCall,
							type: "tool-result",
							output: part.output,
							...part.type === "preliminary" && { preliminary: true }
						});
						if (part.type === "final") output = part.output;
					}
				} catch (error) {
					recordErrorOnSpan(span, error);
					enqueueToolResult({
						...toolCall,
						type: "tool-error",
						error
					});
					outstandingToolResults.delete(toolExecutionId);
					attemptClose();
					return;
				}
				outstandingToolResults.delete(toolExecutionId);
				attemptClose();
				try {
					span.setAttributes(selectTelemetryAttributes({
						telemetry,
						attributes: { "ai.toolCall.result": { output: () => JSON.stringify(output) } }
					}));
				} catch (ignored) {}
			}
		});
	}
	const activeToolCallToolNames = /* @__PURE__ */ new Map();
	const forwardStream = new TransformStream({
		async transform(chunk, controller) {
			var _a16, _b, _c, _d;
			const chunkType = chunk.type;
			switch (chunkType) {
				case "stream-start":
				case "text-start":
				case "text-delta":
				case "text-end":
				case "reasoning-start":
				case "reasoning-delta":
				case "reasoning-end":
				case "source":
				case "response-metadata":
				case "error":
				case "raw":
					controller.enqueue(chunk);
					break;
				case "tool-input-start":
					activeToolCallToolNames.set(chunk.id, chunk.toolName);
					await ((_b = (_a16 = tools == null ? void 0 : tools[chunk.toolName]) == null ? void 0 : _a16.onInputStart) == null ? void 0 : _b.call(_a16, {
						toolCallId: chunk.id,
						messages,
						abortSignal,
						experimental_context
					}));
					controller.enqueue(chunk);
					break;
				case "tool-input-delta": {
					const toolName = activeToolCallToolNames.get(chunk.id);
					if (toolName != null) await ((_d = (_c = tools == null ? void 0 : tools[toolName]) == null ? void 0 : _c.onInputDelta) == null ? void 0 : _d.call(_c, {
						inputTextDelta: chunk.delta,
						toolCallId: chunk.id,
						messages,
						abortSignal,
						experimental_context
					}));
					controller.enqueue(chunk);
					break;
				}
				case "tool-input-end":
					activeToolCallToolNames.delete(chunk.id);
					controller.enqueue(chunk);
					break;
				case "file":
					controller.enqueue({
						type: "file",
						file: new DefaultGeneratedFileWithType({
							data: chunk.data,
							mediaType: chunk.mediaType
						})
					});
					break;
				case "finish":
					finishChunk = {
						type: "finish",
						finishReason: chunk.finishReason,
						usage: chunk.usage,
						providerMetadata: chunk.providerMetadata
					};
					if (isToolExecutionAllowedFinishReason(chunk.finishReason)) for (const toolCall of pendingToolCalls.splice(0)) executePendingToolCall(toolCall);
					else pendingToolCalls.length = 0;
					break;
				case "tool-call":
					try {
						const toolCall = await parseToolCall({
							toolCall: chunk,
							tools,
							repairToolCall,
							system,
							messages
						});
						controller.enqueue(toolCall);
						if (toolCall.invalid) {
							enqueueToolResult({
								type: "tool-error",
								toolCallId: toolCall.toolCallId,
								toolName: toolCall.toolName,
								input: toolCall.input,
								error: getErrorMessage$1(toolCall.error),
								dynamic: true
							});
							break;
						}
						const tool2 = tools[toolCall.toolName];
						toolInputs.set(toolCall.toolCallId, toolCall.input);
						if (tool2.onInputAvailable != null) await tool2.onInputAvailable({
							input: toolCall.input,
							toolCallId: toolCall.toolCallId,
							messages,
							abortSignal,
							experimental_context
						});
						if (tool2.execute != null && toolCall.providerExecuted !== true) pendingToolCalls.push({ ...toolCall });
					} catch (error) {
						enqueueToolResult({
							type: "error",
							error
						});
					}
					break;
				case "tool-result": {
					const toolName = chunk.toolName;
					if (chunk.isError) enqueueToolResult({
						type: "tool-error",
						toolCallId: chunk.toolCallId,
						toolName,
						input: toolInputs.get(chunk.toolCallId),
						providerExecuted: chunk.providerExecuted,
						error: chunk.result
					});
					else controller.enqueue({
						type: "tool-result",
						toolCallId: chunk.toolCallId,
						toolName,
						input: toolInputs.get(chunk.toolCallId),
						output: chunk.result,
						providerExecuted: chunk.providerExecuted
					});
					break;
				}
				default: throw new Error(`Unhandled chunk type: ${chunkType}`);
			}
		},
		flush() {
			canClose = true;
			attemptClose();
		}
	});
	return new ReadableStream({ async start(controller) {
		return Promise.all([generatorStream.pipeThrough(forwardStream).pipeTo(new WritableStream({
			write(chunk) {
				controller.enqueue(chunk);
			},
			close() {}
		})), toolResultsStream.pipeTo(new WritableStream({
			write(chunk) {
				controller.enqueue(chunk);
			},
			close() {
				controller.close();
			}
		}))]);
	} });
}
var originalGenerateId2 = createIdGenerator({
	prefix: "aitxt",
	size: 24
});
function streamText$1({ model, tools, toolChoice, system, prompt, messages, allowSystemInMessages, maxRetries, abortSignal, headers, stopWhen = stepCountIs(1), experimental_output: output, experimental_telemetry: telemetry, prepareStep, providerOptions, experimental_activeTools, activeTools = experimental_activeTools, experimental_repairToolCall: repairToolCall, experimental_transform: transform, experimental_download: download2, includeRawChunks = false, onChunk, onError = ({ error }) => {
	console.error(error);
}, onFinish, onAbort, onStepFinish, experimental_context, _internal: { now: now2 = now, generateId: generateId3 = originalGenerateId2, currentDate = () => /* @__PURE__ */ new Date() } = {}, ...settings }) {
	return new DefaultStreamTextResult({
		model: resolveLanguageModel(model),
		telemetry,
		headers,
		settings,
		maxRetries,
		abortSignal,
		system,
		prompt,
		messages,
		allowSystemInMessages,
		tools,
		toolChoice,
		transforms: asArray(transform),
		activeTools,
		repairToolCall,
		stopConditions: asArray(stopWhen),
		output,
		providerOptions,
		prepareStep,
		includeRawChunks,
		onChunk,
		onError,
		onFinish,
		onAbort,
		onStepFinish,
		now: now2,
		currentDate,
		generateId: generateId3,
		experimental_context,
		download: download2
	});
}
function createOutputTransformStream(output) {
	if (!output) return new TransformStream({ transform(chunk, controller) {
		controller.enqueue({
			part: chunk,
			partialOutput: void 0
		});
	} });
	let firstTextChunkId = void 0;
	let text2 = "";
	let textChunk = "";
	let lastPublishedJson = "";
	function publishTextChunk({ controller, partialOutput = void 0 }) {
		controller.enqueue({
			part: {
				type: "text-delta",
				id: firstTextChunkId,
				text: textChunk
			},
			partialOutput
		});
		textChunk = "";
	}
	return new TransformStream({ async transform(chunk, controller) {
		if (chunk.type === "finish-step" && textChunk.length > 0) publishTextChunk({ controller });
		if (chunk.type !== "text-delta" && chunk.type !== "text-start" && chunk.type !== "text-end") {
			controller.enqueue({
				part: chunk,
				partialOutput: void 0
			});
			return;
		}
		if (firstTextChunkId == null) firstTextChunkId = chunk.id;
		else if (chunk.id !== firstTextChunkId) {
			controller.enqueue({
				part: chunk,
				partialOutput: void 0
			});
			return;
		}
		if (chunk.type === "text-start") {
			controller.enqueue({
				part: chunk,
				partialOutput: void 0
			});
			return;
		}
		if (chunk.type === "text-end") {
			if (textChunk.length > 0) publishTextChunk({ controller });
			controller.enqueue({
				part: chunk,
				partialOutput: void 0
			});
			return;
		}
		text2 += chunk.text;
		textChunk += chunk.text;
		if (chunk.text.length === 0 && chunk.providerMetadata != null) {
			controller.enqueue({
				part: chunk,
				partialOutput: void 0
			});
			return;
		}
		const result = await output.parsePartial({ text: text2 });
		if (result != null) {
			const currentJson = JSON.stringify(result.partial);
			if (currentJson !== lastPublishedJson) {
				publishTextChunk({
					controller,
					partialOutput: result.partial
				});
				lastPublishedJson = currentJson;
			}
		}
	} });
}
var DefaultStreamTextResult = class {
	constructor({ model, telemetry, headers, settings, maxRetries: maxRetriesArg, abortSignal, system, prompt, messages, allowSystemInMessages, tools, toolChoice, transforms, activeTools, repairToolCall, stopConditions, output, providerOptions, prepareStep, includeRawChunks, now: now2, currentDate, generateId: generateId3, onChunk, onError, onFinish, onAbort, onStepFinish, experimental_context, download: download2 }) {
		this._totalUsage = new DelayedPromise();
		this._finishReason = new DelayedPromise();
		this._steps = new DelayedPromise();
		this.output = output;
		this.includeRawChunks = includeRawChunks;
		this.tools = tools;
		let stepFinish;
		let recordedContent = [];
		const recordedResponseMessages = [];
		let recordedFinishReason = void 0;
		let recordedTotalUsage = void 0;
		let recordedRequest = {};
		let recordedWarnings = [];
		const recordedSteps = [];
		let currentStepToolSet = tools;
		let rootSpan;
		let activeTextContent = createIdMap();
		let activeReasoningContent = createIdMap();
		const eventProcessor = new TransformStream({
			async transform(chunk, controller) {
				var _a16, _b, _c, _d;
				controller.enqueue(chunk);
				const { part } = chunk;
				if (part.type === "text-delta" || part.type === "reasoning-delta" || part.type === "source" || part.type === "tool-call" || part.type === "tool-result" || part.type === "tool-input-start" || part.type === "tool-input-delta" || part.type === "raw") await notify({
					event: { chunk: part },
					callbacks: onChunk
				});
				if (part.type === "error") await notify({
					event: { error: wrapGatewayError(part.error) },
					callbacks: onError
				});
				if (part.type === "text-start") {
					activeTextContent[part.id] = {
						type: "text",
						text: "",
						providerMetadata: part.providerMetadata
					};
					recordedContent.push(activeTextContent[part.id]);
				}
				if (part.type === "text-delta") {
					const activeText = activeTextContent[part.id];
					if (activeText == null) {
						controller.enqueue({
							part: {
								type: "error",
								error: `text part ${part.id} not found`
							},
							partialOutput: void 0
						});
						return;
					}
					activeText.text += part.text;
					activeText.providerMetadata = (_a16 = part.providerMetadata) != null ? _a16 : activeText.providerMetadata;
				}
				if (part.type === "text-end") {
					const activeText = activeTextContent[part.id];
					if (activeText == null) {
						controller.enqueue({
							part: {
								type: "error",
								error: `text part ${part.id} not found`
							},
							partialOutput: void 0
						});
						return;
					}
					activeText.providerMetadata = (_b = part.providerMetadata) != null ? _b : activeText.providerMetadata;
					delete activeTextContent[part.id];
				}
				if (part.type === "reasoning-start") {
					activeReasoningContent[part.id] = {
						type: "reasoning",
						text: "",
						providerMetadata: part.providerMetadata
					};
					recordedContent.push(activeReasoningContent[part.id]);
				}
				if (part.type === "reasoning-delta") {
					const activeReasoning = activeReasoningContent[part.id];
					if (activeReasoning == null) {
						controller.enqueue({
							part: {
								type: "error",
								error: `reasoning part ${part.id} not found`
							},
							partialOutput: void 0
						});
						return;
					}
					activeReasoning.text += part.text;
					activeReasoning.providerMetadata = (_c = part.providerMetadata) != null ? _c : activeReasoning.providerMetadata;
				}
				if (part.type === "reasoning-end") {
					const activeReasoning = activeReasoningContent[part.id];
					if (activeReasoning == null) {
						controller.enqueue({
							part: {
								type: "error",
								error: `reasoning part ${part.id} not found`
							},
							partialOutput: void 0
						});
						return;
					}
					activeReasoning.providerMetadata = (_d = part.providerMetadata) != null ? _d : activeReasoning.providerMetadata;
					delete activeReasoningContent[part.id];
				}
				if (part.type === "file") recordedContent.push({
					type: "file",
					file: part.file
				});
				if (part.type === "source") recordedContent.push(part);
				if (part.type === "tool-call") recordedContent.push(part);
				if (part.type === "tool-result" && !part.preliminary) recordedContent.push(part);
				if (part.type === "tool-error") recordedContent.push(part);
				if (part.type === "start-step") {
					recordedContent = [];
					activeReasoningContent = createIdMap();
					activeTextContent = createIdMap();
					recordedRequest = part.request;
					recordedWarnings = part.warnings;
				}
				if (part.type === "finish-step") {
					const stepMessages = toResponseMessages({
						content: recordedContent,
						tools: currentStepToolSet
					});
					const currentStepResult = new DefaultStepResult({
						content: recordedContent,
						finishReason: part.finishReason,
						usage: part.usage,
						warnings: recordedWarnings,
						request: recordedRequest,
						response: {
							...part.response,
							messages: [...recordedResponseMessages, ...stepMessages]
						},
						providerMetadata: part.providerMetadata
					});
					await (onStepFinish == null ? void 0 : onStepFinish(currentStepResult));
					logWarnings(recordedWarnings);
					recordedSteps.push(currentStepResult);
					recordedContent = [];
					activeReasoningContent = createIdMap();
					activeTextContent = createIdMap();
					recordedResponseMessages.push(...stepMessages);
					stepFinish.resolve();
				}
				if (part.type === "finish") {
					recordedTotalUsage = part.totalUsage;
					recordedFinishReason = part.finishReason;
				}
			},
			async flush(controller) {
				try {
					if (recordedSteps.length === 0) {
						const error = new NoOutputGeneratedError({ message: "No output generated. Check the stream for errors." });
						self._finishReason.reject(error);
						self._totalUsage.reject(error);
						self._steps.reject(error);
						return;
					}
					const finishReason = recordedFinishReason != null ? recordedFinishReason : "unknown";
					const totalUsage = recordedTotalUsage != null ? recordedTotalUsage : {
						inputTokens: void 0,
						outputTokens: void 0,
						totalTokens: void 0
					};
					self._finishReason.resolve(finishReason);
					self._totalUsage.resolve(totalUsage);
					self._steps.resolve(recordedSteps);
					const finalStep = recordedSteps[recordedSteps.length - 1];
					await (onFinish == null ? void 0 : onFinish({
						finishReason,
						totalUsage,
						usage: finalStep.usage,
						content: finalStep.content,
						text: finalStep.text,
						reasoningText: finalStep.reasoningText,
						reasoning: finalStep.reasoning,
						files: finalStep.files,
						sources: finalStep.sources,
						toolCalls: finalStep.toolCalls,
						staticToolCalls: finalStep.staticToolCalls,
						dynamicToolCalls: finalStep.dynamicToolCalls,
						toolResults: finalStep.toolResults,
						staticToolResults: finalStep.staticToolResults,
						dynamicToolResults: finalStep.dynamicToolResults,
						request: finalStep.request,
						response: finalStep.response,
						warnings: finalStep.warnings,
						providerMetadata: finalStep.providerMetadata,
						steps: recordedSteps
					}));
					rootSpan.setAttributes(selectTelemetryAttributes({
						telemetry,
						attributes: {
							"ai.response.finishReason": finishReason,
							"ai.response.text": { output: () => finalStep.text },
							"ai.response.toolCalls": { output: () => {
								var _a16;
								return ((_a16 = finalStep.toolCalls) == null ? void 0 : _a16.length) ? JSON.stringify(finalStep.toolCalls) : void 0;
							} },
							"ai.response.providerMetadata": JSON.stringify(finalStep.providerMetadata),
							"ai.usage.inputTokens": totalUsage.inputTokens,
							"ai.usage.outputTokens": totalUsage.outputTokens,
							"ai.usage.totalTokens": totalUsage.totalTokens,
							"ai.usage.reasoningTokens": totalUsage.reasoningTokens,
							"ai.usage.cachedInputTokens": totalUsage.cachedInputTokens
						}
					}));
				} catch (error) {
					controller.error(error);
				} finally {
					rootSpan.end();
				}
			}
		});
		const stitchableStream = createStitchableStream();
		this.addStream = stitchableStream.addStream;
		this.closeStream = stitchableStream.close;
		const reader = stitchableStream.stream.getReader();
		let stream = new ReadableStream({
			async start(controller) {
				controller.enqueue({ type: "start" });
			},
			async pull(controller) {
				function abort() {
					onAbort?.({ steps: recordedSteps });
					controller.enqueue({ type: "abort" });
					controller.close();
				}
				try {
					const { done, value } = await reader.read();
					if (done) {
						controller.close();
						return;
					}
					if (abortSignal == null ? void 0 : abortSignal.aborted) {
						abort();
						return;
					}
					controller.enqueue(value);
				} catch (error) {
					if (isAbortError(error) && (abortSignal == null ? void 0 : abortSignal.aborted)) abort();
					else controller.error(error);
				}
			},
			cancel(reason) {
				return stitchableStream.stream.cancel(reason);
			}
		});
		for (const transform of transforms) stream = stream.pipeThrough(transform({
			tools,
			stopStream() {
				stitchableStream.terminate();
			}
		}));
		this.baseStream = stream.pipeThrough(createOutputTransformStream(output)).pipeThrough(eventProcessor);
		const { maxRetries, retry } = prepareRetries({
			maxRetries: maxRetriesArg,
			abortSignal
		});
		const tracer = getTracer(telemetry);
		const callSettings = prepareCallSettings(settings);
		const baseTelemetryAttributes = getBaseTelemetryAttributes({
			model,
			telemetry,
			headers,
			settings: {
				...callSettings,
				maxRetries
			}
		});
		const self = this;
		recordSpan({
			name: "ai.streamText",
			attributes: selectTelemetryAttributes({
				telemetry,
				attributes: {
					...assembleOperationName({
						operationId: "ai.streamText",
						telemetry
					}),
					...baseTelemetryAttributes,
					"ai.prompt": { input: () => JSON.stringify({
						system,
						prompt,
						messages
					}) }
				}
			}),
			tracer,
			endWhenDone: false,
			fn: async (rootSpanArg) => {
				rootSpan = rootSpanArg;
				async function streamStep({ currentStep, responseMessages, usage }) {
					var _a16, _b, _c, _d, _e;
					const includeRawChunks2 = self.includeRawChunks;
					stepFinish = new DelayedPromise();
					const initialPrompt = await standardizePrompt({
						system,
						prompt,
						messages,
						allowSystemInMessages
					});
					const stepInputMessages = [...initialPrompt.messages, ...responseMessages];
					const prepareStepResult = await (prepareStep == null ? void 0 : prepareStep({
						model,
						steps: recordedSteps,
						stepNumber: recordedSteps.length,
						messages: stepInputMessages
					}));
					const stepModel = resolveLanguageModel((_a16 = prepareStepResult == null ? void 0 : prepareStepResult.model) != null ? _a16 : model);
					const promptMessages = await convertToLanguageModelPrompt({
						prompt: {
							system: (_b = prepareStepResult == null ? void 0 : prepareStepResult.system) != null ? _b : initialPrompt.system,
							messages: (_c = prepareStepResult == null ? void 0 : prepareStepResult.messages) != null ? _c : stepInputMessages
						},
						supportedUrls: await stepModel.supportedUrls,
						download: download2
					});
					const stepActiveTools = (_d = prepareStepResult == null ? void 0 : prepareStepResult.activeTools) != null ? _d : activeTools;
					const stepToolSet = filterActiveTools({
						tools,
						activeTools: stepActiveTools
					});
					currentStepToolSet = stepToolSet;
					const { toolChoice: stepToolChoice, tools: stepTools } = prepareToolsAndToolChoice({
						tools,
						toolChoice: (_e = prepareStepResult == null ? void 0 : prepareStepResult.toolChoice) != null ? _e : toolChoice,
						activeTools: stepActiveTools
					});
					const { result: { stream: stream2, response, request }, doStreamSpan, startTimestampMs } = await retry(() => recordSpan({
						name: "ai.streamText.doStream",
						attributes: selectTelemetryAttributes({
							telemetry,
							attributes: {
								...assembleOperationName({
									operationId: "ai.streamText.doStream",
									telemetry
								}),
								...baseTelemetryAttributes,
								"ai.model.provider": stepModel.provider,
								"ai.model.id": stepModel.modelId,
								"ai.prompt.messages": { input: () => stringifyForTelemetry(promptMessages) },
								"ai.prompt.tools": { input: () => stepTools == null ? void 0 : stepTools.map((tool2) => JSON.stringify(tool2)) },
								"ai.prompt.toolChoice": { input: () => stepToolChoice != null ? JSON.stringify(stepToolChoice) : void 0 },
								"gen_ai.system": stepModel.provider,
								"gen_ai.request.model": stepModel.modelId,
								"gen_ai.request.frequency_penalty": callSettings.frequencyPenalty,
								"gen_ai.request.max_tokens": callSettings.maxOutputTokens,
								"gen_ai.request.presence_penalty": callSettings.presencePenalty,
								"gen_ai.request.stop_sequences": callSettings.stopSequences,
								"gen_ai.request.temperature": callSettings.temperature,
								"gen_ai.request.top_k": callSettings.topK,
								"gen_ai.request.top_p": callSettings.topP
							}
						}),
						tracer,
						endWhenDone: false,
						endOnError: true,
						fn: async (doStreamSpan2) => {
							return {
								startTimestampMs: now2(),
								doStreamSpan: doStreamSpan2,
								result: await stepModel.doStream({
									...callSettings,
									tools: stepTools,
									toolChoice: stepToolChoice,
									responseFormat: output == null ? void 0 : output.responseFormat,
									prompt: promptMessages,
									providerOptions,
									abortSignal,
									headers,
									includeRawChunks: includeRawChunks2
								})
							};
						}
					}));
					const streamWithToolResults = runToolsTransformation({
						tools: stepToolSet,
						generatorStream: stream2,
						tracer,
						telemetry,
						system,
						messages: stepInputMessages,
						repairToolCall,
						abortSignal,
						experimental_context
					});
					const stepRequest = request != null ? request : {};
					const stepToolCalls = [];
					const stepToolOutputs = [];
					let warnings;
					let stepFinishReason = "unknown";
					let stepUsage = {
						inputTokens: void 0,
						outputTokens: void 0,
						totalTokens: void 0
					};
					let stepProviderMetadata;
					let stepFirstChunk = true;
					let stepResponse = {
						id: generateId3(),
						timestamp: currentDate(),
						modelId: model.modelId
					};
					let activeText = "";
					self.addStream(streamWithToolResults.pipeThrough(new TransformStream({
						async transform(chunk, controller) {
							var _a17, _b2, _c2, _d2;
							if (chunk.type === "stream-start") {
								warnings = chunk.warnings;
								return;
							}
							if (stepFirstChunk) {
								const msToFirstChunk = now2() - startTimestampMs;
								stepFirstChunk = false;
								doStreamSpan.addEvent("ai.stream.firstChunk", { "ai.response.msToFirstChunk": msToFirstChunk });
								doStreamSpan.setAttributes({ "ai.response.msToFirstChunk": msToFirstChunk });
								controller.enqueue({
									type: "start-step",
									request: stepRequest,
									warnings: warnings != null ? warnings : []
								});
							}
							const chunkType = chunk.type;
							switch (chunkType) {
								case "text-start":
								case "text-end":
									controller.enqueue(chunk);
									break;
								case "text-delta":
									if (chunk.delta.length > 0 || chunk.providerMetadata != null) {
										controller.enqueue({
											type: "text-delta",
											id: chunk.id,
											text: chunk.delta,
											providerMetadata: chunk.providerMetadata
										});
										activeText += chunk.delta;
									}
									break;
								case "reasoning-start":
								case "reasoning-end":
									controller.enqueue(chunk);
									break;
								case "reasoning-delta":
									controller.enqueue({
										type: "reasoning-delta",
										id: chunk.id,
										text: chunk.delta,
										providerMetadata: chunk.providerMetadata
									});
									break;
								case "tool-call":
									controller.enqueue(chunk);
									stepToolCalls.push(chunk);
									break;
								case "tool-result":
									controller.enqueue(chunk);
									if (!chunk.preliminary) stepToolOutputs.push(chunk);
									break;
								case "tool-error":
									controller.enqueue(chunk);
									stepToolOutputs.push(chunk);
									break;
								case "response-metadata":
									stepResponse = {
										id: (_a17 = chunk.id) != null ? _a17 : stepResponse.id,
										timestamp: (_b2 = chunk.timestamp) != null ? _b2 : stepResponse.timestamp,
										modelId: (_c2 = chunk.modelId) != null ? _c2 : stepResponse.modelId
									};
									break;
								case "finish": {
									stepUsage = chunk.usage;
									stepFinishReason = chunk.finishReason;
									stepProviderMetadata = chunk.providerMetadata;
									const msToFinish = now2() - startTimestampMs;
									doStreamSpan.addEvent("ai.stream.finish");
									doStreamSpan.setAttributes({
										"ai.response.msToFinish": msToFinish,
										"ai.response.avgOutputTokensPerSecond": 1e3 * ((_d2 = stepUsage.outputTokens) != null ? _d2 : 0) / msToFinish
									});
									break;
								}
								case "file":
									controller.enqueue(chunk);
									break;
								case "source":
									controller.enqueue(chunk);
									break;
								case "tool-input-start": {
									const tool2 = stepToolSet == null ? void 0 : stepToolSet[chunk.toolName];
									controller.enqueue({
										...chunk,
										dynamic: (tool2 == null ? void 0 : tool2.type) === "dynamic"
									});
									break;
								}
								case "tool-input-end":
									controller.enqueue(chunk);
									break;
								case "tool-input-delta":
									controller.enqueue(chunk);
									break;
								case "error":
									controller.enqueue(chunk);
									stepFinishReason = "error";
									break;
								case "raw":
									if (includeRawChunks2) controller.enqueue(chunk);
									break;
								default: throw new Error(`Unknown chunk type: ${chunkType}`);
							}
						},
						async flush(controller) {
							const stepToolCallsJson = stepToolCalls.length > 0 ? JSON.stringify(stepToolCalls) : void 0;
							try {
								doStreamSpan.setAttributes(selectTelemetryAttributes({
									telemetry,
									attributes: {
										"ai.response.finishReason": stepFinishReason,
										"ai.response.text": { output: () => activeText },
										"ai.response.toolCalls": { output: () => stepToolCallsJson },
										"ai.response.id": stepResponse.id,
										"ai.response.model": stepResponse.modelId,
										"ai.response.timestamp": stepResponse.timestamp.toISOString(),
										"ai.response.providerMetadata": JSON.stringify(stepProviderMetadata),
										"ai.usage.inputTokens": stepUsage.inputTokens,
										"ai.usage.outputTokens": stepUsage.outputTokens,
										"ai.usage.totalTokens": stepUsage.totalTokens,
										"ai.usage.reasoningTokens": stepUsage.reasoningTokens,
										"ai.usage.cachedInputTokens": stepUsage.cachedInputTokens,
										"gen_ai.response.finish_reasons": [stepFinishReason],
										"gen_ai.response.id": stepResponse.id,
										"gen_ai.response.model": stepResponse.modelId,
										"gen_ai.usage.input_tokens": stepUsage.inputTokens,
										"gen_ai.usage.output_tokens": stepUsage.outputTokens
									}
								}));
							} catch (error) {} finally {
								doStreamSpan.end();
							}
							controller.enqueue({
								type: "finish-step",
								finishReason: stepFinishReason,
								usage: stepUsage,
								providerMetadata: stepProviderMetadata,
								response: {
									...stepResponse,
									headers: response == null ? void 0 : response.headers
								}
							});
							const combinedUsage = addLanguageModelUsage(usage, stepUsage);
							await stepFinish.promise;
							const clientToolCalls = stepToolCalls.filter((toolCall) => toolCall.providerExecuted !== true);
							const clientToolOutputs = stepToolOutputs.filter((toolOutput) => toolOutput.providerExecuted !== true);
							if (clientToolCalls.length > 0 && clientToolOutputs.length === clientToolCalls.length && !await isStopConditionMet({
								stopConditions,
								steps: recordedSteps
							})) {
								responseMessages.push(...toResponseMessages({
									content: recordedSteps[recordedSteps.length - 1].content,
									tools: stepToolSet
								}));
								try {
									await streamStep({
										currentStep: currentStep + 1,
										responseMessages,
										usage: combinedUsage
									});
								} catch (error) {
									controller.enqueue({
										type: "error",
										error
									});
									self.closeStream();
								}
							} else {
								controller.enqueue({
									type: "finish",
									finishReason: stepFinishReason,
									totalUsage: combinedUsage
								});
								self.closeStream();
							}
						}
					})));
				}
				await streamStep({
					currentStep: 0,
					responseMessages: [],
					usage: {
						inputTokens: void 0,
						outputTokens: void 0,
						totalTokens: void 0
					}
				});
			}
		}).catch((error) => {
			self.addStream(new ReadableStream({ start(controller) {
				controller.enqueue({
					type: "error",
					error
				});
				controller.close();
			} }));
			self.closeStream();
		});
	}
	get steps() {
		this.consumeStream();
		return this._steps.promise;
	}
	get finalStep() {
		return this.steps.then((steps) => steps[steps.length - 1]);
	}
	get content() {
		return this.finalStep.then((step) => step.content);
	}
	get warnings() {
		return this.finalStep.then((step) => step.warnings);
	}
	get providerMetadata() {
		return this.finalStep.then((step) => step.providerMetadata);
	}
	get text() {
		return this.finalStep.then((step) => step.text);
	}
	get reasoningText() {
		return this.finalStep.then((step) => step.reasoningText);
	}
	get reasoning() {
		return this.finalStep.then((step) => step.reasoning);
	}
	get sources() {
		return this.finalStep.then((step) => step.sources);
	}
	get files() {
		return this.finalStep.then((step) => step.files);
	}
	get toolCalls() {
		return this.finalStep.then((step) => step.toolCalls);
	}
	get staticToolCalls() {
		return this.finalStep.then((step) => step.staticToolCalls);
	}
	get dynamicToolCalls() {
		return this.finalStep.then((step) => step.dynamicToolCalls);
	}
	get toolResults() {
		return this.finalStep.then((step) => step.toolResults);
	}
	get staticToolResults() {
		return this.finalStep.then((step) => step.staticToolResults);
	}
	get dynamicToolResults() {
		return this.finalStep.then((step) => step.dynamicToolResults);
	}
	get usage() {
		return this.finalStep.then((step) => step.usage);
	}
	get request() {
		return this.finalStep.then((step) => step.request);
	}
	get response() {
		return this.finalStep.then((step) => step.response);
	}
	get totalUsage() {
		this.consumeStream();
		return this._totalUsage.promise;
	}
	get finishReason() {
		this.consumeStream();
		return this._finishReason.promise;
	}
	/**
	Split out a new stream from the original stream.
	The original stream is replaced to allow for further splitting,
	since we do not know how many times the stream will be split.
	
	Note: this leads to buffering the stream content on the server.
	However, the LLM results are expected to be small enough to not cause issues.
	*/
	teeStream() {
		const [stream1, stream2] = this.baseStream.tee();
		this.baseStream = stream2;
		return stream1;
	}
	get textStream() {
		return createAsyncIterableStream(this.teeStream().pipeThrough(new TransformStream({ transform({ part }, controller) {
			if (part.type === "text-delta") controller.enqueue(part.text);
		} })));
	}
	get fullStream() {
		return createAsyncIterableStream(this.teeStream().pipeThrough(new TransformStream({ transform({ part }, controller) {
			controller.enqueue(part);
		} })));
	}
	async consumeStream(options) {
		var _a16;
		try {
			await consumeStream({
				stream: this.fullStream,
				onError: options == null ? void 0 : options.onError
			});
		} catch (error) {
			(_a16 = options == null ? void 0 : options.onError) == null || _a16.call(options, error);
		}
	}
	get experimental_partialOutputStream() {
		if (this.output == null) throw new NoOutputSpecifiedError();
		return createAsyncIterableStream(this.teeStream().pipeThrough(new TransformStream({ transform({ partialOutput }, controller) {
			if (partialOutput != null) controller.enqueue(partialOutput);
		} })));
	}
	toUIMessageStream({ originalMessages, generateMessageId, onFinish, messageMetadata, sendReasoning = true, sendSources = false, sendStart = true, sendFinish = true, onError = () => "An error occurred." } = {}) {
		let outcome = { status: "unknown" };
		let hasFatalFailure = false;
		const setSourceOutcome = (newOutcome) => {
			if (!hasFatalFailure && outcome.status !== "completed" && outcome.status !== "aborted" && newOutcome.status !== "unknown" && (outcome.status === "unknown" || newOutcome.status !== "failed")) outcome = newOutcome;
		};
		const failOutcome = (error) => {
			hasFatalFailure = true;
			outcome = {
				status: "failed",
				error
			};
		};
		const responseMessageId = generateMessageId != null ? getResponseUIMessageId({
			originalMessages,
			responseMessageId: generateMessageId
		}) : void 0;
		const toolNamesByCallId = {};
		const isDynamic = (toolCallId) => {
			var _a16, _b;
			const toolName = toolNamesByCallId[toolCallId];
			return ((_b = (_a16 = this.tools) == null ? void 0 : _a16[toolName]) == null ? void 0 : _b.type) === "dynamic" ? true : void 0;
		};
		const sourceReader = this.fullStream.getReader();
		let sourceReaderReleased = false;
		let sourceStreamCancelled = false;
		const releaseSourceReader = () => {
			if (!sourceReaderReleased) {
				sourceReader.releaseLock();
				sourceReaderReleased = true;
			}
		};
		const baseStreamReader = new ReadableStream({
			async pull(controller) {
				try {
					const { done, value } = await sourceReader.read();
					if (done) {
						releaseSourceReader();
						if (!sourceStreamCancelled) controller.close();
					} else controller.enqueue(value);
				} catch (error) {
					releaseSourceReader();
					if (!sourceStreamCancelled) {
						failOutcome(error);
						controller.error(error);
					}
				}
			},
			async cancel(reason) {
				sourceStreamCancelled = true;
				if (sourceReaderReleased) return;
				try {
					await sourceReader.cancel(reason);
				} finally {
					releaseSourceReader();
				}
			}
		}).pipeThrough(new TransformStream({ transform: async (part, controller) => {
			const messageMetadataValue = messageMetadata == null ? void 0 : messageMetadata({ part });
			const partType = part.type;
			switch (partType) {
				case "text-start":
					controller.enqueue({
						type: "text-start",
						id: part.id,
						...part.providerMetadata != null ? { providerMetadata: part.providerMetadata } : {}
					});
					break;
				case "text-delta":
					controller.enqueue({
						type: "text-delta",
						id: part.id,
						delta: part.text,
						...part.providerMetadata != null ? { providerMetadata: part.providerMetadata } : {}
					});
					break;
				case "text-end":
					controller.enqueue({
						type: "text-end",
						id: part.id,
						...part.providerMetadata != null ? { providerMetadata: part.providerMetadata } : {}
					});
					break;
				case "reasoning-start":
					controller.enqueue({
						type: "reasoning-start",
						id: part.id,
						...part.providerMetadata != null ? { providerMetadata: part.providerMetadata } : {}
					});
					break;
				case "reasoning-delta":
					if (sendReasoning) controller.enqueue({
						type: "reasoning-delta",
						id: part.id,
						delta: part.text,
						...part.providerMetadata != null ? { providerMetadata: part.providerMetadata } : {}
					});
					break;
				case "reasoning-end":
					controller.enqueue({
						type: "reasoning-end",
						id: part.id,
						...part.providerMetadata != null ? { providerMetadata: part.providerMetadata } : {}
					});
					break;
				case "file":
					controller.enqueue({
						type: "file",
						mediaType: part.file.mediaType,
						url: `data:${part.file.mediaType};base64,${part.file.base64}`
					});
					break;
				case "source":
					if (sendSources && part.sourceType === "url") controller.enqueue({
						type: "source-url",
						sourceId: part.id,
						url: part.url,
						title: part.title,
						...part.providerMetadata != null ? { providerMetadata: part.providerMetadata } : {}
					});
					if (sendSources && part.sourceType === "document") controller.enqueue({
						type: "source-document",
						sourceId: part.id,
						mediaType: part.mediaType,
						title: part.title,
						filename: part.filename,
						...part.providerMetadata != null ? { providerMetadata: part.providerMetadata } : {}
					});
					break;
				case "tool-input-start": {
					toolNamesByCallId[part.id] = part.toolName;
					const dynamic = isDynamic(part.id);
					controller.enqueue({
						type: "tool-input-start",
						toolCallId: part.id,
						toolName: part.toolName,
						...part.providerExecuted != null ? { providerExecuted: part.providerExecuted } : {},
						...dynamic != null ? { dynamic } : {}
					});
					break;
				}
				case "tool-input-delta":
					controller.enqueue({
						type: "tool-input-delta",
						toolCallId: part.id,
						inputTextDelta: part.delta
					});
					break;
				case "tool-call": {
					toolNamesByCallId[part.toolCallId] = part.toolName;
					const dynamic = isDynamic(part.toolCallId);
					if (part.invalid) controller.enqueue({
						type: "tool-input-error",
						toolCallId: part.toolCallId,
						toolName: part.toolName,
						input: part.input,
						...part.providerExecuted != null ? { providerExecuted: part.providerExecuted } : {},
						...part.providerMetadata != null ? { providerMetadata: part.providerMetadata } : {},
						...dynamic != null ? { dynamic } : {},
						errorText: onError(part.error)
					});
					else controller.enqueue({
						type: "tool-input-available",
						toolCallId: part.toolCallId,
						toolName: part.toolName,
						input: part.input,
						...part.providerExecuted != null ? { providerExecuted: part.providerExecuted } : {},
						...part.providerMetadata != null ? { providerMetadata: part.providerMetadata } : {},
						...dynamic != null ? { dynamic } : {}
					});
					break;
				}
				case "tool-result": {
					const dynamic = isDynamic(part.toolCallId);
					controller.enqueue({
						type: "tool-output-available",
						toolCallId: part.toolCallId,
						output: part.output,
						...part.providerExecuted != null ? { providerExecuted: part.providerExecuted } : {},
						...part.preliminary != null ? { preliminary: part.preliminary } : {},
						...dynamic != null ? { dynamic } : {}
					});
					break;
				}
				case "tool-error": {
					const dynamic = isDynamic(part.toolCallId);
					controller.enqueue({
						type: "tool-output-error",
						toolCallId: part.toolCallId,
						errorText: onError(part.error),
						...part.providerExecuted != null ? { providerExecuted: part.providerExecuted } : {},
						...dynamic != null ? { dynamic } : {}
					});
					break;
				}
				case "error":
					controller.enqueue({
						type: "error",
						errorText: onError(part.error)
					});
					break;
				case "start-step":
					controller.enqueue({ type: "start-step" });
					break;
				case "finish-step":
					controller.enqueue({ type: "finish-step" });
					break;
				case "start":
					if (sendStart) controller.enqueue({
						type: "start",
						...messageMetadataValue != null ? { messageMetadata: messageMetadataValue } : {},
						...responseMessageId != null ? { messageId: responseMessageId } : {}
					});
					break;
				case "finish":
					if (sendFinish) controller.enqueue({
						type: "finish",
						finishReason: part.finishReason,
						...messageMetadataValue != null ? { messageMetadata: messageMetadataValue } : {}
					});
					break;
				case "abort":
					controller.enqueue(part);
					break;
				case "tool-input-end": break;
				case "raw": break;
				default: throw new Error(`Unknown chunk type: ${partType}`);
			}
			if (messageMetadataValue != null && partType !== "start" && partType !== "finish") controller.enqueue({
				type: "message-metadata",
				messageMetadata: messageMetadataValue
			});
			if (part.type === "finish") setSourceOutcome({ status: "completed" });
			else if (part.type === "abort") setSourceOutcome({ status: "aborted" });
			else if (part.type === "error") setSourceOutcome({
				status: "failed",
				error: part.error
			});
		} })).getReader();
		let baseStreamReaderReleased = false;
		let baseStreamCancelled = false;
		const releaseBaseStreamReader = () => {
			if (!baseStreamReaderReleased) {
				baseStreamReader.releaseLock();
				baseStreamReaderReleased = true;
			}
		};
		return createAsyncIterableStream(handleUIMessageStreamFinish({
			stream: new ReadableStream({
				async pull(controller) {
					try {
						const { done, value } = await baseStreamReader.read();
						if (done) {
							releaseBaseStreamReader();
							if (!baseStreamCancelled) controller.close();
						} else controller.enqueue(value);
					} catch (error) {
						releaseBaseStreamReader();
						if (!baseStreamCancelled) {
							failOutcome(error);
							controller.error(error);
						}
					}
				},
				async cancel(reason) {
					baseStreamCancelled = true;
					if (baseStreamReaderReleased) return;
					try {
						await baseStreamReader.cancel(reason);
					} finally {
						releaseBaseStreamReader();
					}
				}
			}),
			messageId: responseMessageId != null ? responseMessageId : generateMessageId == null ? void 0 : generateMessageId(),
			originalMessages,
			onFinish,
			onError,
			getOutcome: () => outcome
		}));
	}
	pipeUIMessageStreamToResponse(response, { originalMessages, generateMessageId, onFinish, messageMetadata, sendReasoning, sendSources, sendFinish, sendStart, onError, ...init } = {}) {
		return pipeUIMessageStreamToResponse({
			response,
			stream: this.toUIMessageStream({
				originalMessages,
				generateMessageId,
				onFinish,
				messageMetadata,
				sendReasoning,
				sendSources,
				sendFinish,
				sendStart,
				onError
			}),
			...init
		});
	}
	pipeTextStreamToResponse(response, init) {
		return pipeTextStreamToResponse({
			response,
			textStream: this.textStream,
			...init
		});
	}
	toUIMessageStreamResponse({ originalMessages, generateMessageId, onFinish, messageMetadata, sendReasoning, sendSources, sendFinish, sendStart, onError, ...init } = {}) {
		return createUIMessageStreamResponse({
			stream: this.toUIMessageStream({
				originalMessages,
				generateMessageId,
				onFinish,
				messageMetadata,
				sendReasoning,
				sendSources,
				sendFinish,
				sendStart,
				onError
			}),
			...init
		});
	}
	toTextStreamResponse(init) {
		return createTextStreamResponse({
			textStream: this.textStream,
			...init
		});
	}
};
function getOwn(obj, key) {
	return obj != null && Object.hasOwn(obj, key) ? obj[key] : void 0;
}
function markToolPartAsUnavailable(part) {
	part.dynamic = false;
	return part;
}
function isToolPartFromUnavailableTool(part) {
	return part.type === "dynamic-tool" && part.dynamic === false;
}
function convertToModelMessages(messages, options) {
	const modelMessages = [];
	if (options == null ? void 0 : options.ignoreIncompleteToolCalls) messages = messages.map((message) => ({
		...message,
		parts: message.parts.filter((part) => !isToolOrDynamicToolUIPart(part) || part.state !== "input-streaming" && part.state !== "input-available" && (part.state !== "output-available" || part.preliminary !== true))
	}));
	function createModelOutput({ toolPart, toolName, output, errorMode }) {
		const tool2 = getOwn(options == null ? void 0 : options.tools, toolName);
		if (errorMode === "none" && tool2 == null && isToolPartFromUnavailableTool(toolPart)) return {
			type: "text",
			value: "Tool output omitted because the tool is no longer available."
		};
		return createToolModelOutput({
			output,
			tool: tool2,
			errorMode
		});
	}
	for (const message of messages) switch (message.role) {
		case "system": {
			const textParts = message.parts.filter((part) => part.type === "text");
			const providerMetadata = textParts.reduce((acc, part) => {
				if (part.providerMetadata != null) return {
					...acc,
					...part.providerMetadata
				};
				return acc;
			}, {});
			modelMessages.push({
				role: "system",
				content: textParts.map((part) => part.text).join(""),
				...Object.keys(providerMetadata).length > 0 ? { providerOptions: providerMetadata } : {}
			});
			break;
		}
		case "user":
			modelMessages.push({
				role: "user",
				content: message.parts.map((part) => {
					var _a16;
					if (isTextUIPart(part)) return {
						type: "text",
						text: part.text,
						...part.providerMetadata != null ? { providerOptions: part.providerMetadata } : {}
					};
					if (isFileUIPart(part)) return {
						type: "file",
						mediaType: part.mediaType,
						filename: part.filename,
						data: part.url,
						...part.providerMetadata != null ? { providerOptions: part.providerMetadata } : {}
					};
					if (isDataUIPart(part)) return (_a16 = options == null ? void 0 : options.convertDataPart) == null ? void 0 : _a16.call(options, part);
				}).filter((part) => part != null)
			});
			break;
		case "assistant":
			if (message.parts != null) {
				let processBlock2 = function() {
					var _a16, _b;
					if (block.length === 0) return;
					const content = [];
					for (const part of block) if (isTextUIPart(part)) content.push({
						type: "text",
						text: part.text,
						...part.providerMetadata != null ? { providerOptions: part.providerMetadata } : {}
					});
					else if (isFileUIPart(part)) content.push({
						type: "file",
						mediaType: part.mediaType,
						filename: part.filename,
						data: part.url
					});
					else if (isReasoningUIPart(part)) content.push({
						type: "reasoning",
						text: part.text,
						providerOptions: part.providerMetadata
					});
					else if (isDynamicToolUIPart(part)) {
						const toolName = part.toolName;
						if (part.state !== "input-streaming") content.push({
							type: "tool-call",
							toolCallId: part.toolCallId,
							toolName,
							input: part.input,
							...part.callProviderMetadata != null ? { providerOptions: part.callProviderMetadata } : {}
						});
					} else if (isToolUIPart(part)) {
						const toolName = getToolName(part);
						if (part.state !== "input-streaming") {
							content.push({
								type: "tool-call",
								toolCallId: part.toolCallId,
								toolName,
								input: part.state === "output-error" ? (_a16 = part.input) != null ? _a16 : part.rawInput : part.input,
								providerExecuted: part.providerExecuted,
								...part.callProviderMetadata != null ? { providerOptions: part.callProviderMetadata } : {}
							});
							if (part.providerExecuted === true && (part.state === "output-available" || part.state === "output-error")) content.push({
								type: "tool-result",
								toolCallId: part.toolCallId,
								toolName,
								output: createModelOutput({
									toolPart: part,
									toolName,
									output: part.state === "output-error" ? part.errorText : part.output,
									errorMode: part.state === "output-error" ? "json" : "none"
								}),
								...part.callProviderMetadata != null ? { providerOptions: part.callProviderMetadata } : {}
							});
						}
					} else if (isDataUIPart(part)) {
						const dataPart = (_b = options == null ? void 0 : options.convertDataPart) == null ? void 0 : _b.call(options, part);
						if (dataPart != null) content.push(dataPart);
					} else throw new Error(`Unsupported part: ${part}`);
					modelMessages.push({
						role: "assistant",
						content
					});
					const toolParts = block.filter((part) => isToolUIPart(part) && part.providerExecuted !== true || part.type === "dynamic-tool");
					if (toolParts.length > 0) modelMessages.push({
						role: "tool",
						content: toolParts.map((toolPart) => {
							switch (toolPart.state) {
								case "output-error":
								case "output-available": {
									const toolName = getToolOrDynamicToolName(toolPart);
									return {
										type: "tool-result",
										toolCallId: toolPart.toolCallId,
										toolName,
										output: createModelOutput({
											toolPart,
											toolName,
											output: toolPart.state === "output-error" ? toolPart.errorText : toolPart.output,
											errorMode: toolPart.state === "output-error" ? "text" : "none"
										}),
										...toolPart.callProviderMetadata != null ? { providerOptions: toolPart.callProviderMetadata } : {}
									};
								}
								default: return null;
							}
						}).filter((output) => output != null)
					});
					block = [];
				};
				let block = [];
				for (const part of message.parts) if (isTextUIPart(part) || isReasoningUIPart(part) || isFileUIPart(part) || isToolOrDynamicToolUIPart(part) || isDataUIPart(part)) block.push(part);
				else if (part.type === "step-start") processBlock2();
				processBlock2();
				break;
			}
			break;
		default: {
			const _exhaustiveCheck = message.role;
			throw new MessageConversionError({
				originalMessage: message,
				message: `Unsupported role: ${_exhaustiveCheck}`
			});
		}
	}
	return modelMessages;
}
var convertToCoreMessages = convertToModelMessages;
var Agent = class {
	constructor(settings) {
		this.settings = settings;
	}
	get tools() {
		return this.settings.tools;
	}
	async generate(options) {
		return generateText$1({
			...this.settings,
			...options
		});
	}
	stream(options) {
		return streamText$1({
			...this.settings,
			...options
		});
	}
	/**
	* Creates a response object that streams UI messages to the client.
	*/
	respond(options) {
		return this.stream({ prompt: convertToModelMessages(options.messages) }).toUIMessageStreamResponse();
	}
};
async function embed({ model: modelArg, value, providerOptions, maxRetries: maxRetriesArg, abortSignal, headers, experimental_telemetry: telemetry }) {
	const model = resolveEmbeddingModel(modelArg);
	const { maxRetries, retry } = prepareRetries({
		maxRetries: maxRetriesArg,
		abortSignal
	});
	const headersWithUserAgent = withUserAgentSuffix(headers != null ? headers : {}, `ai/${VERSION}`);
	const baseTelemetryAttributes = getBaseTelemetryAttributes({
		model,
		telemetry,
		headers: headersWithUserAgent,
		settings: { maxRetries }
	});
	const tracer = getTracer(telemetry);
	return recordSpan({
		name: "ai.embed",
		attributes: selectTelemetryAttributes({
			telemetry,
			attributes: {
				...assembleOperationName({
					operationId: "ai.embed",
					telemetry
				}),
				...baseTelemetryAttributes,
				"ai.value": { input: () => JSON.stringify(value) }
			}
		}),
		tracer,
		fn: async (span) => {
			const { embedding, usage, response, providerMetadata } = await retry(() => recordSpan({
				name: "ai.embed.doEmbed",
				attributes: selectTelemetryAttributes({
					telemetry,
					attributes: {
						...assembleOperationName({
							operationId: "ai.embed.doEmbed",
							telemetry
						}),
						...baseTelemetryAttributes,
						"ai.values": { input: () => [JSON.stringify(value)] }
					}
				}),
				tracer,
				fn: async (doEmbedSpan) => {
					var _a16;
					const modelResponse = await model.doEmbed({
						values: [value],
						abortSignal,
						headers: headersWithUserAgent,
						providerOptions
					});
					const embedding2 = modelResponse.embeddings[0];
					const usage2 = (_a16 = modelResponse.usage) != null ? _a16 : { tokens: NaN };
					doEmbedSpan.setAttributes(selectTelemetryAttributes({
						telemetry,
						attributes: {
							"ai.embeddings": { output: () => modelResponse.embeddings.map((embedding3) => JSON.stringify(embedding3)) },
							"ai.usage.tokens": usage2.tokens
						}
					}));
					if (embedding2 == null) throw new InvalidResponseDataError({
						data: modelResponse.embeddings,
						message: "No embedding generated."
					});
					return {
						embedding: embedding2,
						usage: usage2,
						providerMetadata: modelResponse.providerMetadata,
						response: modelResponse.response
					};
				}
			}));
			span.setAttributes(selectTelemetryAttributes({
				telemetry,
				attributes: {
					"ai.embedding": { output: () => JSON.stringify(embedding) },
					"ai.usage.tokens": usage.tokens
				}
			}));
			return new DefaultEmbedResult({
				value,
				embedding,
				usage,
				providerMetadata,
				response
			});
		}
	});
}
var DefaultEmbedResult = class {
	constructor(options) {
		this.value = options.value;
		this.embedding = options.embedding;
		this.usage = options.usage;
		this.providerMetadata = options.providerMetadata;
		this.response = options.response;
	}
};
function setOwn(object2, key, value) {
	Object.defineProperty(object2, key, {
		value,
		enumerable: true,
		configurable: true,
		writable: true
	});
}
function getEmbeddingModelMaxInputBytesPerCall(model) {
	return model[EMBEDDING_MODEL_MAX_INPUT_BYTES_PER_CALL];
}
function splitArray(array, chunkSize) {
	if (chunkSize <= 0) throw new Error("chunkSize must be greater than 0");
	const result = [];
	for (let i = 0; i < array.length; i += chunkSize) result.push(array.slice(i, i + chunkSize));
	return result;
}
async function embedMany({ model: modelArg, values, maxParallelCalls = Infinity, maxRetries: maxRetriesArg, abortSignal, headers, providerOptions, experimental_telemetry: telemetry }) {
	const model = resolveEmbeddingModel(modelArg);
	const { maxRetries, retry } = prepareRetries({
		maxRetries: maxRetriesArg,
		abortSignal
	});
	const headersWithUserAgent = withUserAgentSuffix(headers != null ? headers : {}, `ai/${VERSION}`);
	const baseTelemetryAttributes = getBaseTelemetryAttributes({
		model,
		telemetry,
		headers: headersWithUserAgent,
		settings: { maxRetries }
	});
	const tracer = getTracer(telemetry);
	return recordSpan({
		name: "ai.embedMany",
		attributes: selectTelemetryAttributes({
			telemetry,
			attributes: {
				...assembleOperationName({
					operationId: "ai.embedMany",
					telemetry
				}),
				...baseTelemetryAttributes,
				"ai.values": { input: () => values.map((value) => JSON.stringify(value)) }
			}
		}),
		tracer,
		fn: async (span) => {
			const [maxEmbeddingsPerCall, maxInputBytesPerCall, supportsParallelCalls] = await Promise.all([
				model.maxEmbeddingsPerCall,
				getEmbeddingModelMaxInputBytesPerCall(model),
				model.supportsParallelCalls
			]);
			const hasEmbeddingLimit = maxEmbeddingsPerCall != null && maxEmbeddingsPerCall !== Infinity;
			const hasInputByteLimit = maxInputBytesPerCall != null && maxInputBytesPerCall !== Infinity;
			if (!hasEmbeddingLimit && !hasInputByteLimit) {
				const { embeddings: embeddings2, usage, response, providerMetadata: providerMetadata2 } = await retry(() => {
					return recordSpan({
						name: "ai.embedMany.doEmbed",
						attributes: selectTelemetryAttributes({
							telemetry,
							attributes: {
								...assembleOperationName({
									operationId: "ai.embedMany.doEmbed",
									telemetry
								}),
								...baseTelemetryAttributes,
								"ai.values": { input: () => values.map((value) => JSON.stringify(value)) }
							}
						}),
						tracer,
						fn: async (doEmbedSpan) => {
							var _a16;
							const modelResponse = await model.doEmbed({
								values,
								abortSignal,
								headers: headersWithUserAgent,
								providerOptions
							});
							const embeddings3 = modelResponse.embeddings;
							const usage2 = (_a16 = modelResponse.usage) != null ? _a16 : { tokens: NaN };
							doEmbedSpan.setAttributes(selectTelemetryAttributes({
								telemetry,
								attributes: {
									"ai.embeddings": { output: () => embeddings3.map((embedding) => JSON.stringify(embedding)) },
									"ai.usage.tokens": usage2.tokens
								}
							}));
							return {
								embeddings: embeddings3,
								usage: usage2,
								providerMetadata: modelResponse.providerMetadata,
								response: modelResponse.response
							};
						}
					});
				});
				span.setAttributes(selectTelemetryAttributes({
					telemetry,
					attributes: {
						"ai.embeddings": { output: () => embeddings2.map((embedding) => JSON.stringify(embedding)) },
						"ai.usage.tokens": usage.tokens
					}
				}));
				return new DefaultEmbedManyResult({
					values,
					embeddings: embeddings2,
					usage,
					providerMetadata: providerMetadata2,
					responses: [response]
				});
			}
			const valueChunks = splitByEmbeddingLimits({
				values,
				maxEmbeddingsPerCall: hasEmbeddingLimit ? maxEmbeddingsPerCall : Infinity,
				maxInputBytesPerCall: hasInputByteLimit ? maxInputBytesPerCall : Infinity
			});
			const embeddings = [];
			const responses = [];
			let tokens = 0;
			let providerMetadata;
			const parallelChunks = splitArray(valueChunks, supportsParallelCalls ? maxParallelCalls : 1);
			for (const parallelChunk of parallelChunks) {
				const results = await Promise.all(parallelChunk.map((chunk) => {
					return retry(() => {
						return recordSpan({
							name: "ai.embedMany.doEmbed",
							attributes: selectTelemetryAttributes({
								telemetry,
								attributes: {
									...assembleOperationName({
										operationId: "ai.embedMany.doEmbed",
										telemetry
									}),
									...baseTelemetryAttributes,
									"ai.values": { input: () => chunk.map((value) => JSON.stringify(value)) }
								}
							}),
							tracer,
							fn: async (doEmbedSpan) => {
								var _a16;
								const modelResponse = await model.doEmbed({
									values: chunk,
									abortSignal,
									headers: headersWithUserAgent,
									providerOptions
								});
								const embeddings2 = modelResponse.embeddings;
								const usage = (_a16 = modelResponse.usage) != null ? _a16 : { tokens: NaN };
								doEmbedSpan.setAttributes(selectTelemetryAttributes({
									telemetry,
									attributes: {
										"ai.embeddings": { output: () => embeddings2.map((embedding) => JSON.stringify(embedding)) },
										"ai.usage.tokens": usage.tokens
									}
								}));
								return {
									embeddings: embeddings2,
									usage,
									providerMetadata: modelResponse.providerMetadata,
									response: modelResponse.response
								};
							}
						});
					});
				}));
				for (const result of results) {
					embeddings.push(...result.embeddings);
					responses.push(result.response);
					tokens += result.usage.tokens;
					if (result.providerMetadata) {
						if (!providerMetadata) providerMetadata = { ...result.providerMetadata };
						else for (const [providerName, metadata] of Object.entries(result.providerMetadata)) setOwn(providerMetadata, providerName, {
							...getOwn(providerMetadata, providerName),
							...metadata
						});
					}
				}
			}
			span.setAttributes(selectTelemetryAttributes({
				telemetry,
				attributes: {
					"ai.embeddings": { output: () => embeddings.map((embedding) => JSON.stringify(embedding)) },
					"ai.usage.tokens": tokens
				}
			}));
			return new DefaultEmbedManyResult({
				values,
				embeddings,
				usage: { tokens },
				providerMetadata,
				responses
			});
		}
	});
}
var textEncoder = new TextEncoder();
function splitByEmbeddingLimits({ values, maxEmbeddingsPerCall, maxInputBytesPerCall }) {
	if (maxEmbeddingsPerCall <= 0) throw new Error("maxEmbeddingsPerCall must be greater than 0");
	if (maxInputBytesPerCall <= 0) throw new Error("maxInputBytesPerCall must be greater than 0");
	if (values.length === 0) return [];
	const chunks = [];
	let currentChunk = [];
	let currentInputBytes = 0;
	for (const value of values) {
		const inputBytes = maxInputBytesPerCall === Infinity ? 0 : textEncoder.encode(value).length;
		if (currentChunk.length > 0 && (currentChunk.length >= maxEmbeddingsPerCall || currentInputBytes + inputBytes > maxInputBytesPerCall)) {
			chunks.push(currentChunk);
			currentChunk = [];
			currentInputBytes = 0;
		}
		currentChunk.push(value);
		currentInputBytes += inputBytes;
	}
	chunks.push(currentChunk);
	return chunks;
}
var DefaultEmbedManyResult = class {
	constructor(options) {
		this.values = options.values;
		this.embeddings = options.embeddings;
		this.usage = options.usage;
		this.providerMetadata = options.providerMetadata;
		this.responses = options.responses;
	}
};
var RetryableNoImageResultError = class extends Error {
	constructor() {
		super("No image generated.");
		this.name = "RetryableNoImageResultError";
	}
};
async function generateImage({ model: modelArg, prompt, n = 1, maxImagesPerCall, size, aspectRatio, seed, providerOptions, maxRetries: maxRetriesArg, abortSignal, headers }) {
	var _a16, _b;
	const model = resolveImageModel(modelArg);
	const headersWithUserAgent = withUserAgentSuffix(headers != null ? headers : {}, `ai/${VERSION}`);
	const { retry } = prepareRetries({
		maxRetries: maxRetriesArg,
		abortSignal,
		additionalRetryableError: (error) => error instanceof RetryableNoImageResultError
	});
	const maxImagesPerCallWithDefault = (_a16 = maxImagesPerCall != null ? maxImagesPerCall : await invokeModelMaxImagesPerCall(model)) != null ? _a16 : 1;
	const callCount = Math.ceil(n / maxImagesPerCallWithDefault);
	const callImageCounts = Array.from({ length: callCount }, (_, i) => {
		if (i < callCount - 1) return maxImagesPerCallWithDefault;
		const remainder = n % maxImagesPerCallWithDefault;
		return remainder === 0 ? maxImagesPerCallWithDefault : remainder;
	});
	const results = (await Promise.all(callImageCounts.map(async (callImageCount) => {
		const callResults = [];
		try {
			await retry(async () => {
				const result = await model.doGenerate({
					prompt,
					n: callImageCount,
					abortSignal,
					headers: headersWithUserAgent,
					size,
					aspectRatio,
					seed,
					providerOptions: providerOptions != null ? providerOptions : {}
				});
				callResults.push(result);
				if (result.images.length === 0 && result.isRetryable !== false) throw new RetryableNoImageResultError();
				return result;
			});
			return callResults;
		} catch (error) {
			if ((error instanceof RetryableNoImageResultError ? error : RetryError.isInstance(error) && error.lastError instanceof RetryableNoImageResultError ? error.lastError : void 0) != null) return callResults;
			throw error;
		}
	}))).flat();
	const images = [];
	const warnings = [];
	const responses = [];
	const providerMetadata = {};
	for (const result of results) {
		images.push(...result.images.map((image) => {
			var _a17;
			return new DefaultGeneratedFile({
				data: image,
				mediaType: (_a17 = detectMediaType({
					data: image,
					signatures: imageMediaTypeSignatures
				})) != null ? _a17 : "image/png"
			});
		}));
		warnings.push(...result.warnings);
		if (result.providerMetadata) for (const [providerName, metadata] of Object.entries(result.providerMetadata)) if (providerName === "gateway") {
			const currentEntry = providerMetadata[providerName];
			if (currentEntry != null && typeof currentEntry === "object") providerMetadata[providerName] = {
				...currentEntry,
				...metadata
			};
			else providerMetadata[providerName] = metadata;
			const imagesValue = providerMetadata[providerName].images;
			if (Array.isArray(imagesValue) && imagesValue.length === 0) delete providerMetadata[providerName].images;
		} else {
			const currentEntry = (_b = getOwn(providerMetadata, providerName)) != null ? _b : { images: [] };
			currentEntry.images.push(...result.providerMetadata[providerName].images);
			setOwn(providerMetadata, providerName, currentEntry);
		}
		responses.push(result.response);
	}
	logWarnings(warnings);
	if (!images.length) throw new NoImageGeneratedError({ responses });
	return new DefaultGenerateImageResult({
		images,
		warnings,
		responses,
		providerMetadata
	});
}
var DefaultGenerateImageResult = class {
	constructor(options) {
		this.images = options.images;
		this.warnings = options.warnings;
		this.responses = options.responses;
		this.providerMetadata = options.providerMetadata;
	}
	get image() {
		return this.images[0];
	}
};
async function invokeModelMaxImagesPerCall(model) {
	if (!(model.maxImagesPerCall instanceof Function)) return model.maxImagesPerCall;
	return model.maxImagesPerCall({ modelId: model.modelId });
}
function extractReasoningContent(content) {
	const parts = content.filter((content2) => content2.type === "reasoning");
	return parts.length === 0 ? void 0 : parts.map((content2) => content2.text).join("\n");
}
var noSchemaOutputStrategy = {
	type: "no-schema",
	jsonSchema: void 0,
	async validatePartialResult({ value, textDelta }) {
		return {
			success: true,
			value: {
				partial: value,
				textDelta
			}
		};
	},
	async validateFinalResult(value, context) {
		return value === void 0 ? {
			success: false,
			error: new NoObjectGeneratedError({
				message: "No object generated: response did not match schema.",
				text: context.text,
				response: context.response,
				usage: context.usage,
				finishReason: context.finishReason
			})
		} : {
			success: true,
			value
		};
	},
	createElementStream() {
		throw new UnsupportedFunctionalityError({ functionality: "element streams in no-schema mode" });
	}
};
var objectOutputStrategy = (schema) => ({
	type: "object",
	jsonSchema: schema.jsonSchema,
	async validatePartialResult({ value, textDelta }) {
		return {
			success: true,
			value: {
				partial: value,
				textDelta
			}
		};
	},
	async validateFinalResult(value) {
		return safeValidateTypes({
			value,
			schema
		});
	},
	createElementStream() {
		throw new UnsupportedFunctionalityError({ functionality: "element streams in object mode" });
	}
});
var arrayOutputStrategy = (schema) => {
	const { $schema, ...itemSchema } = schema.jsonSchema;
	return {
		type: "array",
		jsonSchema: {
			$schema: "http://json-schema.org/draft-07/schema#",
			type: "object",
			properties: { elements: {
				type: "array",
				items: itemSchema
			} },
			required: ["elements"],
			additionalProperties: false
		},
		async validatePartialResult({ value, latestObject, isFirstDelta, isFinalDelta }) {
			var _a16;
			if (!isJSONObject(value) || !isJSONArray(value.elements)) return {
				success: false,
				error: new TypeValidationError({
					value,
					cause: "value must be an object that contains an array of elements"
				})
			};
			const inputArray = value.elements;
			const resultArray = [];
			for (let i = 0; i < inputArray.length; i++) {
				const element = inputArray[i];
				const result = await safeValidateTypes({
					value: element,
					schema
				});
				if (i === inputArray.length - 1 && !isFinalDelta) continue;
				if (!result.success) return result;
				resultArray.push(result.value);
			}
			const publishedElementCount = (_a16 = latestObject == null ? void 0 : latestObject.length) != null ? _a16 : 0;
			let textDelta = "";
			if (isFirstDelta) textDelta += "[";
			if (publishedElementCount > 0) textDelta += ",";
			textDelta += resultArray.slice(publishedElementCount).map((element) => JSON.stringify(element)).join(",");
			if (isFinalDelta) textDelta += "]";
			return {
				success: true,
				value: {
					partial: resultArray,
					textDelta
				}
			};
		},
		async validateFinalResult(value) {
			if (!isJSONObject(value) || !isJSONArray(value.elements)) return {
				success: false,
				error: new TypeValidationError({
					value,
					cause: "value must be an object that contains an array of elements"
				})
			};
			const inputArray = value.elements;
			const resultArray = [];
			for (const element of inputArray) {
				const result = await safeValidateTypes({
					value: element,
					schema
				});
				if (!result.success) return result;
				resultArray.push(result.value);
			}
			return {
				success: true,
				value: resultArray
			};
		},
		createElementStream(originalStream) {
			let publishedElements = 0;
			return createAsyncIterableStream(originalStream.pipeThrough(new TransformStream({ transform(chunk, controller) {
				switch (chunk.type) {
					case "object": {
						const array = chunk.object;
						for (; publishedElements < array.length; publishedElements++) controller.enqueue(array[publishedElements]);
						break;
					}
					case "text-delta":
					case "finish":
					case "error": break;
					default: throw new Error(`Unsupported chunk type: ${chunk}`);
				}
			} })));
		}
	};
};
var enumOutputStrategy = (enumValues) => {
	return {
		type: "enum",
		jsonSchema: {
			$schema: "http://json-schema.org/draft-07/schema#",
			type: "object",
			properties: { result: {
				type: "string",
				enum: enumValues
			} },
			required: ["result"],
			additionalProperties: false
		},
		async validateFinalResult(value) {
			if (!isJSONObject(value) || typeof value.result !== "string") return {
				success: false,
				error: new TypeValidationError({
					value,
					cause: "value must be an object that contains a string in the \"result\" property."
				})
			};
			const result = value.result;
			return enumValues.includes(result) ? {
				success: true,
				value: result
			} : {
				success: false,
				error: new TypeValidationError({
					value,
					cause: "value must be a string in the enum"
				})
			};
		},
		async validatePartialResult({ value, textDelta }) {
			if (!isJSONObject(value) || typeof value.result !== "string") return {
				success: false,
				error: new TypeValidationError({
					value,
					cause: "value must be an object that contains a string in the \"result\" property."
				})
			};
			const result = value.result;
			const possibleEnumValues = enumValues.filter((enumValue) => enumValue.startsWith(result));
			if (value.result.length === 0 || possibleEnumValues.length === 0) return {
				success: false,
				error: new TypeValidationError({
					value,
					cause: "value must be a string in the enum"
				})
			};
			return {
				success: true,
				value: {
					partial: possibleEnumValues.length > 1 ? result : possibleEnumValues[0],
					textDelta
				}
			};
		},
		createElementStream() {
			throw new UnsupportedFunctionalityError({ functionality: "element streams in enum mode" });
		}
	};
};
function getOutputStrategy({ output, schema, enumValues }) {
	switch (output) {
		case "object": return objectOutputStrategy(asSchema(schema));
		case "array": return arrayOutputStrategy(asSchema(schema));
		case "enum": return enumOutputStrategy(enumValues);
		case "no-schema": return noSchemaOutputStrategy;
		default: throw new Error(`Unsupported output: ${output}`);
	}
}
async function parseAndValidateObjectResult(result, outputStrategy, context) {
	const parseResult = await safeParseJSON({ text: result });
	if (!parseResult.success) throw new NoObjectGeneratedError({
		message: "No object generated: could not parse the response.",
		cause: parseResult.error,
		text: result,
		response: context.response,
		usage: context.usage,
		finishReason: context.finishReason
	});
	const validationResult = await outputStrategy.validateFinalResult(parseResult.value, {
		text: result,
		response: context.response,
		usage: context.usage
	});
	if (!validationResult.success) throw new NoObjectGeneratedError({
		message: "No object generated: response did not match schema.",
		cause: validationResult.error,
		text: result,
		response: context.response,
		usage: context.usage,
		finishReason: context.finishReason
	});
	return validationResult.value;
}
async function parseAndValidateObjectResultWithRepair(result, outputStrategy, repairText, context) {
	try {
		return await parseAndValidateObjectResult(result, outputStrategy, context);
	} catch (error) {
		if (repairText != null && NoObjectGeneratedError.isInstance(error) && (JSONParseError.isInstance(error.cause) || TypeValidationError.isInstance(error.cause))) {
			const repairedText = await repairText({
				text: result,
				error: error.cause
			});
			if (repairedText === null) throw error;
			return await parseAndValidateObjectResult(repairedText, outputStrategy, context);
		}
		throw error;
	}
}
function validateObjectGenerationInput({ output, schema, schemaName, schemaDescription, enumValues }) {
	if (output != null && output !== "object" && output !== "array" && output !== "enum" && output !== "no-schema") throw new InvalidArgumentError({
		parameter: "output",
		value: output,
		message: "Invalid output type."
	});
	if (output === "no-schema") {
		if (schema != null) throw new InvalidArgumentError({
			parameter: "schema",
			value: schema,
			message: "Schema is not supported for no-schema output."
		});
		if (schemaDescription != null) throw new InvalidArgumentError({
			parameter: "schemaDescription",
			value: schemaDescription,
			message: "Schema description is not supported for no-schema output."
		});
		if (schemaName != null) throw new InvalidArgumentError({
			parameter: "schemaName",
			value: schemaName,
			message: "Schema name is not supported for no-schema output."
		});
		if (enumValues != null) throw new InvalidArgumentError({
			parameter: "enumValues",
			value: enumValues,
			message: "Enum values are not supported for no-schema output."
		});
	}
	if (output === "object") {
		if (schema == null) throw new InvalidArgumentError({
			parameter: "schema",
			value: schema,
			message: "Schema is required for object output."
		});
		if (enumValues != null) throw new InvalidArgumentError({
			parameter: "enumValues",
			value: enumValues,
			message: "Enum values are not supported for object output."
		});
	}
	if (output === "array") {
		if (schema == null) throw new InvalidArgumentError({
			parameter: "schema",
			value: schema,
			message: "Element schema is required for array output."
		});
		if (enumValues != null) throw new InvalidArgumentError({
			parameter: "enumValues",
			value: enumValues,
			message: "Enum values are not supported for array output."
		});
	}
	if (output === "enum") {
		if (schema != null) throw new InvalidArgumentError({
			parameter: "schema",
			value: schema,
			message: "Schema is not supported for enum output."
		});
		if (schemaDescription != null) throw new InvalidArgumentError({
			parameter: "schemaDescription",
			value: schemaDescription,
			message: "Schema description is not supported for enum output."
		});
		if (schemaName != null) throw new InvalidArgumentError({
			parameter: "schemaName",
			value: schemaName,
			message: "Schema name is not supported for enum output."
		});
		if (enumValues == null) throw new InvalidArgumentError({
			parameter: "enumValues",
			value: enumValues,
			message: "Enum values are required for enum output."
		});
		for (const value of enumValues) if (typeof value !== "string") throw new InvalidArgumentError({
			parameter: "enumValues",
			value,
			message: "Enum values must be strings."
		});
	}
}
var originalGenerateId3 = createIdGenerator({
	prefix: "aiobj",
	size: 24
});
async function generateObject(options) {
	const { model: modelArg, output = "object", system, prompt, messages, allowSystemInMessages, maxRetries: maxRetriesArg, abortSignal, headers, experimental_repairText: repairText, experimental_telemetry: telemetry, experimental_download: download2, providerOptions, _internal: { generateId: generateId3 = originalGenerateId3, currentDate = () => /* @__PURE__ */ new Date() } = {}, ...settings } = options;
	const model = resolveLanguageModel(modelArg);
	const enumValues = "enum" in options ? options.enum : void 0;
	const { schema: inputSchema, schemaDescription, schemaName } = "schema" in options ? options : {};
	validateObjectGenerationInput({
		output,
		schema: inputSchema,
		schemaName,
		schemaDescription,
		enumValues
	});
	const { maxRetries, retry } = prepareRetries({
		maxRetries: maxRetriesArg,
		abortSignal
	});
	const outputStrategy = getOutputStrategy({
		output,
		schema: inputSchema,
		enumValues
	});
	const callSettings = prepareCallSettings(settings);
	const headersWithUserAgent = withUserAgentSuffix(headers != null ? headers : {}, `ai/${VERSION}`);
	const baseTelemetryAttributes = getBaseTelemetryAttributes({
		model,
		telemetry,
		headers: headersWithUserAgent,
		settings: {
			...callSettings,
			maxRetries
		}
	});
	const tracer = getTracer(telemetry);
	try {
		return await recordSpan({
			name: "ai.generateObject",
			attributes: selectTelemetryAttributes({
				telemetry,
				attributes: {
					...assembleOperationName({
						operationId: "ai.generateObject",
						telemetry
					}),
					...baseTelemetryAttributes,
					"ai.prompt": { input: () => JSON.stringify({
						system,
						prompt,
						messages
					}) },
					"ai.schema": outputStrategy.jsonSchema != null ? { input: () => JSON.stringify(outputStrategy.jsonSchema) } : void 0,
					"ai.schema.name": schemaName,
					"ai.schema.description": schemaDescription,
					"ai.settings.output": outputStrategy.type
				}
			}),
			tracer,
			fn: async (span) => {
				var _a16;
				let result;
				let finishReason;
				let usage;
				let warnings;
				let response;
				let request;
				let resultProviderMetadata;
				let reasoning;
				const promptMessages = await convertToLanguageModelPrompt({
					prompt: await standardizePrompt({
						system,
						prompt,
						messages,
						allowSystemInMessages
					}),
					supportedUrls: await model.supportedUrls,
					download: download2
				});
				const generateResult = await retry(() => recordSpan({
					name: "ai.generateObject.doGenerate",
					attributes: selectTelemetryAttributes({
						telemetry,
						attributes: {
							...assembleOperationName({
								operationId: "ai.generateObject.doGenerate",
								telemetry
							}),
							...baseTelemetryAttributes,
							"ai.prompt.messages": { input: () => stringifyForTelemetry(promptMessages) },
							"gen_ai.system": model.provider,
							"gen_ai.request.model": model.modelId,
							"gen_ai.request.frequency_penalty": callSettings.frequencyPenalty,
							"gen_ai.request.max_tokens": callSettings.maxOutputTokens,
							"gen_ai.request.presence_penalty": callSettings.presencePenalty,
							"gen_ai.request.temperature": callSettings.temperature,
							"gen_ai.request.top_k": callSettings.topK,
							"gen_ai.request.top_p": callSettings.topP
						}
					}),
					tracer,
					fn: async (span2) => {
						var _a17, _b, _c, _d, _e, _f, _g, _h;
						const result2 = await model.doGenerate({
							responseFormat: {
								type: "json",
								schema: outputStrategy.jsonSchema,
								name: schemaName,
								description: schemaDescription
							},
							...prepareCallSettings(settings),
							prompt: promptMessages,
							providerOptions,
							abortSignal,
							headers: headersWithUserAgent
						});
						const responseData = {
							id: (_b = (_a17 = result2.response) == null ? void 0 : _a17.id) != null ? _b : generateId3(),
							timestamp: (_d = (_c = result2.response) == null ? void 0 : _c.timestamp) != null ? _d : currentDate(),
							modelId: (_f = (_e = result2.response) == null ? void 0 : _e.modelId) != null ? _f : model.modelId,
							headers: (_g = result2.response) == null ? void 0 : _g.headers,
							body: (_h = result2.response) == null ? void 0 : _h.body
						};
						const text2 = extractTextContent(result2.content);
						const reasoning2 = extractReasoningContent(result2.content);
						if (text2 === void 0) throw new NoObjectGeneratedError({
							message: "No object generated: the model did not return a response.",
							response: responseData,
							usage: result2.usage,
							finishReason: result2.finishReason
						});
						span2.setAttributes(selectTelemetryAttributes({
							telemetry,
							attributes: {
								"ai.response.finishReason": result2.finishReason,
								"ai.response.object": { output: () => text2 },
								"ai.response.id": responseData.id,
								"ai.response.model": responseData.modelId,
								"ai.response.timestamp": responseData.timestamp.toISOString(),
								"ai.response.providerMetadata": JSON.stringify(result2.providerMetadata),
								"ai.usage.promptTokens": result2.usage.inputTokens,
								"ai.usage.completionTokens": result2.usage.outputTokens,
								"gen_ai.response.finish_reasons": [result2.finishReason],
								"gen_ai.response.id": responseData.id,
								"gen_ai.response.model": responseData.modelId,
								"gen_ai.usage.input_tokens": result2.usage.inputTokens,
								"gen_ai.usage.output_tokens": result2.usage.outputTokens
							}
						}));
						return {
							...result2,
							objectText: text2,
							reasoning: reasoning2,
							responseData
						};
					}
				}));
				result = generateResult.objectText;
				finishReason = generateResult.finishReason;
				usage = generateResult.usage;
				warnings = generateResult.warnings;
				resultProviderMetadata = generateResult.providerMetadata;
				request = (_a16 = generateResult.request) != null ? _a16 : {};
				response = generateResult.responseData;
				reasoning = generateResult.reasoning;
				logWarnings(warnings);
				const object2 = await parseAndValidateObjectResultWithRepair(result, outputStrategy, repairText, {
					response,
					usage,
					finishReason
				});
				span.setAttributes(selectTelemetryAttributes({
					telemetry,
					attributes: {
						"ai.response.finishReason": finishReason,
						"ai.response.object": { output: () => JSON.stringify(object2) },
						"ai.response.providerMetadata": JSON.stringify(resultProviderMetadata),
						"ai.usage.promptTokens": usage.inputTokens,
						"ai.usage.completionTokens": usage.outputTokens
					}
				}));
				return new DefaultGenerateObjectResult({
					object: object2,
					reasoning,
					finishReason,
					usage,
					warnings,
					request,
					response,
					providerMetadata: resultProviderMetadata
				});
			}
		});
	} catch (error) {
		throw wrapGatewayError(error);
	}
}
var DefaultGenerateObjectResult = class {
	constructor(options) {
		this.object = options.object;
		this.finishReason = options.finishReason;
		this.usage = options.usage;
		this.warnings = options.warnings;
		this.providerMetadata = options.providerMetadata;
		this.response = options.response;
		this.request = options.request;
		this.reasoning = options.reasoning;
	}
	toJsonResponse(init) {
		var _a16;
		return new Response(JSON.stringify(this.object), {
			status: (_a16 = init == null ? void 0 : init.status) != null ? _a16 : 200,
			headers: prepareHeaders(init == null ? void 0 : init.headers, { "content-type": "application/json; charset=utf-8" })
		});
	}
};
function cosineSimilarity(vector1, vector2) {
	if (vector1.length !== vector2.length) throw new InvalidArgumentError({
		parameter: "vector1,vector2",
		value: {
			vector1Length: vector1.length,
			vector2Length: vector2.length
		},
		message: `Vectors must have the same length`
	});
	const n = vector1.length;
	if (n === 0) return 0;
	let magnitudeSquared1 = 0;
	let magnitudeSquared2 = 0;
	let dotProduct = 0;
	for (let i = 0; i < n; i++) {
		const value1 = vector1[i];
		const value2 = vector2[i];
		magnitudeSquared1 += value1 * value1;
		magnitudeSquared2 += value2 * value2;
		dotProduct += value1 * value2;
	}
	return magnitudeSquared1 === 0 || magnitudeSquared2 === 0 ? 0 : dotProduct / (Math.sqrt(magnitudeSquared1) * Math.sqrt(magnitudeSquared2));
}
function createDownload(options) {
	return ({ url, abortSignal }) => download({
		url,
		maxBytes: options == null ? void 0 : options.maxBytes,
		abortSignal
	});
}
var { atob } = globalThis;
function getTextFromDataUrl(dataUrl) {
	const [header, base64Content] = dataUrl.split(",");
	if (header.split(";")[0].split(":")[1] == null || base64Content == null) throw new Error("Invalid data URL format");
	try {
		return atob(base64Content);
	} catch (error) {
		throw new Error(`Error decoding data URL`);
	}
}
function isDeepEqualData(obj1, obj2) {
	if (obj1 === obj2) return true;
	if (obj1 == null || obj2 == null) return false;
	if (typeof obj1 !== "object" && typeof obj2 !== "object") return obj1 === obj2;
	if (obj1.constructor !== obj2.constructor) return false;
	if (obj1 instanceof Date && obj2 instanceof Date) return obj1.getTime() === obj2.getTime();
	if (Array.isArray(obj1)) {
		if (obj1.length !== obj2.length) return false;
		for (let i = 0; i < obj1.length; i++) if (!isDeepEqualData(obj1[i], obj2[i])) return false;
		return true;
	}
	const keys1 = Object.keys(obj1);
	const keys2 = Object.keys(obj2);
	if (keys1.length !== keys2.length) return false;
	for (const key of keys1) {
		if (!keys2.includes(key)) return false;
		if (!isDeepEqualData(obj1[key], obj2[key])) return false;
	}
	return true;
}
var SerialJobExecutor = class {
	constructor() {
		this.queue = [];
		this.isProcessing = false;
		this.idleWaiters = [];
	}
	async processQueue() {
		if (this.isProcessing) return;
		this.isProcessing = true;
		try {
			while (this.queue.length > 0) {
				await this.queue[0]();
				this.queue.shift();
			}
		} finally {
			this.isProcessing = false;
			for (const resolve2 of this.idleWaiters.splice(0)) resolve2();
		}
	}
	async run(job) {
		return new Promise((resolve2, reject) => {
			this.queue.push(async () => {
				try {
					await job();
					resolve2();
				} catch (error) {
					reject(error);
				}
			});
			this.processQueue();
		});
	}
	async waitForIdle() {
		if (!this.isProcessing && this.queue.length === 0) return;
		await new Promise((resolve2) => {
			this.idleWaiters.push(resolve2);
		});
	}
};
function simulateReadableStream({ chunks, initialDelayInMs = 0, chunkDelayInMs = 0, _internal }) {
	var _a16;
	const delay2 = (_a16 = _internal == null ? void 0 : _internal.delay) != null ? _a16 : delay;
	let index = 0;
	return new ReadableStream({ async pull(controller) {
		if (index < chunks.length) {
			await delay2(index === 0 ? initialDelayInMs : chunkDelayInMs);
			controller.enqueue(chunks[index++]);
		} else controller.close();
	} });
}
var originalGenerateId4 = createIdGenerator({
	prefix: "aiobj",
	size: 24
});
async function markPromiseAsHandled(promise) {
	try {
		await promise;
	} catch (e) {}
}
function streamObject(options) {
	const { model, output = "object", system, prompt, messages, allowSystemInMessages, maxRetries, abortSignal, headers, experimental_repairText: repairText, experimental_telemetry: telemetry, experimental_download: download2, providerOptions, onError = ({ error }) => {
		console.error(error);
	}, onFinish, _internal: { generateId: generateId3 = originalGenerateId4, currentDate = () => /* @__PURE__ */ new Date(), now: now2 = now } = {}, ...settings } = options;
	const enumValues = "enum" in options && options.enum ? options.enum : void 0;
	const { schema: inputSchema, schemaDescription, schemaName } = "schema" in options ? options : {};
	validateObjectGenerationInput({
		output,
		schema: inputSchema,
		schemaName,
		schemaDescription,
		enumValues
	});
	return new DefaultStreamObjectResult({
		model,
		telemetry,
		headers,
		settings,
		maxRetries,
		abortSignal,
		outputStrategy: getOutputStrategy({
			output,
			schema: inputSchema,
			enumValues
		}),
		system,
		prompt,
		messages,
		allowSystemInMessages,
		schemaName,
		schemaDescription,
		providerOptions,
		repairText,
		onError,
		onFinish,
		download: download2,
		generateId: generateId3,
		currentDate,
		now: now2
	});
}
var DefaultStreamObjectResult = class {
	constructor({ model: modelArg, headers, telemetry, settings, maxRetries: maxRetriesArg, abortSignal, outputStrategy, system, prompt, messages, allowSystemInMessages, schemaName, schemaDescription, providerOptions, repairText, onError, onFinish, download: download2, generateId: generateId3, currentDate, now: now2 }) {
		this._object = new DelayedPromise();
		this._usage = new DelayedPromise();
		this._providerMetadata = new DelayedPromise();
		this._warnings = new DelayedPromise();
		this._request = new DelayedPromise();
		this._response = new DelayedPromise();
		this._finishReason = new DelayedPromise();
		const model = resolveLanguageModel(modelArg);
		const { maxRetries, retry } = prepareRetries({
			maxRetries: maxRetriesArg,
			abortSignal
		});
		const callSettings = prepareCallSettings(settings);
		const baseTelemetryAttributes = getBaseTelemetryAttributes({
			model,
			telemetry,
			headers,
			settings: {
				...callSettings,
				maxRetries
			}
		});
		const tracer = getTracer(telemetry);
		const self = this;
		const stitchableStream = createStitchableStream();
		const eventProcessor = new TransformStream({ transform(chunk, controller) {
			controller.enqueue(chunk);
			if (chunk.type === "error") notify({
				event: { error: wrapGatewayError(chunk.error) },
				callbacks: onError
			});
		} });
		this.baseStream = stitchableStream.stream.pipeThrough(eventProcessor);
		recordSpan({
			name: "ai.streamObject",
			attributes: selectTelemetryAttributes({
				telemetry,
				attributes: {
					...assembleOperationName({
						operationId: "ai.streamObject",
						telemetry
					}),
					...baseTelemetryAttributes,
					"ai.prompt": { input: () => JSON.stringify({
						system,
						prompt,
						messages
					}) },
					"ai.schema": outputStrategy.jsonSchema != null ? { input: () => JSON.stringify(outputStrategy.jsonSchema) } : void 0,
					"ai.schema.name": schemaName,
					"ai.schema.description": schemaDescription,
					"ai.settings.output": outputStrategy.type
				}
			}),
			tracer,
			endWhenDone: false,
			endOnError: true,
			fn: async (rootSpan) => {
				const standardizedPrompt = await standardizePrompt({
					system,
					prompt,
					messages,
					allowSystemInMessages
				});
				const callOptions = {
					responseFormat: {
						type: "json",
						schema: outputStrategy.jsonSchema,
						name: schemaName,
						description: schemaDescription
					},
					...prepareCallSettings(settings),
					prompt: await convertToLanguageModelPrompt({
						prompt: standardizedPrompt,
						supportedUrls: await model.supportedUrls,
						download: download2
					}),
					providerOptions,
					abortSignal,
					headers,
					includeRawChunks: false
				};
				const transformer = { transform: (chunk, controller) => {
					switch (chunk.type) {
						case "text-delta":
							controller.enqueue(chunk.delta);
							break;
						case "response-metadata":
						case "finish":
						case "error":
						case "stream-start": controller.enqueue(chunk);
					}
				} };
				const { result: { stream, response, request }, doStreamSpan, startTimestampMs } = await retry(() => recordSpan({
					name: "ai.streamObject.doStream",
					attributes: selectTelemetryAttributes({
						telemetry,
						attributes: {
							...assembleOperationName({
								operationId: "ai.streamObject.doStream",
								telemetry
							}),
							...baseTelemetryAttributes,
							"ai.prompt.messages": { input: () => stringifyForTelemetry(callOptions.prompt) },
							"gen_ai.system": model.provider,
							"gen_ai.request.model": model.modelId,
							"gen_ai.request.frequency_penalty": callSettings.frequencyPenalty,
							"gen_ai.request.max_tokens": callSettings.maxOutputTokens,
							"gen_ai.request.presence_penalty": callSettings.presencePenalty,
							"gen_ai.request.temperature": callSettings.temperature,
							"gen_ai.request.top_k": callSettings.topK,
							"gen_ai.request.top_p": callSettings.topP
						}
					}),
					tracer,
					endWhenDone: false,
					endOnError: true,
					fn: async (doStreamSpan2) => ({
						startTimestampMs: now2(),
						doStreamSpan: doStreamSpan2,
						result: await model.doStream(callOptions)
					})
				}));
				self._request.resolve(request != null ? request : {});
				let warnings;
				let usage = {
					inputTokens: void 0,
					outputTokens: void 0,
					totalTokens: void 0
				};
				let finishReason;
				let providerMetadata;
				let object2;
				let error;
				let terminalError;
				let accumulatedText = "";
				let textDelta = "";
				let fullResponse = {
					id: generateId3(),
					timestamp: currentDate(),
					modelId: model.modelId
				};
				let latestObjectJson = void 0;
				let latestObject = void 0;
				let isFirstChunk = true;
				let isFirstDelta = true;
				const transformedStream = stream.pipeThrough(new TransformStream(transformer)).pipeThrough(new TransformStream({
					async transform(chunk, controller) {
						var _a16, _b, _c;
						if (typeof chunk === "object" && chunk.type === "stream-start") {
							warnings = chunk.warnings;
							return;
						}
						if (isFirstChunk) {
							const msToFirstChunk = now2() - startTimestampMs;
							isFirstChunk = false;
							doStreamSpan.addEvent("ai.stream.firstChunk", { "ai.stream.msToFirstChunk": msToFirstChunk });
							doStreamSpan.setAttributes({ "ai.stream.msToFirstChunk": msToFirstChunk });
						}
						if (typeof chunk === "string") {
							accumulatedText += chunk;
							textDelta += chunk;
							const { value: currentObjectJson, state: parseState } = await parsePartialJson(accumulatedText);
							if (currentObjectJson !== void 0 && !isDeepEqualData(latestObjectJson, currentObjectJson)) {
								const validationResult = await outputStrategy.validatePartialResult({
									value: currentObjectJson,
									textDelta,
									latestObject,
									isFirstDelta,
									isFinalDelta: parseState === "successful-parse"
								});
								if (validationResult.success && !isDeepEqualData(latestObject, validationResult.value.partial)) {
									latestObjectJson = currentObjectJson;
									latestObject = validationResult.value.partial;
									controller.enqueue({
										type: "object",
										object: latestObject
									});
									controller.enqueue({
										type: "text-delta",
										textDelta: validationResult.value.textDelta
									});
									textDelta = "";
									isFirstDelta = false;
								}
							}
							return;
						}
						switch (chunk.type) {
							case "response-metadata":
								fullResponse = {
									id: (_a16 = chunk.id) != null ? _a16 : fullResponse.id,
									timestamp: (_b = chunk.timestamp) != null ? _b : fullResponse.timestamp,
									modelId: (_c = chunk.modelId) != null ? _c : fullResponse.modelId
								};
								break;
							case "error":
								if (terminalError === void 0) {
									const wrappedError = wrapGatewayError(chunk.error);
									terminalError = { error: wrappedError };
									error = wrappedError;
									finishReason = "error";
									self.rejectResultPromises(wrappedError);
								}
								controller.enqueue(chunk);
								break;
							case "finish":
								if (textDelta !== "") controller.enqueue({
									type: "text-delta",
									textDelta
								});
								finishReason = terminalError === void 0 ? chunk.finishReason : "error";
								usage = chunk.usage;
								providerMetadata = chunk.providerMetadata;
								controller.enqueue({
									...chunk,
									usage,
									response: fullResponse
								});
								logWarnings(warnings != null ? warnings : []);
								if (terminalError !== void 0) break;
								self._usage.resolve(usage);
								self._providerMetadata.resolve(providerMetadata);
								self._warnings.resolve(warnings);
								self._response.resolve({
									...fullResponse,
									headers: response == null ? void 0 : response.headers
								});
								self._finishReason.resolve(finishReason != null ? finishReason : "unknown");
								try {
									object2 = await parseAndValidateObjectResultWithRepair(accumulatedText, outputStrategy, repairText, {
										response: fullResponse,
										usage,
										finishReason
									});
									self._object.resolve(object2);
								} catch (e) {
									error = e;
									self._object.reject(e);
								}
								break;
							default: controller.enqueue(chunk);
						}
					},
					async flush(controller) {
						try {
							const finalUsage = usage != null ? usage : {
								promptTokens: NaN,
								completionTokens: NaN,
								totalTokens: NaN
							};
							doStreamSpan.setAttributes(selectTelemetryAttributes({
								telemetry,
								attributes: {
									"ai.response.finishReason": finishReason,
									"ai.response.object": { output: () => JSON.stringify(object2) },
									"ai.response.id": fullResponse.id,
									"ai.response.model": fullResponse.modelId,
									"ai.response.timestamp": fullResponse.timestamp.toISOString(),
									"ai.response.providerMetadata": JSON.stringify(providerMetadata),
									"ai.usage.inputTokens": finalUsage.inputTokens,
									"ai.usage.outputTokens": finalUsage.outputTokens,
									"ai.usage.totalTokens": finalUsage.totalTokens,
									"ai.usage.reasoningTokens": finalUsage.reasoningTokens,
									"ai.usage.cachedInputTokens": finalUsage.cachedInputTokens,
									"gen_ai.response.finish_reasons": [finishReason],
									"gen_ai.response.id": fullResponse.id,
									"gen_ai.response.model": fullResponse.modelId,
									"gen_ai.usage.input_tokens": finalUsage.inputTokens,
									"gen_ai.usage.output_tokens": finalUsage.outputTokens
								}
							}));
							doStreamSpan.end();
							rootSpan.setAttributes(selectTelemetryAttributes({
								telemetry,
								attributes: {
									"ai.usage.inputTokens": finalUsage.inputTokens,
									"ai.usage.outputTokens": finalUsage.outputTokens,
									"ai.usage.totalTokens": finalUsage.totalTokens,
									"ai.usage.reasoningTokens": finalUsage.reasoningTokens,
									"ai.usage.cachedInputTokens": finalUsage.cachedInputTokens,
									"ai.response.object": { output: () => JSON.stringify(object2) },
									"ai.response.providerMetadata": JSON.stringify(providerMetadata)
								}
							}));
							await (onFinish == null ? void 0 : onFinish({
								usage: finalUsage,
								object: object2,
								error,
								response: {
									...fullResponse,
									headers: response == null ? void 0 : response.headers
								},
								warnings,
								providerMetadata
							}));
						} catch (error2) {
							controller.enqueue({
								type: "error",
								error: error2
							});
						} finally {
							rootSpan.end();
						}
					}
				}));
				stitchableStream.addStream(transformedStream, { onError(error2) {
					const wrappedError = wrapGatewayError(error2);
					self.rejectResultPromises(wrappedError);
					notify({
						event: { error: wrappedError },
						callbacks: onError
					});
				} });
			}
		}).catch((error) => {
			self.rejectResultPromises(error);
			stitchableStream.addStream(new ReadableStream({ start(controller) {
				controller.enqueue({
					type: "error",
					error
				});
				controller.close();
			} }));
		}).finally(() => {
			stitchableStream.close();
		});
		this.outputStrategy = outputStrategy;
	}
	rejectResultPromises(error) {
		this.rejectResultPromise({
			delayedPromise: this._object,
			error
		});
		this.rejectResultPromise({
			delayedPromise: this._usage,
			error
		});
		this.rejectResultPromise({
			delayedPromise: this._providerMetadata,
			error
		});
		this.rejectResultPromise({
			delayedPromise: this._warnings,
			error
		});
		this.rejectResultPromise({
			delayedPromise: this._request,
			error
		});
		this.rejectResultPromise({
			delayedPromise: this._response,
			error
		});
		this.rejectResultPromise({
			delayedPromise: this._finishReason,
			error
		});
	}
	rejectResultPromise({ delayedPromise, error }) {
		if (delayedPromise.isPending()) {
			delayedPromise.reject(error);
			markPromiseAsHandled(delayedPromise.promise);
		}
	}
	get object() {
		return this._object.promise;
	}
	get usage() {
		return this._usage.promise;
	}
	get providerMetadata() {
		return this._providerMetadata.promise;
	}
	get warnings() {
		return this._warnings.promise;
	}
	get request() {
		return this._request.promise;
	}
	get response() {
		return this._response.promise;
	}
	get finishReason() {
		return this._finishReason.promise;
	}
	get partialObjectStream() {
		return createAsyncIterableStream(this.baseStream.pipeThrough(new TransformStream({ transform(chunk, controller) {
			switch (chunk.type) {
				case "object":
					controller.enqueue(chunk.object);
					break;
				case "text-delta":
				case "finish":
				case "error": break;
				default: throw new Error(`Unsupported chunk type: ${chunk}`);
			}
		} })));
	}
	get elementStream() {
		return this.outputStrategy.createElementStream(this.baseStream);
	}
	get textStream() {
		return createAsyncIterableStream(this.baseStream.pipeThrough(new TransformStream({ transform(chunk, controller) {
			switch (chunk.type) {
				case "text-delta":
					controller.enqueue(chunk.textDelta);
					break;
				case "object":
				case "finish":
				case "error": break;
				default: throw new Error(`Unsupported chunk type: ${chunk}`);
			}
		} })));
	}
	get fullStream() {
		return createAsyncIterableStream(this.baseStream);
	}
	pipeTextStreamToResponse(response, init) {
		return pipeTextStreamToResponse({
			response,
			textStream: this.textStream,
			...init
		});
	}
	toTextStreamResponse(init) {
		return createTextStreamResponse({
			textStream: this.textStream,
			...init
		});
	}
};
var DefaultGeneratedAudioFile = class extends DefaultGeneratedFile {
	constructor({ data, mediaType }) {
		super({
			data,
			mediaType
		});
		let format = "mp3";
		if (mediaType) {
			const mediaTypeParts = mediaType.split("/");
			if (mediaTypeParts.length === 2) {
				if (mediaType !== "audio/mpeg") format = mediaTypeParts[1];
			}
		}
		if (!format) throw new Error("Audio format must be provided or determinable from media type");
		this.format = format;
	}
};
async function generateSpeech({ model, text: text2, voice, outputFormat, instructions, speed, language, providerOptions = {}, maxRetries: maxRetriesArg, abortSignal, headers }) {
	var _a16;
	if (model.specificationVersion !== "v2") throw new UnsupportedModelVersionError({
		version: model.specificationVersion,
		provider: model.provider,
		modelId: model.modelId
	});
	const headersWithUserAgent = withUserAgentSuffix(headers != null ? headers : {}, `ai/${VERSION}`);
	const { retry } = prepareRetries({
		maxRetries: maxRetriesArg,
		abortSignal
	});
	const result = await retry(() => model.doGenerate({
		text: text2,
		voice,
		outputFormat,
		instructions,
		speed,
		language,
		abortSignal,
		headers: headersWithUserAgent,
		providerOptions
	}));
	if (!result.audio || result.audio.length === 0) throw new NoSpeechGeneratedError({ responses: [result.response] });
	logWarnings(result.warnings);
	return new DefaultSpeechResult({
		audio: new DefaultGeneratedAudioFile({
			data: result.audio,
			mediaType: (_a16 = detectMediaType({
				data: result.audio,
				signatures: audioMediaTypeSignatures
			})) != null ? _a16 : "audio/mp3"
		}),
		warnings: result.warnings,
		responses: [result.response],
		providerMetadata: result.providerMetadata
	});
}
var DefaultSpeechResult = class {
	constructor(options) {
		var _a16;
		this.audio = options.audio;
		this.warnings = options.warnings;
		this.responses = options.responses;
		this.providerMetadata = (_a16 = options.providerMetadata) != null ? _a16 : {};
	}
};
var output_exports = {};
__export(output_exports, {
	object: () => object,
	text: () => text
});
var text = () => ({
	type: "text",
	responseFormat: { type: "text" },
	async parsePartial({ text: text2 }) {
		return { partial: text2 };
	},
	async parseOutput({ text: text2 }) {
		return text2;
	}
});
var object = ({ schema: inputSchema }) => {
	const schema = asSchema(inputSchema);
	return {
		type: "object",
		responseFormat: {
			type: "json",
			schema: schema.jsonSchema
		},
		async parsePartial({ text: text2 }) {
			const result = await parsePartialJson(text2);
			switch (result.state) {
				case "failed-parse":
				case "undefined-input": return;
				case "repaired-parse":
				case "successful-parse": return { partial: result.value };
				default: {
					const _exhaustiveCheck = result.state;
					throw new Error(`Unsupported parse state: ${_exhaustiveCheck}`);
				}
			}
		},
		async parseOutput({ text: text2 }, context) {
			const parseResult = await safeParseJSON({ text: text2 });
			if (!parseResult.success) throw new NoObjectGeneratedError({
				message: "No object generated: could not parse the response.",
				cause: parseResult.error,
				text: text2,
				response: context.response,
				usage: context.usage,
				finishReason: context.finishReason
			});
			const validationResult = await safeValidateTypes({
				value: parseResult.value,
				schema
			});
			if (!validationResult.success) throw new NoObjectGeneratedError({
				message: "No object generated: response did not match schema.",
				cause: validationResult.error,
				text: text2,
				response: context.response,
				usage: context.usage,
				finishReason: context.finishReason
			});
			return validationResult.value;
		}
	};
};
function pruneMessages({ messages, reasoning = "none", toolCalls = [], emptyMessages = "remove" }) {
	if (reasoning === "all" || reasoning === "before-last-message") messages = messages.map((message, messageIndex) => {
		if (message.role !== "assistant" || typeof message.content === "string" || reasoning === "before-last-message" && messageIndex === messages.length - 1) return message;
		return {
			...message,
			content: message.content.filter((part) => part.type !== "reasoning")
		};
	});
	if (toolCalls === "none") toolCalls = [];
	else if (toolCalls === "all") toolCalls = [{ type: "all" }];
	else if (toolCalls === "before-last-message") toolCalls = [{ type: "before-last-message" }];
	else if (typeof toolCalls === "string") toolCalls = [{ type: toolCalls }];
	for (const toolCall of toolCalls) {
		const keepLastMessagesCount = toolCall.type === "all" ? void 0 : toolCall.type === "before-last-message" ? 1 : Number(toolCall.type.slice(12).slice(0, -9));
		const keptToolCallIds = /* @__PURE__ */ new Set();
		if (keepLastMessagesCount != null) {
			for (const message of messages.slice(-keepLastMessagesCount)) if ((message.role === "assistant" || message.role === "tool") && typeof message.content !== "string") {
				for (const part of message.content) if (part.type === "tool-call" || part.type === "tool-result") keptToolCallIds.add(part.toolCallId);
			}
		}
		messages = messages.map((message, messageIndex) => {
			if (message.role !== "assistant" && message.role !== "tool" || typeof message.content === "string" || keepLastMessagesCount && messageIndex >= messages.length - keepLastMessagesCount) return message;
			const toolCallIdToToolName = {};
			return {
				...message,
				content: message.content.filter((part) => {
					if (part.type !== "tool-call" && part.type !== "tool-result") return true;
					if (part.type === "tool-call") toolCallIdToToolName[part.toolCallId] = part.toolName;
					if ((part.type === "tool-call" || part.type === "tool-result") && keptToolCallIds.has(part.toolCallId)) return true;
					return toolCall.tools != null && !toolCall.tools.includes(part.toolName);
				})
			};
		});
	}
	if (emptyMessages === "remove") messages = messages.filter((message) => message.content.length > 0);
	return messages;
}
var CHUNKING_REGEXPS = {
	word: /\S+\s+/m,
	line: /\n+/m
};
function isDocumentHidden() {
	return typeof document !== "undefined" && document.visibilityState === "hidden";
}
function smoothStream({ delayInMs = 10, chunking = "word", _internal: { delay: delay2 = delay } = {} } = {}) {
	let detectChunk;
	if (typeof chunking === "function") detectChunk = (buffer) => {
		const match = chunking(buffer);
		if (match == null) return null;
		if (!match.length) throw new Error(`Chunking function must return a non-empty string.`);
		if (!buffer.startsWith(match)) throw new Error(`Chunking function must return a match that is a prefix of the buffer. Received: "${match}" expected to start with "${buffer}"`);
		return match;
	};
	else {
		const chunkingRegex = typeof chunking === "string" ? CHUNKING_REGEXPS[chunking] : chunking;
		if (chunkingRegex == null) throw new InvalidArgumentError$1({
			argument: "chunking",
			message: `Chunking must be "word" or "line" or a RegExp. Received: ${chunking}`
		});
		detectChunk = (buffer) => {
			const match = chunkingRegex.exec(buffer);
			if (!match) return null;
			return buffer.slice(0, match.index) + (match == null ? void 0 : match[0]);
		};
	}
	return () => {
		let buffer = "";
		let id = "";
		let providerMetadata;
		function flushBuffer(controller) {
			if (buffer.length > 0 || providerMetadata != null) {
				controller.enqueue({
					type: "text-delta",
					text: buffer,
					id,
					...providerMetadata != null ? { providerMetadata } : {}
				});
				buffer = "";
				providerMetadata = void 0;
			}
		}
		return new TransformStream({ async transform(chunk, controller) {
			if (chunk.type !== "text-delta") {
				flushBuffer(controller);
				controller.enqueue(chunk);
				return;
			}
			if (chunk.text.length === 0 && chunk.providerMetadata != null) {
				flushBuffer(controller);
				controller.enqueue(chunk);
				return;
			}
			if (buffer.length > 0 && (chunk.id !== id || providerMetadata != null || chunk.providerMetadata != null)) flushBuffer(controller);
			buffer += chunk.text;
			id = chunk.id;
			providerMetadata = chunk.providerMetadata;
			let match;
			while ((match = detectChunk(buffer)) != null) {
				controller.enqueue({
					type: "text-delta",
					text: match,
					id,
					...providerMetadata != null ? { providerMetadata } : {}
				});
				buffer = buffer.slice(match.length);
				await delay2(isDocumentHidden() ? null : delayInMs);
			}
			if (buffer.length === 0) providerMetadata = void 0;
		} });
	};
}
function defaultSettingsMiddleware({ settings }) {
	return {
		middlewareVersion: "v2",
		transformParams: async ({ params }) => {
			return mergeObjects(settings, params);
		}
	};
}
function getPotentialStartIndex(text2, searchedText) {
	if (searchedText.length === 0) return null;
	const directIndex = text2.indexOf(searchedText);
	if (directIndex !== -1) return directIndex;
	for (let i = text2.length - 1; i >= 0; i--) {
		const suffix = text2.substring(i);
		if (searchedText.startsWith(suffix)) return i;
	}
	return null;
}
function extractReasoningMiddleware({ tagName, separator = "\n", startWithReasoning = false }) {
	const openingTag = `<${tagName}>`;
	const closingTag = `</${tagName}>`;
	return {
		middlewareVersion: "v2",
		wrapGenerate: async ({ doGenerate }) => {
			const { content, ...rest } = await doGenerate();
			const transformedContent = [];
			for (const part of content) {
				if (part.type !== "text") {
					transformedContent.push(part);
					continue;
				}
				const text2 = startWithReasoning ? openingTag + part.text : part.text;
				const regexp = new RegExp(`${openingTag}(.*?)${closingTag}`, "gs");
				const matches = Array.from(text2.matchAll(regexp));
				if (!matches.length) {
					transformedContent.push(part);
					continue;
				}
				const reasoningText = matches.map((match) => match[1]).join(separator);
				let textWithoutReasoning = text2;
				for (let i = matches.length - 1; i >= 0; i--) {
					const match = matches[i];
					const beforeMatch = textWithoutReasoning.slice(0, match.index);
					const afterMatch = textWithoutReasoning.slice(match.index + match[0].length);
					textWithoutReasoning = beforeMatch + (beforeMatch.length > 0 && afterMatch.length > 0 ? separator : "") + afterMatch;
				}
				transformedContent.push({
					type: "reasoning",
					text: reasoningText
				});
				transformedContent.push({
					type: "text",
					text: textWithoutReasoning
				});
			}
			return {
				content: transformedContent,
				...rest
			};
		},
		wrapStream: async ({ doStream }) => {
			const { stream, ...rest } = await doStream();
			const reasoningExtractions = createIdMap();
			let delayedTextStart;
			return {
				stream: stream.pipeThrough(new TransformStream({ transform: (chunk, controller) => {
					if (chunk.type === "text-start") {
						delayedTextStart = chunk;
						return;
					}
					if (chunk.type === "text-end" && delayedTextStart) {
						controller.enqueue(delayedTextStart);
						delayedTextStart = void 0;
					}
					if (chunk.type !== "text-delta") {
						controller.enqueue(chunk);
						return;
					}
					if (reasoningExtractions[chunk.id] == null) reasoningExtractions[chunk.id] = {
						isFirstReasoning: true,
						isFirstText: true,
						afterSwitch: false,
						isReasoning: startWithReasoning,
						buffer: "",
						idCounter: 0,
						textId: chunk.id
					};
					const activeExtraction = reasoningExtractions[chunk.id];
					activeExtraction.buffer += chunk.delta;
					function publish(text2) {
						if (text2.length > 0) {
							const prefix = activeExtraction.afterSwitch && (activeExtraction.isReasoning ? !activeExtraction.isFirstReasoning : !activeExtraction.isFirstText) ? separator : "";
							if (activeExtraction.isReasoning && (activeExtraction.afterSwitch || activeExtraction.isFirstReasoning)) controller.enqueue({
								type: "reasoning-start",
								id: `reasoning-${activeExtraction.idCounter}`
							});
							if (activeExtraction.isReasoning) controller.enqueue({
								type: "reasoning-delta",
								delta: prefix + text2,
								id: `reasoning-${activeExtraction.idCounter}`
							});
							else {
								if (delayedTextStart) {
									controller.enqueue(delayedTextStart);
									delayedTextStart = void 0;
								}
								controller.enqueue({
									type: "text-delta",
									delta: prefix + text2,
									id: activeExtraction.textId
								});
							}
							activeExtraction.afterSwitch = false;
							if (activeExtraction.isReasoning) activeExtraction.isFirstReasoning = false;
							else activeExtraction.isFirstText = false;
						}
					}
					do {
						const nextTag = activeExtraction.isReasoning ? closingTag : openingTag;
						const startIndex = getPotentialStartIndex(activeExtraction.buffer, nextTag);
						if (startIndex == null) {
							publish(activeExtraction.buffer);
							activeExtraction.buffer = "";
							break;
						}
						publish(activeExtraction.buffer.slice(0, startIndex));
						if (startIndex + nextTag.length <= activeExtraction.buffer.length) {
							activeExtraction.buffer = activeExtraction.buffer.slice(startIndex + nextTag.length);
							if (activeExtraction.isReasoning) controller.enqueue({
								type: "reasoning-end",
								id: `reasoning-${activeExtraction.idCounter++}`
							});
							activeExtraction.isReasoning = !activeExtraction.isReasoning;
							activeExtraction.afterSwitch = true;
						} else {
							activeExtraction.buffer = activeExtraction.buffer.slice(startIndex);
							break;
						}
					} while (true);
				} })),
				...rest
			};
		}
	};
}
function simulateStreamingMiddleware() {
	return {
		middlewareVersion: "v2",
		wrapStream: async ({ doGenerate }) => {
			const result = await doGenerate();
			let id = 0;
			return {
				stream: new ReadableStream({ start(controller) {
					controller.enqueue({
						type: "stream-start",
						warnings: result.warnings
					});
					controller.enqueue({
						type: "response-metadata",
						...result.response
					});
					for (const part of result.content) switch (part.type) {
						case "text":
							if (part.text.length > 0) {
								controller.enqueue({
									type: "text-start",
									id: String(id),
									...part.providerMetadata != null ? { providerMetadata: part.providerMetadata } : {}
								});
								controller.enqueue({
									type: "text-delta",
									id: String(id),
									delta: part.text
								});
								controller.enqueue({
									type: "text-end",
									id: String(id)
								});
								id++;
							}
							break;
						case "reasoning":
							controller.enqueue({
								type: "reasoning-start",
								id: String(id),
								providerMetadata: part.providerMetadata
							});
							controller.enqueue({
								type: "reasoning-delta",
								id: String(id),
								delta: part.text
							});
							controller.enqueue({
								type: "reasoning-end",
								id: String(id)
							});
							id++;
							break;
						default: controller.enqueue(part);
					}
					controller.enqueue({
						type: "finish",
						finishReason: result.finishReason,
						usage: result.usage,
						providerMetadata: result.providerMetadata
					});
					controller.close();
				} }),
				request: result.request,
				response: result.response
			};
		}
	};
}
var wrapLanguageModel = ({ model, middleware: middlewareArg, modelId, providerId }) => {
	return [...asArray(middlewareArg)].reverse().reduce((wrappedModel, middleware) => {
		return doWrap({
			model: wrappedModel,
			middleware,
			modelId,
			providerId
		});
	}, model);
};
var doWrap = ({ model, middleware: { transformParams, wrapGenerate, wrapStream, overrideProvider, overrideModelId, overrideSupportedUrls }, modelId, providerId }) => {
	var _a16, _b, _c;
	async function doTransform({ params, type }) {
		return transformParams ? await transformParams({
			params,
			type,
			model
		}) : params;
	}
	return {
		specificationVersion: "v2",
		provider: (_a16 = providerId != null ? providerId : overrideProvider == null ? void 0 : overrideProvider({ model })) != null ? _a16 : model.provider,
		modelId: (_b = modelId != null ? modelId : overrideModelId == null ? void 0 : overrideModelId({ model })) != null ? _b : model.modelId,
		supportedUrls: (_c = overrideSupportedUrls == null ? void 0 : overrideSupportedUrls({ model })) != null ? _c : model.supportedUrls,
		async doGenerate(params) {
			const transformedParams = await doTransform({
				params,
				type: "generate"
			});
			const doGenerate = async () => model.doGenerate(transformedParams);
			const doStream = async () => model.doStream(transformedParams);
			return wrapGenerate ? wrapGenerate({
				doGenerate,
				doStream,
				params: transformedParams,
				model
			}) : doGenerate();
		},
		async doStream(params) {
			const transformedParams = await doTransform({
				params,
				type: "stream"
			});
			const doGenerate = async () => model.doGenerate(transformedParams);
			const doStream = async () => model.doStream(transformedParams);
			return wrapStream ? wrapStream({
				doGenerate,
				doStream,
				params: transformedParams,
				model
			}) : doStream();
		}
	};
};
function wrapProvider({ provider, languageModelMiddleware }) {
	return {
		languageModel(modelId) {
			let model = provider.languageModel(modelId);
			model = wrapLanguageModel({
				model,
				middleware: languageModelMiddleware
			});
			return model;
		},
		textEmbeddingModel: provider.textEmbeddingModel,
		imageModel: provider.imageModel,
		transcriptionModel: provider.transcriptionModel,
		speechModel: provider.speechModel
	};
}
function customProvider({ languageModels, textEmbeddingModels, imageModels, transcriptionModels, speechModels, fallbackProvider }) {
	return {
		languageModel(modelId) {
			if (languageModels != null && modelId in languageModels) return languageModels[modelId];
			if (fallbackProvider) return fallbackProvider.languageModel(modelId);
			throw new NoSuchModelError({
				modelId,
				modelType: "languageModel"
			});
		},
		textEmbeddingModel(modelId) {
			if (textEmbeddingModels != null && modelId in textEmbeddingModels) return textEmbeddingModels[modelId];
			if (fallbackProvider) return fallbackProvider.textEmbeddingModel(modelId);
			throw new NoSuchModelError({
				modelId,
				modelType: "textEmbeddingModel"
			});
		},
		imageModel(modelId) {
			if (imageModels != null && modelId in imageModels) return imageModels[modelId];
			if (fallbackProvider == null ? void 0 : fallbackProvider.imageModel) return fallbackProvider.imageModel(modelId);
			throw new NoSuchModelError({
				modelId,
				modelType: "imageModel"
			});
		},
		transcriptionModel(modelId) {
			if (transcriptionModels != null && modelId in transcriptionModels) return transcriptionModels[modelId];
			if (fallbackProvider == null ? void 0 : fallbackProvider.transcriptionModel) return fallbackProvider.transcriptionModel(modelId);
			throw new NoSuchModelError({
				modelId,
				modelType: "transcriptionModel"
			});
		},
		speechModel(modelId) {
			if (speechModels != null && modelId in speechModels) return speechModels[modelId];
			if (fallbackProvider == null ? void 0 : fallbackProvider.speechModel) return fallbackProvider.speechModel(modelId);
			throw new NoSuchModelError({
				modelId,
				modelType: "speechModel"
			});
		}
	};
}
var experimental_customProvider = customProvider;
var name15 = "AI_NoSuchProviderError";
var marker15 = `vercel.ai.error.${name15}`;
var symbol15 = Symbol.for(marker15);
var _a15;
var NoSuchProviderError = class extends NoSuchModelError {
	constructor({ modelId, modelType, providerId, availableProviders, message = `No such provider: ${providerId} (available providers: ${availableProviders.join()})` }) {
		super({
			errorName: name15,
			modelId,
			modelType,
			message
		});
		this[_a15] = true;
		this.providerId = providerId;
		this.availableProviders = availableProviders;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker15);
	}
};
_a15 = symbol15;
function createProviderRegistry(providers, { separator = ":", languageModelMiddleware } = {}) {
	const registry = new DefaultProviderRegistry({
		separator,
		languageModelMiddleware
	});
	for (const [id, provider] of Object.entries(providers)) registry.registerProvider({
		id,
		provider
	});
	return registry;
}
var experimental_createProviderRegistry = createProviderRegistry;
var DefaultProviderRegistry = class {
	constructor({ separator, languageModelMiddleware }) {
		this.providers = /* @__PURE__ */ Object.create(null);
		this.separator = separator;
		this.languageModelMiddleware = languageModelMiddleware;
	}
	registerProvider({ id, provider }) {
		this.providers[id] = provider;
	}
	getProvider(id, modelType) {
		const provider = this.providers[id];
		if (provider == null) throw new NoSuchProviderError({
			modelId: id,
			modelType,
			providerId: id,
			availableProviders: Object.keys(this.providers)
		});
		return provider;
	}
	splitId(id, modelType) {
		const index = id.indexOf(this.separator);
		if (index === -1) throw new NoSuchModelError({
			modelId: id,
			modelType,
			message: `Invalid ${modelType} id for registry: ${id} (must be in the format "providerId${this.separator}modelId")`
		});
		return [id.slice(0, index), id.slice(index + this.separator.length)];
	}
	languageModel(id) {
		var _a16, _b;
		const [providerId, modelId] = this.splitId(id, "languageModel");
		let model = (_b = (_a16 = this.getProvider(providerId, "languageModel")).languageModel) == null ? void 0 : _b.call(_a16, modelId);
		if (model == null) throw new NoSuchModelError({
			modelId: id,
			modelType: "languageModel"
		});
		if (this.languageModelMiddleware != null) model = wrapLanguageModel({
			model,
			middleware: this.languageModelMiddleware
		});
		return model;
	}
	textEmbeddingModel(id) {
		var _a16;
		const [providerId, modelId] = this.splitId(id, "textEmbeddingModel");
		const provider = this.getProvider(providerId, "textEmbeddingModel");
		const model = (_a16 = provider.textEmbeddingModel) == null ? void 0 : _a16.call(provider, modelId);
		if (model == null) throw new NoSuchModelError({
			modelId: id,
			modelType: "textEmbeddingModel"
		});
		return model;
	}
	imageModel(id) {
		var _a16;
		const [providerId, modelId] = this.splitId(id, "imageModel");
		const provider = this.getProvider(providerId, "imageModel");
		const model = (_a16 = provider.imageModel) == null ? void 0 : _a16.call(provider, modelId);
		if (model == null) throw new NoSuchModelError({
			modelId: id,
			modelType: "imageModel"
		});
		return model;
	}
	transcriptionModel(id) {
		var _a16;
		const [providerId, modelId] = this.splitId(id, "transcriptionModel");
		const provider = this.getProvider(providerId, "transcriptionModel");
		const model = (_a16 = provider.transcriptionModel) == null ? void 0 : _a16.call(provider, modelId);
		if (model == null) throw new NoSuchModelError({
			modelId: id,
			modelType: "transcriptionModel"
		});
		return model;
	}
	speechModel(id) {
		var _a16;
		const [providerId, modelId] = this.splitId(id, "speechModel");
		const provider = this.getProvider(providerId, "speechModel");
		const model = (_a16 = provider.speechModel) == null ? void 0 : _a16.call(provider, modelId);
		if (model == null) throw new NoSuchModelError({
			modelId: id,
			modelType: "speechModel"
		});
		return model;
	}
};
var NoTranscriptGeneratedError = class extends AISDKError {
	constructor(options) {
		super({
			name: "AI_NoTranscriptGeneratedError",
			message: "No transcript generated."
		});
		this.responses = options.responses;
	}
};
var defaultDownload = createDownload();
async function transcribe({ model, audio, providerOptions = {}, maxRetries: maxRetriesArg, abortSignal, headers, download: downloadFn = defaultDownload }) {
	if (model.specificationVersion !== "v2") throw new UnsupportedModelVersionError({
		version: model.specificationVersion,
		provider: model.provider,
		modelId: model.modelId
	});
	const { retry } = prepareRetries({
		maxRetries: maxRetriesArg,
		abortSignal
	});
	const headersWithUserAgent = withUserAgentSuffix(headers != null ? headers : {}, `ai/${VERSION}`);
	const audioData = audio instanceof URL ? (await downloadFn({
		url: audio,
		abortSignal
	})).data : convertDataContentToUint8Array(audio);
	const result = await retry(() => {
		var _a16;
		return model.doGenerate({
			audio: audioData,
			abortSignal,
			headers: headersWithUserAgent,
			providerOptions,
			mediaType: (_a16 = detectMediaType({
				data: audioData,
				signatures: audioMediaTypeSignatures
			})) != null ? _a16 : "audio/wav"
		});
	});
	logWarnings(result.warnings);
	if (!result.text) throw new NoTranscriptGeneratedError({ responses: [result.response] });
	return new DefaultTranscriptionResult({
		text: result.text,
		segments: result.segments,
		language: result.language,
		durationInSeconds: result.durationInSeconds,
		warnings: result.warnings,
		responses: [result.response],
		providerMetadata: result.providerMetadata
	});
}
var DefaultTranscriptionResult = class {
	constructor(options) {
		var _a16;
		this.text = options.text;
		this.segments = options.segments;
		this.language = options.language;
		this.durationInSeconds = options.durationInSeconds;
		this.warnings = options.warnings;
		this.responses = options.responses;
		this.providerMetadata = (_a16 = options.providerMetadata) != null ? _a16 : {};
	}
};
async function processTextStream({ stream, onTextPart }) {
	const reader = stream.pipeThrough(new TextDecoderStream()).getReader();
	while (true) {
		const { done, value } = await reader.read();
		if (done) break;
		await onTextPart(value);
	}
}
var getOriginalFetch = () => fetch;
async function callCompletionApi({ api, prompt, credentials, headers, body, streamProtocol = "data", setCompletion, setLoading, setError, setAbortController, onFinish, onError, fetch: fetch2 = getOriginalFetch() }) {
	var _a16;
	try {
		setLoading(true);
		setError(void 0);
		const abortController = new AbortController();
		setAbortController(abortController);
		setCompletion("");
		const response = await fetch2(api, {
			method: "POST",
			body: JSON.stringify({
				prompt,
				...body
			}),
			credentials,
			headers: withUserAgentSuffix({
				"Content-Type": "application/json",
				...headers
			}, `ai-sdk/${VERSION}`, getRuntimeEnvironmentUserAgent()),
			signal: abortController.signal
		}).catch((err) => {
			throw err;
		});
		if (!response.ok) throw new Error((_a16 = await response.text()) != null ? _a16 : "Failed to fetch the chat response.");
		if (!response.body) throw new Error("The response body is empty.");
		let result = "";
		switch (streamProtocol) {
			case "text":
				await processTextStream({
					stream: response.body,
					onTextPart: (chunk) => {
						result += chunk;
						setCompletion(result);
					}
				});
				break;
			case "data":
				await consumeStream({
					stream: parseJsonEventStream({
						stream: response.body,
						schema: uiMessageChunkSchema
					}).pipeThrough(new TransformStream({ async transform(part) {
						if (!part.success) throw part.error;
						const streamPart = part.value;
						if (streamPart.type === "text-delta") {
							result += streamPart.delta;
							setCompletion(result);
						} else if (streamPart.type === "error") throw new Error(streamPart.errorText);
					} })),
					onError: (error) => {
						throw error;
					}
				});
				break;
			default: throw new Error(`Unknown stream protocol: ${streamProtocol}`);
		}
		if (onFinish) onFinish(prompt, result);
		setAbortController(null);
		return result;
	} catch (err) {
		if (err.name === "AbortError") {
			setAbortController(null);
			return null;
		}
		if (err instanceof Error) {
			if (onError) onError(err);
		}
		setError(err);
	} finally {
		setLoading(false);
	}
}
async function convertFileListToFileUIParts(files) {
	if (files == null) return [];
	if (!globalThis.FileList || !(files instanceof globalThis.FileList)) throw new Error("FileList is not supported in the current environment");
	return Promise.all(Array.from(files).map(async (file) => {
		const { name: name16, type } = file;
		return {
			type: "file",
			mediaType: type,
			filename: name16,
			url: await new Promise((resolve2, reject) => {
				const reader = new FileReader();
				reader.onload = (readerEvent) => {
					var _a16;
					resolve2((_a16 = readerEvent.target) == null ? void 0 : _a16.result);
				};
				reader.onerror = (error) => reject(error);
				reader.readAsDataURL(file);
			})
		};
	}));
}
function appendPathToUrl(url, path) {
	const queryOrFragmentStart = url.search(/[?#]/);
	const urlPath = queryOrFragmentStart === -1 ? url : url.slice(0, queryOrFragmentStart);
	const suffix = queryOrFragmentStart === -1 ? "" : url.slice(queryOrFragmentStart);
	return `${urlPath.endsWith("/") && path.startsWith("/") ? urlPath.slice(0, -1) : urlPath}${path}${suffix}`;
}
var HttpChatTransport = class {
	constructor({ api = "/api/chat", credentials, headers, body, fetch: fetch2, prepareSendMessagesRequest, prepareReconnectToStreamRequest }) {
		this.api = api;
		this.credentials = credentials;
		this.headers = headers;
		this.body = body;
		this.fetch = fetch2;
		this.prepareSendMessagesRequest = prepareSendMessagesRequest;
		this.prepareReconnectToStreamRequest = prepareReconnectToStreamRequest;
	}
	async sendMessages({ abortSignal, ...options }) {
		var _a16, _b, _c, _d, _e;
		const resolvedBody = await resolve(this.body);
		const resolvedHeaders = await resolve(this.headers);
		const resolvedCredentials = await resolve(this.credentials);
		const baseHeaders = {
			...normalizeHeaders(resolvedHeaders),
			...normalizeHeaders(options.headers)
		};
		const preparedRequest = await ((_a16 = this.prepareSendMessagesRequest) == null ? void 0 : _a16.call(this, {
			api: this.api,
			id: options.chatId,
			messages: options.messages,
			body: {
				...resolvedBody,
				...options.body
			},
			headers: baseHeaders,
			credentials: resolvedCredentials,
			requestMetadata: options.metadata,
			trigger: options.trigger,
			messageId: options.messageId
		}));
		const api = (_b = preparedRequest == null ? void 0 : preparedRequest.api) != null ? _b : this.api;
		const headers = (preparedRequest == null ? void 0 : preparedRequest.headers) !== void 0 ? normalizeHeaders(preparedRequest.headers) : baseHeaders;
		const body = (preparedRequest == null ? void 0 : preparedRequest.body) !== void 0 ? preparedRequest.body : {
			...resolvedBody,
			...options.body,
			id: options.chatId,
			messages: options.messages,
			trigger: options.trigger,
			messageId: options.messageId
		};
		const credentials = (_c = preparedRequest == null ? void 0 : preparedRequest.credentials) != null ? _c : resolvedCredentials;
		const response = await ((_d = this.fetch) != null ? _d : globalThis.fetch)(api, {
			method: "POST",
			headers: {
				"content-type": "application/json",
				...headers
			},
			body: JSON.stringify(body),
			credentials,
			signal: abortSignal
		});
		if (!response.ok) throw new Error((_e = await response.text()) != null ? _e : "Failed to fetch the chat response.");
		if (!response.body) throw new Error("The response body is empty.");
		return this.processResponseStream(response.body);
	}
	async reconnectToStream(options) {
		var _a16, _b, _c, _d;
		const resolvedBody = await resolve(this.body);
		const resolvedHeaders = await resolve(this.headers);
		const resolvedCredentials = await resolve(this.credentials);
		const baseHeaders = {
			...normalizeHeaders(resolvedHeaders),
			...normalizeHeaders(options.headers)
		};
		const preparedRequest = await ((_a16 = this.prepareReconnectToStreamRequest) == null ? void 0 : _a16.call(this, {
			api: this.api,
			id: options.chatId,
			body: {
				...resolvedBody,
				...options.body
			},
			headers: baseHeaders,
			credentials: resolvedCredentials,
			requestMetadata: options.metadata
		}));
		let api = preparedRequest == null ? void 0 : preparedRequest.api;
		if (api == null) {
			if (options.chatId === "." || options.chatId === "..") throw new InvalidArgumentError({
				parameter: "chatId",
				value: options.chatId,
				message: "Chat IDs must not be \".\" or \"..\" when using the default reconnect URL."
			});
			api = appendPathToUrl(this.api, `/${encodeURIComponent(options.chatId)}/stream`);
		}
		const headers = (preparedRequest == null ? void 0 : preparedRequest.headers) !== void 0 ? normalizeHeaders(preparedRequest.headers) : baseHeaders;
		const credentials = (_b = preparedRequest == null ? void 0 : preparedRequest.credentials) != null ? _b : resolvedCredentials;
		const response = await ((_c = this.fetch) != null ? _c : globalThis.fetch)(api, {
			method: "GET",
			headers,
			credentials,
			signal: options.abortSignal
		});
		if (response.status === 204) return null;
		if (!response.ok) throw new Error((_d = await response.text()) != null ? _d : "Failed to fetch the chat response.");
		if (!response.body) throw new Error("The response body is empty.");
		return this.processResponseStream(response.body);
	}
};
var DefaultChatTransport = class extends HttpChatTransport {
	constructor(options = {}) {
		super(options);
	}
	processResponseStream(stream) {
		return parseJsonEventStream({
			stream,
			schema: uiMessageChunkSchema
		}).pipeThrough(new TransformStream({ async transform(chunk, controller) {
			if (!chunk.success) throw chunk.error;
			controller.enqueue(chunk.value);
		} }));
	}
};
var AbstractChat = class {
	constructor({ generateId: generateId3 = generateId, id = generateId3(), transport = new DefaultChatTransport(), messageMetadataSchema, dataPartSchemas, state, onError, onToolCall, onFinish, onData, sendAutomaticallyWhen }) {
		this.activeResponse = void 0;
		this.activeResumeRequest = void 0;
		this.resumableStreamState = void 0;
		this.jobExecutor = new SerialJobExecutor();
		this.activeStopCount = 0;
		this.stopGeneration = 0;
		/**
		* Appends or replaces a user message to the chat list. This triggers the API call to fetch
		* the assistant's response.
		*
		* If a messageId is provided, the message will be replaced.
		*/
		this.sendMessage = async (message, options) => {
			var _a16, _b, _c, _d;
			if (message == null) {
				await this.makeRequest({
					trigger: "submit-message",
					messageId: (_a16 = this.lastMessage) == null ? void 0 : _a16.id,
					...options
				});
				return;
			}
			let uiMessage;
			if ("text" in message || "files" in message) uiMessage = { parts: [...Array.isArray(message.files) ? message.files : await convertFileListToFileUIParts(message.files), ..."text" in message && message.text != null ? [{
				type: "text",
				text: message.text
			}] : []] };
			else uiMessage = message;
			if (message.messageId != null) {
				const messageIndex = this.state.messages.findIndex((m) => m.id === message.messageId);
				if (messageIndex === -1) throw new Error(`message with id ${message.messageId} not found`);
				if (this.state.messages[messageIndex].role !== "user") throw new Error(`message with id ${message.messageId} is not a user message`);
				this.state.messages = this.state.messages.slice(0, messageIndex + 1);
				this.state.replaceMessage(messageIndex, {
					...uiMessage,
					id: message.messageId,
					role: (_b = uiMessage.role) != null ? _b : "user",
					metadata: message.metadata
				});
			} else this.state.pushMessage({
				...uiMessage,
				id: (_c = uiMessage.id) != null ? _c : this.generateId(),
				role: (_d = uiMessage.role) != null ? _d : "user",
				metadata: message.metadata
			});
			await this.makeRequest({
				trigger: "submit-message",
				messageId: message.messageId,
				...options
			});
		};
		/**
		* Regenerate the assistant message with the provided message id.
		* If no message id is provided, the last assistant message will be regenerated.
		*/
		this.regenerate = async ({ messageId, ...options } = {}) => {
			const messageIndex = messageId == null ? this.state.messages.length - 1 : this.state.messages.findIndex((message) => message.id === messageId);
			if (messageIndex === -1) throw new Error(`message ${messageId} not found`);
			this.state.messages = this.state.messages.slice(0, this.messages[messageIndex].role === "assistant" ? messageIndex : messageIndex + 1);
			await this.makeRequest({
				trigger: "regenerate-message",
				messageId,
				...options
			});
		};
		/**
		* Attempt to resume an ongoing streaming response.
		*/
		this.resumeStream = async (options = {}) => {
			await this.makeRequest({
				trigger: "resume-stream",
				...options
			});
		};
		/**
		* Resume the stream if the latest response ended with a resumable network
		* disconnect. If a response is still active, wait for it to settle first so
		* disconnects reported shortly after the caller's trigger are handled.
		*
		* @internal
		*/
		this["~resumeStreamIfDisconnected"] = async ({ shouldResume = () => true } = {}) => {
			const activeResponse = this.activeResponse;
			if (this.resumableStreamState == null && activeResponse != null) {
				await activeResponse.completionPromise;
				if (this.resumableStreamState !== activeResponse.state) return;
			}
			if (this.resumableStreamState != null && shouldResume()) await this.resumeStream();
		};
		/**
		* Clear the error state and set the status to ready if the chat is in an error state.
		*/
		this.clearError = () => {
			if (this.status === "error") {
				this.state.error = void 0;
				this.setStatus({ status: "ready" });
			}
		};
		this.addToolOutput = async ({ state = "output-available", tool: tool2, toolCallId, output, errorText }) => this.jobExecutor.run(async () => {
			const messages = this.state.messages;
			const messageIndex = messages.findIndex((message) => message.parts.some((part) => isToolOrDynamicToolUIPart(part) && part.toolCallId === toolCallId));
			if (messageIndex !== -1) {
				const message = messages[messageIndex];
				this.state.replaceMessage(messageIndex, {
					...message,
					parts: message.parts.map((part) => isToolOrDynamicToolUIPart(part) && part.toolCallId === toolCallId ? {
						...part,
						state,
						output,
						errorText
					} : part)
				});
			}
			if (this.activeResponse) this.activeResponse.state.message.parts = this.activeResponse.state.message.parts.map((part) => isToolOrDynamicToolUIPart(part) && part.toolCallId === toolCallId ? {
				...part,
				state,
				output,
				errorText
			} : part);
			if (messageIndex !== -1 && this.status !== "streaming" && this.status !== "submitted" && this.sendAutomaticallyWhen) {
				const shouldSend = await this.shouldSendAutomatically();
				if (shouldSend) this.runAutomaticRequest(() => this.makeRequest({
					trigger: "submit-message",
					messageId: messages[messageIndex].id
				}), shouldSend);
			}
		});
		/** @deprecated Use addToolOutput */
		this.addToolResult = this.addToolOutput;
		/**
		* Abort the current request, keep the generated tokens if any, and wait for
		* the request pipeline to finish.
		*/
		this.stop = async () => {
			this.activeStopCount++;
			this.stopGeneration++;
			try {
				const activeResumeRequest = this.activeResumeRequest;
				const activeResponse = this.activeResponse;
				activeResumeRequest?.abortController.abort();
				activeResponse?.abortController.abort();
				await Promise.all([activeResumeRequest == null ? void 0 : activeResumeRequest.completionPromise, activeResponse == null ? void 0 : activeResponse.completionPromise]);
				await this.jobExecutor.waitForIdle();
			} finally {
				this.activeStopCount--;
			}
		};
		this.id = id;
		this.transport = transport;
		this.generateId = generateId3;
		this.messageMetadataSchema = messageMetadataSchema;
		this.dataPartSchemas = dataPartSchemas;
		this.state = state;
		this.onError = onError;
		this.onToolCall = onToolCall;
		this.onFinish = onFinish;
		this.onData = onData;
		this.sendAutomaticallyWhen = sendAutomaticallyWhen;
	}
	/**
	* Hook status:
	*
	* - `submitted`: The message has been sent to the API and we're awaiting the start of the response stream.
	* - `streaming`: The response is actively streaming in from the API, receiving chunks of data.
	* - `ready`: The full response has been received and processed; a new user message can be submitted.
	* - `error`: An error occurred during the API request, preventing successful completion.
	*/
	get status() {
		return this.state.status;
	}
	setStatus({ status, error }) {
		if (this.status === status) return;
		this.state.status = status;
		this.state.error = error;
	}
	get error() {
		return this.state.error;
	}
	get messages() {
		return this.state.messages;
	}
	get lastMessage() {
		return this.state.messages[this.state.messages.length - 1];
	}
	set messages(messages) {
		this.state.messages = messages;
	}
	async shouldSendAutomatically() {
		if (!this.sendAutomaticallyWhen) return false;
		const result = this.sendAutomaticallyWhen({ messages: this.state.messages });
		if (result && typeof result === "object" && "then" in result) return await result;
		return result;
	}
	async runAutomaticRequest(request, shouldSend) {
		const stopGeneration = this.stopGeneration;
		const startedWhileStopping = this.activeStopCount > 0;
		if (!(shouldSend != null ? shouldSend : await this.shouldSendAutomatically())) return;
		if (startedWhileStopping || stopGeneration !== this.stopGeneration || this.activeStopCount > 0) return;
		await request();
	}
	async makeRequest(options) {
		const completion = createResolvablePromise();
		try {
			await this.makeRequestImpl({
				...options,
				completionPromise: completion.promise
			});
		} finally {
			completion.resolve();
		}
	}
	async makeRequestImpl({ trigger, metadata, headers, body, messageId, completionPromise }) {
		var _a16, _b;
		if (trigger !== "resume-stream") this.resumableStreamState = void 0;
		const abortController = new AbortController();
		const activeResumeRequest = trigger === "resume-stream" ? {
			abortController,
			completionPromise
		} : void 0;
		if (activeResumeRequest) {
			(_a16 = this.activeResumeRequest) == null || _a16.abortController.abort();
			this.activeResumeRequest = activeResumeRequest;
		}
		const isCurrentRequest = () => activeResumeRequest == null || this.activeResumeRequest === activeResumeRequest;
		const clearActiveResumeRequest = () => {
			if (this.activeResumeRequest === activeResumeRequest) this.activeResumeRequest = void 0;
		};
		this.setStatus({
			status: "submitted",
			error: void 0
		});
		const lastMessage = this.lastMessage;
		const responseMessageIndex = trigger === "submit-message" && messageId != null ? this.state.messages.findIndex((message) => message.id === messageId) : this.state.messages.length - 1;
		const responseMessage = responseMessageIndex === -1 ? lastMessage : this.state.messages[responseMessageIndex];
		const originalResponseMessageId = responseMessage == null ? void 0 : responseMessage.id;
		const resumableResponseMessage = trigger === "resume-stream" && (lastMessage == null ? void 0 : lastMessage.role) === "assistant" && lastMessage.parts.some((part) => isToolOrDynamicToolUIPart(part) && part.state === "input-streaming") ? this.state.snapshot(lastMessage) : void 0;
		const usesEarlierAssistantMessage = responseMessageIndex !== -1 && responseMessageIndex < this.state.messages.length - 1 && (responseMessage == null ? void 0 : responseMessage.role) === "assistant";
		let isAbort = false;
		let isDisconnect = false;
		let isError = false;
		let activeResponse;
		try {
			const response = {
				state: trigger === "resume-stream" && this.resumableStreamState != null ? this.resumableStreamState : createStreamingUIMessageState({
					lastMessage: trigger === "resume-stream" ? resumableResponseMessage : this.state.snapshot(responseMessage),
					messageId: this.generateId()
				}),
				abortController,
				completionPromise
			};
			activeResponse = response;
			response.abortController.signal.addEventListener("abort", () => {
				isAbort = true;
			});
			this.activeResponse = response;
			let stream;
			if (trigger === "resume-stream") {
				const reconnect = await this.transport.reconnectToStream({
					chatId: this.id,
					abortSignal: abortController.signal,
					metadata,
					headers,
					body
				});
				if (abortController.signal.aborted || !isCurrentRequest()) {
					await (reconnect == null ? void 0 : reconnect.cancel().catch(() => {}));
					if (isCurrentRequest()) {
						this.setStatus({ status: "ready" });
						this.resumableStreamState = void 0;
					}
					return;
				}
				if (reconnect == null) {
					if (isCurrentRequest()) {
						this.setStatus({ status: "ready" });
						this.resumableStreamState = void 0;
					}
					return;
				}
				stream = reconnect;
			} else stream = await this.transport.sendMessages({
				chatId: this.id,
				messages: this.state.messages,
				abortSignal: response.abortController.signal,
				metadata,
				headers,
				body,
				trigger,
				messageId
			});
			const runUpdateMessageJob = (job) => this.jobExecutor.run(() => {
				if (response.abortController.signal.aborted) return Promise.resolve();
				return job({
					state: response.state,
					write: ({ updateStatus = true } = {}) => {
						if (response.abortController.signal.aborted) return;
						if (updateStatus) this.setStatus({ status: "streaming" });
						const existingMessageIndex = this.state.messages.findLastIndex((message) => message.id === response.state.message.id);
						if (existingMessageIndex !== -1) this.state.replaceMessage(existingMessageIndex, response.state.message);
						else if (usesEarlierAssistantMessage) {
							const originalMessageIndex = this.state.messages.findLastIndex((message) => message.id === originalResponseMessageId);
							if (originalMessageIndex !== -1) this.state.replaceMessage(originalMessageIndex, response.state.message);
							else this.state.pushMessage(response.state.message);
						} else this.state.pushMessage(response.state.message);
					}
				});
			});
			await consumeStream({
				stream: processUIMessageStream({
					stream,
					onToolCall: this.onToolCall,
					onData: this.onData,
					messageMetadataSchema: this.messageMetadataSchema,
					dataPartSchemas: this.dataPartSchemas,
					runUpdateMessageJob,
					onError: (error) => {
						throw error;
					}
				}),
				abortSignal: response.abortController.signal,
				onError: (error) => {
					throw error;
				}
			});
			if (isAbort) {
				if (isCurrentRequest()) {
					this.setStatus({ status: "ready" });
					if (this.resumableStreamState === response.state) this.resumableStreamState = void 0;
				}
				return null;
			}
			if (isCurrentRequest()) {
				this.setStatus({ status: "ready" });
				if (this.resumableStreamState === response.state) this.resumableStreamState = void 0;
			}
		} catch (err) {
			if (isAbort || err.name === "AbortError") {
				isAbort = true;
				if (isCurrentRequest()) {
					this.setStatus({ status: "ready" });
					if (this.resumableStreamState === (activeResponse == null ? void 0 : activeResponse.state)) this.resumableStreamState = void 0;
				}
				return null;
			}
			if (!isCurrentRequest()) return null;
			isError = true;
			if (err instanceof TypeError && (err.message.toLowerCase().includes("fetch") || err.message.toLowerCase().includes("network"))) isDisconnect = true;
			if (isDisconnect) this.resumableStreamState = activeResponse == null ? void 0 : activeResponse.state;
			else if (this.resumableStreamState === (activeResponse == null ? void 0 : activeResponse.state)) this.resumableStreamState = void 0;
			if (this.onError && err instanceof Error) this.onError(err);
			this.setStatus({
				status: "error",
				error: err
			});
		} finally {
			try {
				if (activeResponse) (_b = this.onFinish) == null || _b.call(this, {
					message: activeResponse.state.message,
					messages: this.state.messages,
					isAbort,
					isDisconnect,
					isError,
					finishReason: activeResponse.state.finishReason
				});
			} finally {
				if (this.activeResponse === activeResponse) this.activeResponse = void 0;
				clearActiveResumeRequest();
			}
		}
		if (!isAbort && !isError) await this.runAutomaticRequest(() => {
			var _a17;
			return this.makeRequest({
				trigger: "submit-message",
				messageId: (_a17 = this.lastMessage) == null ? void 0 : _a17.id,
				metadata,
				headers,
				body
			});
		});
	}
};
function lastAssistantMessageIsCompleteWithToolCalls({ messages }) {
	const message = messages[messages.length - 1];
	if (!message) return false;
	if (message.role !== "assistant") return false;
	const lastStepStartIndex = message.parts.reduce((lastIndex, part, index) => {
		return part.type === "step-start" ? index : lastIndex;
	}, -1);
	const lastStepParts = message.parts.slice(lastStepStartIndex + 1);
	const lastStepToolInvocations = lastStepParts.filter(isToolOrDynamicToolUIPart).filter((part) => !part.providerExecuted);
	const lastToolInvocationIndex = lastStepParts.reduce((lastIndex, part, index) => isToolOrDynamicToolUIPart(part) && !part.providerExecuted ? index : lastIndex, -1);
	return lastStepToolInvocations.length > 0 && !lastStepParts.slice(lastToolInvocationIndex + 1).some((part) => part.type === "text" && part.state !== "done") && lastStepToolInvocations.every((part) => part.state === "output-available" || part.state === "output-error");
}
function transformTextToUiMessageStream({ stream }) {
	return stream.pipeThrough(new TransformStream({
		start(controller) {
			controller.enqueue({ type: "start" });
			controller.enqueue({ type: "start-step" });
			controller.enqueue({
				type: "text-start",
				id: "text-1"
			});
		},
		async transform(part, controller) {
			controller.enqueue({
				type: "text-delta",
				id: "text-1",
				delta: part
			});
		},
		async flush(controller) {
			controller.enqueue({
				type: "text-end",
				id: "text-1"
			});
			controller.enqueue({ type: "finish-step" });
			controller.enqueue({ type: "finish" });
		}
	}));
}
var TextStreamChatTransport = class extends HttpChatTransport {
	constructor(options = {}) {
		super(options);
	}
	processResponseStream(stream) {
		return transformTextToUiMessageStream({ stream: stream.pipeThrough(new TextDecoderStream()) });
	}
};
function isEmptyObject(value) {
	return value != null && typeof value === "object" && !Array.isArray(value) && Object.keys(value).length === 0;
}
function asDynamicToolPart(toolPart) {
	const common = {
		type: "dynamic-tool",
		toolName: toolPart.type.slice(5),
		toolCallId: toolPart.toolCallId,
		...toolPart.providerExecuted === void 0 ? {} : { providerExecuted: toolPart.providerExecuted },
		...toolPart.callProviderMetadata === void 0 ? {} : { callProviderMetadata: toolPart.callProviderMetadata }
	};
	if (toolPart.state === "output-available") return markToolPartAsUnavailable({
		...common,
		state: "output-available",
		input: toolPart.input,
		output: toolPart.output,
		...toolPart.preliminary === void 0 ? {} : { preliminary: toolPart.preliminary }
	});
	return markToolPartAsUnavailable({
		...common,
		state: "output-error",
		input: toolPart.input,
		errorText: toolPart.errorText
	});
}
var uiMessagesSchema = lazyValidator(() => zodSchema(z.array(z.object({
	id: z.string(),
	role: z.enum([
		"system",
		"user",
		"assistant"
	]),
	metadata: z.unknown().optional(),
	parts: z.array(z.union([
		z.object({
			type: z.literal("text"),
			text: z.string(),
			state: z.enum(["streaming", "done"]).optional(),
			providerMetadata: providerMetadataSchema.optional()
		}),
		z.object({
			type: z.literal("reasoning"),
			id: z.string().optional(),
			text: z.string(),
			state: z.enum(["streaming", "done"]).optional(),
			providerMetadata: providerMetadataSchema.optional()
		}),
		z.object({
			type: z.literal("source-url"),
			sourceId: z.string(),
			url: z.string(),
			title: z.string().optional(),
			providerMetadata: providerMetadataSchema.optional()
		}),
		z.object({
			type: z.literal("source-document"),
			sourceId: z.string(),
			mediaType: z.string(),
			title: z.string(),
			filename: z.string().optional(),
			providerMetadata: providerMetadataSchema.optional()
		}),
		z.object({
			type: z.literal("file"),
			mediaType: z.string(),
			filename: z.string().optional(),
			url: z.string(),
			providerMetadata: providerMetadataSchema.optional()
		}),
		z.object({ type: z.literal("step-start") }),
		z.object({
			type: z.string().startsWith("data-"),
			id: z.string().optional(),
			data: z.unknown()
		}),
		z.object({
			type: z.literal("dynamic-tool"),
			dynamic: z.literal(false).optional(),
			toolName: z.string(),
			toolCallId: z.string(),
			state: z.literal("input-streaming"),
			input: z.unknown().optional(),
			rawInput: z.string().optional(),
			providerExecuted: z.boolean().optional(),
			output: z.never().optional(),
			errorText: z.never().optional()
		}),
		z.object({
			type: z.literal("dynamic-tool"),
			dynamic: z.literal(false).optional(),
			toolName: z.string(),
			toolCallId: z.string(),
			state: z.literal("input-available"),
			input: z.unknown(),
			providerExecuted: z.boolean().optional(),
			output: z.never().optional(),
			errorText: z.never().optional(),
			callProviderMetadata: providerMetadataSchema.optional()
		}),
		z.object({
			type: z.literal("dynamic-tool"),
			dynamic: z.literal(false).optional(),
			toolName: z.string(),
			toolCallId: z.string(),
			state: z.literal("output-available"),
			input: z.unknown(),
			providerExecuted: z.boolean().optional(),
			output: z.unknown(),
			errorText: z.never().optional(),
			callProviderMetadata: providerMetadataSchema.optional(),
			preliminary: z.boolean().optional()
		}),
		z.object({
			type: z.literal("dynamic-tool"),
			dynamic: z.literal(false).optional(),
			toolName: z.string(),
			toolCallId: z.string(),
			state: z.literal("output-error"),
			input: z.unknown().optional(),
			rawInput: z.unknown().optional(),
			providerExecuted: z.boolean().optional(),
			output: z.never().optional(),
			errorText: z.string(),
			callProviderMetadata: providerMetadataSchema.optional()
		}),
		z.object({
			type: z.string().startsWith("tool-"),
			toolCallId: z.string(),
			state: z.literal("input-streaming"),
			providerExecuted: z.boolean().optional(),
			input: z.unknown().optional(),
			rawInput: z.string().optional(),
			output: z.never().optional(),
			errorText: z.never().optional(),
			approval: z.never().optional()
		}),
		z.object({
			type: z.string().startsWith("tool-"),
			toolCallId: z.string(),
			state: z.literal("input-available"),
			providerExecuted: z.boolean().optional(),
			input: z.unknown(),
			output: z.never().optional(),
			errorText: z.never().optional(),
			callProviderMetadata: providerMetadataSchema.optional(),
			approval: z.never().optional()
		}),
		z.object({
			type: z.string().startsWith("tool-"),
			toolCallId: z.string(),
			state: z.literal("approval-requested"),
			input: z.unknown(),
			providerExecuted: z.boolean().optional(),
			output: z.never().optional(),
			errorText: z.never().optional(),
			callProviderMetadata: providerMetadataSchema.optional(),
			approval: z.object({
				id: z.string(),
				approved: z.never().optional(),
				reason: z.never().optional()
			})
		}),
		z.object({
			type: z.string().startsWith("tool-"),
			toolCallId: z.string(),
			state: z.literal("approval-responded"),
			input: z.unknown(),
			providerExecuted: z.boolean().optional(),
			output: z.never().optional(),
			errorText: z.never().optional(),
			callProviderMetadata: providerMetadataSchema.optional(),
			approval: z.object({
				id: z.string(),
				approved: z.boolean(),
				reason: z.string().optional()
			})
		}),
		z.object({
			type: z.string().startsWith("tool-"),
			toolCallId: z.string(),
			state: z.literal("output-available"),
			providerExecuted: z.boolean().optional(),
			input: z.unknown(),
			output: z.unknown(),
			errorText: z.never().optional(),
			callProviderMetadata: providerMetadataSchema.optional(),
			preliminary: z.boolean().optional(),
			approval: z.object({
				id: z.string(),
				approved: z.literal(true),
				reason: z.string().optional()
			}).optional()
		}),
		z.object({
			type: z.string().startsWith("tool-"),
			toolCallId: z.string(),
			state: z.literal("output-error"),
			providerExecuted: z.boolean().optional(),
			input: z.unknown().optional(),
			rawInput: z.unknown().optional(),
			output: z.never().optional(),
			errorText: z.string(),
			callProviderMetadata: providerMetadataSchema.optional(),
			approval: z.object({
				id: z.string(),
				approved: z.literal(true),
				reason: z.string().optional()
			}).optional()
		}),
		z.object({
			type: z.string().startsWith("tool-"),
			toolCallId: z.string(),
			state: z.literal("output-denied"),
			providerExecuted: z.boolean().optional(),
			input: z.unknown(),
			output: z.never().optional(),
			errorText: z.never().optional(),
			callProviderMetadata: providerMetadataSchema.optional(),
			approval: z.object({
				id: z.string(),
				approved: z.literal(false),
				reason: z.string().optional()
			})
		})
	]))
}).superRefine((message, context) => {
	if (message.role !== "assistant" && message.parts.length === 0) context.addIssue({
		origin: "array",
		code: "too_small",
		minimum: 1,
		inclusive: true,
		input: message.parts,
		path: ["parts"],
		message: "Message must contain at least one part"
	});
})).nonempty("Messages array must not be empty")));
async function safeValidateUIMessages({ messages, metadataSchema, dataSchemas, tools }) {
	try {
		if (messages == null) return {
			success: false,
			error: new InvalidArgumentError({
				parameter: "messages",
				value: messages,
				message: "messages parameter must be provided"
			})
		};
		const validatedMessages = await validateTypes({
			value: messages,
			schema: uiMessagesSchema
		});
		for (const message of validatedMessages) for (const part of message.parts) {
			if (part.type !== "dynamic-tool" && !part.type.startsWith("tool-")) continue;
			const toolPart = part;
			if (toolPart.state === "output-error" && !("input" in toolPart)) toolPart.input = void 0;
		}
		if (metadataSchema) for (const message of validatedMessages) message.metadata = await validateTypes({
			value: message.metadata,
			schema: metadataSchema
		});
		if (dataSchemas) for (const message of validatedMessages) {
			const dataParts = message.parts.filter((part) => part.type.startsWith("data-"));
			for (const dataPart of dataParts) {
				const dataName = dataPart.type.slice(5);
				const dataSchema = dataSchemas[dataName];
				if (!dataSchema) return {
					success: false,
					error: new TypeValidationError({
						value: dataPart.data,
						cause: `No data schema found for data part ${dataName}`
					})
				};
				dataPart.data = await validateTypes({
					value: dataPart.data,
					schema: dataSchema
				});
			}
		}
		if (tools) for (const message of validatedMessages) for (const [partIdx, part] of message.parts.entries()) {
			if (!part.type.startsWith("tool-")) continue;
			const toolPart = part;
			const toolName = toolPart.type.slice(5);
			const tool2 = getOwn(tools, toolName);
			if (!tool2 && (toolPart.state === "output-available" || toolPart.state === "output-error")) {
				message.parts[partIdx] = asDynamicToolPart(toolPart);
				continue;
			}
			if (!tool2) return {
				success: false,
				error: new TypeValidationError({
					value: toolPart.input,
					cause: `No tool schema found for tool part ${toolName}`
				})
			};
			let dynamicToolPart;
			if (toolPart.state === "output-error") {
				if (toolPart.input !== void 0) {
					if (!(await safeValidateTypes({
						value: toolPart.input,
						schema: tool2.inputSchema
					})).success) dynamicToolPart = asDynamicToolPart(toolPart);
				}
			} else if (toolPart.state === "output-available") {
				const result = await safeValidateTypes({
					value: toolPart.input,
					schema: tool2.inputSchema
				});
				if (!result.success) {
					if (isEmptyObject(toolPart.input)) dynamicToolPart = asDynamicToolPart(toolPart);
					else throw result.error;
				}
			} else if (toolPart.state === "input-available") await validateTypes({
				value: toolPart.input,
				schema: tool2.inputSchema
			});
			if (toolPart.state === "output-available" && tool2.outputSchema) await validateTypes({
				value: toolPart.output,
				schema: tool2.outputSchema
			});
			if (dynamicToolPart) message.parts[partIdx] = dynamicToolPart;
		}
		return {
			success: true,
			data: validatedMessages
		};
	} catch (error) {
		return {
			success: false,
			error
		};
	}
}
async function validateUIMessages(options) {
	const response = await safeValidateUIMessages(options);
	if (!response.success) throw response.error;
	return response.data;
}
function createUIMessageStream({ execute, onError = () => "An error occurred.", originalMessages, onFinish, generateId: generateId3 = generateId }) {
	let controller;
	const ongoingStreamPromises = [];
	let outcome = { status: "unknown" };
	const stream = new ReadableStream({ start(controllerArg) {
		controller = controllerArg;
	} });
	function safeEnqueue(data) {
		try {
			controller.enqueue(data);
		} catch (error) {}
	}
	function setOutcome(newOutcome) {
		if (outcome.status === "unknown" && newOutcome.status !== "unknown") outcome = newOutcome;
	}
	function failOutcome(error) {
		outcome = {
			status: "failed",
			error
		};
	}
	function safeError(error) {
		try {
			controller.error(error);
		} catch (e) {}
	}
	function handleError(error) {
		failOutcome(error);
		let errorText;
		try {
			errorText = onError(error);
		} catch (onErrorError) {
			failOutcome(onErrorError);
			safeError(onErrorError);
			return;
		}
		safeEnqueue({
			type: "error",
			errorText
		});
	}
	try {
		const result = execute({ writer: {
			write(part) {
				safeEnqueue(part);
			},
			merge(streamArg) {
				ongoingStreamPromises.push((async () => {
					const reader = streamArg.getReader();
					while (true) {
						const { done, value } = await reader.read();
						if (done) break;
						safeEnqueue(value);
					}
				})().catch((error) => {
					handleError(error);
				}));
			},
			setOutcome,
			onError
		} });
		if (result) ongoingStreamPromises.push(result.catch((error) => {
			handleError(error);
		}));
	} catch (error) {
		handleError(error);
	}
	(async () => {
		while (ongoingStreamPromises.length > 0) await ongoingStreamPromises.shift();
	})().finally(() => {
		try {
			controller.close();
		} catch (error) {}
	});
	return handleUIMessageStreamFinish({
		stream,
		messageId: generateId3(),
		originalMessages,
		onFinish,
		onError,
		getOutcome: () => outcome
	});
}
function createUIMessageSnapshot(message) {
	const textByPartIndex = /* @__PURE__ */ new Map();
	const messageWithoutText = {
		...message,
		parts: message.parts.map((part, index) => {
			if (part.type === "text" || part.type === "reasoning") {
				textByPartIndex.set(index, part.text);
				return {
					...part,
					text: ""
				};
			}
			return part;
		})
	};
	const snapshot = structuredClone(messageWithoutText);
	for (const [index, text2] of textByPartIndex) {
		const part = snapshot.parts[index];
		if (part.type === "text" || part.type === "reasoning") part.text = text2;
	}
	return snapshot;
}
function readUIMessageStream({ message, stream, onError, terminateOnError = false }) {
	var _a16;
	let controller;
	let hasErrored = false;
	let isCancelled = false;
	const abortController = new AbortController();
	const outputStream = new ReadableStream({
		start(controllerParam) {
			controller = controllerParam;
		},
		cancel() {
			isCancelled = true;
			abortController.abort();
		}
	});
	const state = createStreamingUIMessageState({
		messageId: (_a16 = message == null ? void 0 : message.id) != null ? _a16 : "",
		lastMessage: message
	});
	const handleError = (error) => {
		onError?.(error);
		if (!hasErrored && terminateOnError) {
			hasErrored = true;
			controller?.error(error);
		}
	};
	consumeStream({
		stream: processUIMessageStream({
			stream,
			resetStateOnMessageIdChange: true,
			runUpdateMessageJob(job) {
				return job({
					state,
					write: () => {
						if (!isCancelled) controller?.enqueue(createUIMessageSnapshot(state.message));
					}
				});
			},
			onError: handleError
		}),
		onError: handleError,
		abortSignal: abortController.signal
	}).finally(() => {
		if (!hasErrored && !isCancelled) controller?.close();
	});
	return createAsyncIterableStream(outputStream);
}
//#endregion
//#region src/index.ts
const generateText = (options) => generateText$1({
	...options,
	allowSystemInMessages: false
});
const streamText = (options) => streamText$1({
	...options,
	allowSystemInMessages: false
});
//#endregion
export { AISDKError, APICallError, AbstractChat, DefaultChatTransport, DownloadError, EmptyResponseBodyError, Agent as Experimental_Agent, HttpChatTransport, InvalidArgumentError, InvalidDataContentError, InvalidMessageRoleError, InvalidPromptError, InvalidResponseDataError, InvalidStreamPartError, InvalidToolInputError, JSONParseError, JsonToSseTransformStream, LoadAPIKeyError, LoadSettingError, MessageConversionError, NoContentGeneratedError, NoImageGeneratedError, NoObjectGeneratedError, NoOutputGeneratedError, NoOutputSpecifiedError, NoSpeechGeneratedError, NoSuchModelError, NoSuchProviderError, NoSuchToolError, output_exports as Output, RetryError, SerialJobExecutor, TextStreamChatTransport, TooManyEmbeddingValuesForCallError, ToolCallRepairError, TypeValidationError, UI_MESSAGE_STREAM_HEADERS, UnsupportedFunctionalityError, UnsupportedModelVersionError, asSchema, assistantModelMessageSchema, callCompletionApi, consumeStream, convertFileListToFileUIParts, convertToCoreMessages, convertToModelMessages, coreAssistantMessageSchema, coreMessageSchema, coreSystemMessageSchema, coreToolMessageSchema, coreUserMessageSchema, cosineSimilarity, createDownload, createGatewayProvider as createGateway, createIdGenerator, createProviderRegistry, createTextStreamResponse, createUIMessageStream, createUIMessageStreamResponse, customProvider, defaultSettingsMiddleware, dynamicTool, embed, embedMany, experimental_createProviderRegistry, experimental_customProvider, generateImage as experimental_generateImage, generateSpeech as experimental_generateSpeech, transcribe as experimental_transcribe, extractReasoningMiddleware, gateway, generateId, generateObject, generateText, getTextFromDataUrl, getToolName, getToolOrDynamicToolName, hasToolCall, isDataUIPart, isDeepEqualData, isDynamicToolUIPart, isFileUIPart, isReasoningUIPart, isTextUIPart, isToolOrDynamicToolUIPart, isToolUIPart, jsonSchema, lastAssistantMessageIsCompleteWithToolCalls, modelMessageSchema, parseJsonEventStream, parsePartialJson, pipeTextStreamToResponse, pipeUIMessageStreamToResponse, pruneMessages, readUIMessageStream, safeValidateUIMessages, simulateReadableStream, simulateStreamingMiddleware, smoothStream, stepCountIs, streamObject, streamText, systemModelMessageSchema, tool, toolModelMessageSchema, uiMessageChunkSchema, userModelMessageSchema, validateUIMessages, wrapLanguageModel, wrapProvider, zodSchema };

//# sourceMappingURL=index.js.map